import { useState, useEffect, useRef } from "react";
import { loginWithGoogle, logout, onAuthChange, loginWithEmail, registerWithEmail, resetPassword } from "./firebase";
import { BANNERS_DATA, BANNERS_PERIODO } from "./bannersData";
import ReporteCaptacion from "./ReporteCaptacion";
import ReporteComercializacion from "./ReporteComercializacion";
import ReporteConsumo from "./ReporteConsumo";
import ReporteVivienda from "./ReporteVivienda";
import GraficasView from "./GraficasView";
import { C, FONTS, CHART_COLORS, PLOTLY_BASE, HTML_EXPORT_CSS } from "./theme";

// ─── CONFIG ──────────────────────────────────────────────────────────────────
// Cambia esta URL a la de tu servicio en Cloud Run
const BACKEND_URL =
  process.env.REACT_APP_BACKEND_URL || "https://cnbv-agente-7bdezditva-uc.a.run.app";

// ─── PALETTE ─────────────────────────────────────────────────────────────────
// C, FONTS, CHART_COLORS, PLOTLY_BASE, HTML_EXPORT_CSS — importados de ./theme

// ─── AGENT PIPELINE ──────────────────────────────────────────────────────────
const STEPS = [
  { id: "orch", label: "Orquestador",   icon: "⬡" },
  { id: "clar", label: "Clarificador",  icon: "◈" },
  { id: "sql",  label: "Agente SQL",    icon: "◉" },
  { id: "anal", label: "Análisis Fin.", icon: "◆" },
  { id: "vis",  label: "Visualizador",  icon: "◎" },
];


// ─── CATÁLOGO CNBV — grupos e instituciones ───────────────────────────────────
const GRUPOS_CNBV = [
  { clave: 5,  nombre: "Total Banca Múltiple" },
  { clave: 59, nombre: "G-7" },
  { clave: 60, nombre: "Bancos Cambiarios" },
  { clave: 61, nombre: "Inversión y Servicios Financieros" },
  { clave: 62, nombre: "Comercial Mediano" },
  { clave: 63, nombre: "Comercial Pequeño" },
  { clave: 64, nombre: "Créditos a los Hogares" },
];

const INSTITUCIONES_CNBV = {
  5:  [{ clave: 5,     nombre: "5 Total Banca Múltiple" }],
  59: [
    { clave: 40002, nombre: "40002 Banamex" },
    { clave: 40012, nombre: "40012 BBVA México" },
    { clave: 40014, nombre: "40014 Santander" },
    { clave: 40021, nombre: "40021 HSBC" },
    { clave: 40036, nombre: "40036 Inbursa" },
    { clave: 40044, nombre: "40044 Scotiabank" },
    { clave: 40072, nombre: "40072 Banorte" },
  ],
  60: [
    { clave: 40112, nombre: "40112 Monex" },
    { clave: 40136, nombre: "40136 Intercam Banco" },
    { clave: 40143, nombre: "40143 CIBanco" },
    { clave: 40145, nombre: "40145 Banco Base" },
  ],
  61: [
    { clave: 40059, nombre: "40059 Invex" },
    { clave: 40062, nombre: "40062 Afirme" },
    { clave: 40103, nombre: "40103 American Express" },
    { clave: 40106, nombre: "40106 Bank of America" },
    { clave: 40108, nombre: "40108 MUFG Bank" },
    { clave: 40110, nombre: "40110 J.P. Morgan" },
    { clave: 40124, nombre: "40124 Citi México" },
    { clave: 40126, nombre: "40126 Credit Suisse" },
    { clave: 40129, nombre: "40129 Barclays" },
    { clave: 40139, nombre: "40139 BIAfirme" },
    { clave: 40148, nombre: "40148 Pagatodo" },
    { clave: 40160, nombre: "40160 Banco S3" },
    { clave: 40164, nombre: "40164 BNP Paribas México" },
  ],
  62: [
    { clave: 40030, nombre: "40030 Banco del Bajío" },
    { clave: 40042, nombre: "40042 Banca Mifel" },
    { clave: 40058, nombre: "40058 Banregio" },
    { clave: 40113, nombre: "40113 Ve por Más" },
    { clave: 40132, nombre: "40132 Multiva" },
    { clave: 40156, nombre: "40156 Sabadell" },
  ],
  63: [
    { clave: 40060, nombre: "40060 Bansí" },
    { clave: 40128, nombre: "40128 Kapital" },
    { clave: 40133, nombre: "40133 Actinver" },
    { clave: 40138, nombre: "40138 Ualá" },
    { clave: 40147, nombre: "40147 Bankaool" },
    { clave: 40150, nombre: "40150 Inmobiliario Mexicano" },
    { clave: 40151, nombre: "40151 Dondé Banco" },
    { clave: 40152, nombre: "40152 Bancrea" },
    { clave: 40154, nombre: "40154 Covalto" },
    { clave: 40155, nombre: "40155 ICBC" },
    { clave: 40157, nombre: "40157 Shinhan" },
    { clave: 40158, nombre: "40158 Mizuho Bank" },
    { clave: 40159, nombre: "40159 Bank of China" },
    { clave: 40162, nombre: "40162 KEB Hana México" },
  ],
  64: [
    { clave: 40127, nombre: "40127 Banco Azteca" },
    { clave: 40130, nombre: "40130 Compartamos" },
    { clave: 40137, nombre: "40137 Bancoppel" },
    { clave: 40140, nombre: "40140 Consubanco" },
    { clave: 40141, nombre: "40141 Volkswagen Bank" },
    { clave: 40149, nombre: "40149 Banfeliz (Antes Forjadores)" },
    { clave: 40165, nombre: "40165 Banco Bineo" },
    { clave: 40167, nombre: "40167 Hey Banco" },
    { clave: 40169, nombre: "40169 Openbank" },
    { clave: 40170, nombre: "40170 Revolut Bank" },
  ],
};
// Texto de ayuda de grupos GENERADO desde el catálogo de arriba (no escribir miembros
// a mano: se desalinea del backend). Fuente única: GRUPOS_CNBV / INSTITUCIONES_CNBV.
const _DESC_GRUPOS_CNBV = {
  59: "Los siete bancos más grandes del sistema",
  60: "Instituciones con mandatos especializados",
  61: "Instituciones con mandatos especializados",
  62: "Bancos de tamaño intermedio con enfoque empresarial",
  63: "Instituciones de menor tamaño o nicho específico",
  64: "Banca especializada en consumo y nómina",
};
const _nombreInstCNBV = (n) => String(n).replace(/^\d+\s+/, "").replace(/\s*\(Antes[^)]*\)\s*$/, "");
const TEXTO_GRUPOS_CNBV = GRUPOS_CNBV.filter(g => g.clave !== 5).map(g => {
  const miembros = (INSTITUCIONES_CNBV[g.clave] || []).map(i => _nombreInstCNBV(i.nombre));
  return `**${g.nombre}** — ${_DESC_GRUPOS_CNBV[g.clave] || ""} (${miembros.length}):\n${miembros.join(", ")}.`;
}).join("\n\n");
const LISTA_GRUPOS_CNBV = GRUPOS_CNBV.filter(g => g.clave !== 5).map(g => g.nombre).join(", ");

// ─── MOCK DATA (History & Prompts — sprint futuro) ───────────────────────────
// (historial ahora viene de BigQuery)
const PROMPTS = [
  // ── Balance ──────────────────────────────────────────────────────────────────
  { id: 1,  title: "Activo total por grupo bancario",
    text: "Muestra el activo total del sistema bancario desglosado por grupo (G-7, Crédito a los Hogares, Comercial Mediano, etc.) a julio 2026.",
    tag: "Balance" },
  { id: 2,  title: "Top 10 bancos por cartera de crédito",
    text: "Dame el top 10 de bancos por cartera de crédito total a julio 2026, ordenado de mayor a menor.",
    tag: "Balance" },
  { id: 3,  title: "Desglose de cartera por tipo",
    text: "Muestra el desglose de la cartera de crédito del sistema por tipo: comercial, consumo y vivienda a julio 2026.",
    tag: "Balance" },
  { id: 4,  title: "Activo de Banorte vs Santander: 2023–2025",
    text: "Muestra la evolución del activo total de Banorte y Santander de enero 2023 a julio 2026 en una gráfica de líneas con el eje X = periodo y el eje Y = activo total.",
    tag: "Balance" },
  { id: 5,  title: "Captación: depósitos a la vista vs a plazo del G-7",
    text: "Muestra el desglose de la captación tradicional entre depósitos de exigibilidad inmediata y depósitos a plazo para cada banco del G-7 a julio 2026.",
    tag: "Balance" },
  { id: 6,  title: "Cartera de consumo de Citibanamex por producto",
    text: "Muestra el saldo de la cartera de crédito de consumo de Citibanamex desglosada por producto: tarjeta de crédito, nómina y crédito personal a julio 2026.",
    tag: "Balance" },

  // ── Rentabilidad ─────────────────────────────────────────────────────────────
  { id: 7,  title: "ROA y ROE del G-7: 2024 vs 2025",
    text: "Compara el ROA y el ROE de los bancos del G-7 entre diciembre 2024 y julio 2026.",
    tag: "Rentabilidad" },
  { id: 8,  title: "Rentabilidad del sistema en 2025",
    text: "¿Qué tan rentable fue 2025? Muestra la utilidad neta del sistema bancario y los principales drivers: margen financiero, comisiones y estimaciones preventivas.",
    tag: "Rentabilidad" },
  { id: 9,  title: "Resultado neto histórico: Banco Inmobiliario",
    text: "De la información del Estado de Resultados, toma el Resultado neto (flujo acumulado 12 meses) para Banco Inmobiliario Mexicano y muestra su comportamiento mensual desde enero 2024 al último periodo disponible.",
    tag: "Rentabilidad" },
  { id: 10, title: "Margen financiero ajustado del sistema en 2025",
    text: "Muestra la evolución mensual del margen financiero ajustado por riesgos crediticios del total del sistema bancario durante todo 2025.",
    tag: "Rentabilidad" },
  { id: 11, title: "Ingresos vs gastos por intereses: Scotiabank",
    text: "Compara los ingresos por intereses contra los gastos por intereses para Scotiabank desde enero 2024 al último periodo disponible. Genera una gráfica de líneas con una serie por cada concepto.",
    tag: "Rentabilidad" },
  { id: 12, title: "Resultado de operación: Comercial Mediano",
    text: "Muestra el resultado de la operación para cada banco del grupo Comercial Mediano en julio 2026, ordenado de mayor a menor.",
    tag: "Rentabilidad" },

  // ── Riesgo y Morosidad ───────────────────────────────────────────────────────
  { id: 13, title: "Evolución del IMOR por tipo de cartera en 2025",
    text: "Muestra la evolución mensual del IMOR para cartera comercial, consumo y vivienda del total del sistema bancario a lo largo de 2025. Genera una gráfica de líneas con una serie por cada tipo de cartera.",
    tag: "Riesgo" },
  { id: 14, title: "IMOR vs IMORA: grupo Crédito a los Hogares",
    text: "Compara el IMORA e IMOR en un diagrama de dispersión para julio 2026 para los siguientes bancos: Banco Azteca, Banco Bineo, Bancoppel, Banfeliz (Antes Forjadores), Compartamos, Consubanco, Hey Banco, Openbank, Revolut Bank y Volkswagen Bank.",
    tag: "Riesgo" },
  { id: 15, title: "Bancos con deterioro temprano en consumo",
    text: "Identifica los bancos donde el IMOR de la cartera de consumo creció más que el IMOR total durante 2025, como señal de deterioro temprano en crédito al consumo.",
    tag: "Riesgo" },
  { id: 16, title: "IMOR de tarjeta de crédito: HSBC, Santander y Citibanamex",
    text: "Muestra la evolución mensual del IMOR de tarjeta de crédito para HSBC, Santander y Citibanamex a lo largo de 2025. Genera una gráfica de líneas con una serie por banco.",
    tag: "Riesgo" },
  { id: 17, title: "TDA del sistema: serie histórica 2023–2025",
    text: "Muestra la Tasa de Deterioro Ajustada (TDA) total del sistema bancario con datos mensuales de enero 2023 a julio 2026.",
    tag: "Riesgo" },
  { id: 18, title: "ICOR de consumo: Bancoppel vs Consubanco",
    text: "Compara el Índice de Cobertura (ICOR) de la cartera de consumo entre Bancoppel y Consubanco a julio 2026.",
    tag: "Riesgo" },

  // ── Capitalización ───────────────────────────────────────────────────────────
  { id: 19, title: "ICAP del sistema y bancos en mínimos",
    text: "Muestra el ICAP de cada institución del sistema bancario a julio 2026 e identifica cuáles están por debajo del mínimo regulatorio del 10.5%.",
    tag: "Capitalización" },
  { id: 20, title: "Requerimientos de capital por tipo de riesgo: Multiva",
    text: "Utiliza la información de Capitalización para mostrar los requerimientos de capital por riesgo de crédito, riesgo de mercado y riesgo operacional para Multiva desde enero 2024 al último periodo disponible. Genera una gráfica de líneas con el eje X = periodo, eje Y = monto del requerimiento y una línea por tipo de riesgo.",
    tag: "Capitalización" },
  { id: 21, title: "Variación del ICAP y ROE del G-7",
    text: "Compara la variación del ICAP y el ROE de cada banco del G-7 entre diciembre 2024 y julio 2026.",
    tag: "Capitalización" },
  { id: 22, title: "Capital Neto Tier 1 y Tier 2 del G-7",
    text: "Muestra el Capital Neto desglosado en Capital Básico (Tier 1) y Capital Complementario (Tier 2) para cada banco del G-7 a julio 2026.",
    tag: "Capitalización" },
  { id: 23, title: "APR por tipo de riesgo: BBVA",
    text: "Muestra los Activos Ponderados por Riesgo (APR) de BBVA desglosados en riesgo de crédito, riesgo de mercado y riesgo operacional a julio 2026.",
    tag: "Capitalización" },
  { id: 24, title: "Sobrante de capital: Comercial Mediano",
    text: "Muestra el sobrante o faltante de capital regulatorio para cada banco del grupo Comercial Mediano a julio 2026, ordenado de mayor a menor sobrante.",
    tag: "Capitalización" },

  // ── Reservas y Calificación ──────────────────────────────────────────────────
  { id: 25, title: "Reservas por segmento de cartera: Multiva",
    text: "Muestra las estimaciones preventivas (EPRC) por segmento de cartera para Multiva en julio 2026: comercial, consumo y vivienda.",
    tag: "Reservas" },
  { id: 26, title: "Cobertura de cartera vencida al cierre 2025",
    text: "Muestra el índice de cobertura (estimaciones preventivas / cartera vencida) para el total del sistema bancario al cierre de 2025.",
    tag: "Reservas" },
  { id: 27, title: "Distribución de riesgo en consumo por producto",
    text: "Muestra la distribución de la cartera de consumo por producto — tarjeta de crédito, nómina y crédito personal — para el total del sistema a julio 2026.",
    tag: "Reservas" },
  { id: 28, title: "EPRC por etapa IFRS9: Banco Azteca consumo",
    text: "Muestra las estimaciones preventivas (EPRC) por etapa IFRS9 — etapa 1, etapa 2 y etapa 3 — para la cartera de consumo de Banco Azteca a julio 2026.",
    tag: "Reservas" },
  { id: 29, title: "Reservas de tarjeta: grupo Crédito a los Hogares",
    text: "Muestra las estimaciones preventivas de tarjeta de crédito para cada banco del grupo Crédito a los Hogares a julio 2026, ordenadas de mayor a menor.",
    tag: "Reservas" },
  { id: 30, title: "Índice de cobertura de vivienda en 2025",
    text: "Muestra la evolución mensual del índice de cobertura (EPRC / cartera vencida) para la cartera de vivienda del total del sistema bancario durante 2025.",
    tag: "Reservas" },

  // ── Directorio ───────────────────────────────────────────────────────────────
  { id: 31, title: "Bancos del grupo Comercial Pequeño",
    text: "Enlista los bancos que pertenecen al Grupo Comercial Pequeño.",
    tag: "Directorio" },
  { id: 32, title: "Instituciones del sistema a julio 2026",
    text: "¿Cuántos bancos hay en el sistema bancario al cierre de julio 2026? Genera una tabla con el nombre de cada institución y el grupo al que pertenece.",
    tag: "Directorio" },
  { id: 33, title: "¿Qué bancos forman el G-7?",
    text: "¿Qué bancos conforman el grupo G-7 y cuál es su participación en el activo total del sistema a julio 2026?",
    tag: "Directorio" },
  { id: 34, title: "Bancos del grupo Inversión y Servicios Financieros",
    text: "Enlista los bancos que conforman el grupo Inversión y Servicios Financieros.",
    tag: "Directorio" },
  { id: 35, title: "Bancos Cambiarios: listado con activo total",
    text: "Lista los bancos que pertenecen al grupo Bancos Cambiarios junto con su activo total a julio 2026.",
    tag: "Directorio" },
  { id: 36, title: "mayor cartera comercial en Comercial Mediano",
    text: "¿Qué bancos del grupo Comercial Mediano tienen la mayor cartera de crédito comercial a julio 2026? Muestra el ranking completo.",
    tag: "Directorio" },

  // ── Quitas ───────────────────────────────────────────────────────────────────
  { id: 37, title: "Quitas de vivienda vs tarjeta de crédito en 2025",
    text: "Compara las quitas de vivienda contra las quitas de tarjeta de crédito para el total del sistema bancario a lo largo de 2025. Genera una gráfica de líneas con una serie por cada tipo.",
    tag: "Quitas" },
  { id: 38, title: "Evolución de quitas de consumo en 2025",
    text: "Muestra cómo evolucionaron las quitas de consumo del sistema bancario mes a mes durante 2025.",
    tag: "Quitas" },
  { id: 39, title: "Quitas y Castigos Total de Bancoppel: histórico 2020–2026",
    text: "Muestra el comportamiento del indicador Quitas y Castigos Total (Flujo 12 meses) para Bancoppel desde enero 2020 a la última fecha disponible.",
    tag: "Quitas" },
  { id: 40, title: "Quitas y Castigos + Cartera Vencida: Bancoppel",
    text: "Muestra el comportamiento del indicador Quitas y Castigos Total (Flujo 12 meses) y Cartera Vencida para Bancoppel desde enero 2020 a la última fecha disponible. Genera una gráfica de doble eje con ambas series.",
    tag: "Quitas" },
  { id: 41, title: "Quitas de tarjeta de crédito del sistema en 2024",
    text: "¿Cuáles fueron las quitas de tarjeta de crédito del sistema bancario a lo largo de 2024? Muestra la serie mensual.",
    tag: "Quitas" },
  { id: 42, title: "Comparativo de quitas de vivienda 2023 vs 2024 vs 2025",
    text: "Compara las quitas de vivienda del sistema bancario para los años 2023, 2024 y 2025. Genera una gráfica de líneas con una serie por año.",
    tag: "Quitas" },
  { id: 43, title: "Quitas y castigos de Openbank desde 2025",
    text: "Muestra el comportamiento de las quitas y castigos para Openbank desde enero 2025 hasta el último periodo disponible.",
    tag: "Quitas" },
  { id: 44, title: "Total de quitas de BBVA en diciembre 2024",
    text: "¿Cuánto fue el total de quitas y castigos de BBVA en diciembre 2024?",
    tag: "Quitas" },
  { id: 45, title: "Quitas de vivienda vs tarjeta: BBVA 2025",
    text: "Compara las quitas de vivienda contra las quitas de tarjeta de crédito para BBVA a lo largo de 2025.",
    tag: "Quitas" },
];
const TAG_COLORS = {
  "Balance":        C.blue,
  "Rentabilidad":   C.green,
  "Riesgo":         C.red,
  "Capitalización": C.purple,
  "Reservas":       C.gold,
  "Quitas":         "#a78bfa",
  "Directorio":     C.muted,
};

// ─── UTILS ───────────────────────────────────────────────────────────────────
function sleep(ms) { return new Promise(r => setTimeout(r, ms)); }
function now() { return new Date().toLocaleTimeString("es-MX", { hour: "2-digit", minute: "2-digit" }); }
// Formatea un hallazgo/alerta que puede ser string u objeto del backend
function formatItem(item) {
  if (typeof item === "string") return item;
  if (typeof item === "object" && item !== null) {
    // Formato hallazgo: {metrica, valor, unidad, contexto, relevancia}
    if (item.metrica !== undefined) {
      const partes = [];
      partes.push(item.metrica.toUpperCase());
      if (item.valor !== undefined && item.valor !== null)
        partes.push(`: ${item.valor}${item.unidad ? " " + item.unidad : ""}`);
      if (item.contexto)   partes.push(` — ${item.contexto}`);
      if (item.relevancia) partes.push(` [${item.relevancia}]`);
      return partes.join("");
    }
    // Formato alerta: {nivel, descripcion, recomendacion}
    if (item.descripcion !== undefined) {
      const partes = [];
      if (item.nivel)         partes.push(`[${item.nivel.toUpperCase()}] `);
      if (item.descripcion)   partes.push(item.descripcion);
      if (item.recomendacion) partes.push(` → ${item.recomendacion}`);
      return partes.join("");
    }
    // Fallback: cualquier otro objeto con texto legible
    return item.mensaje || item.texto || item.text || item.message || JSON.stringify(item);
  }
  return String(item);
}

function stripHtml(str) {
  // Elimina tags HTML (ej: <br>, <sup>) que Plotly inserta en títulos pero React muestra como texto plano
  return (str || "").replace(/<[^>]+>/g, " ").replace(/\s+/g, " ").trim();
}

function getChartTitle(fig) {
  const t = fig?.layout?.title;
  if (!t) return "Gráfica";
  if (typeof t === "string") return stripHtml(t);
  if (typeof t === "object" && t.text) return stripHtml(t.text);
  return "Gráfica";
}

// ─── FORMATO MONTOS ESCALA MEXICANA ──────────────────────────────────────────
// Los valores en la tabla están en millones de pesos (mdp)
// < 1,000 mdp  → "$999 mdp"
// >= 1,000 mdp → "$1.2 mmdp"  (miles de millones de pesos)
// >= 1,000,000 mdp → "$1.2 B" (billones)
function formatMonto(val) {
  if (val === null || val === undefined || isNaN(val)) return "—";

  const abs = Math.abs(val);

  if (abs >= 1_000_000_000_000) {
    return `$${(val / 1_000_000_000_000).toFixed(1)} B`;
  }

  if (abs >= 1_000_000_000) {
    return `$${(val / 1_000_000_000).toFixed(1)} mmdp`;
  }

  return `$${(val / 1_000_000).toFixed(0)} mdp`;
}

function formatPct(val) {
  if (val === null || val === undefined) return "—";
  return `${val.toFixed(2)}%`;
}

function formatValor(val, tipo) {
  if (tipo === "porcentaje") return formatPct(val);
  if (tipo === "entero")     return val != null ? val.toLocaleString("es-MX") : "—";
  return formatMonto(val);
}

function formatDelta(actual, anterior, tipo, esPp) {
  if (actual == null || anterior == null) return { texto: "", signo: null };
  const diff = actual - anterior;
  const signo = diff > 0 ? "▲" : diff < 0 ? "▼" : "=";
  let texto;
  if (esPp) {
    texto = `${signo} ${Math.abs(diff).toFixed(2)}pp`;
  } else if (tipo === "monto") {
    texto = `${signo} ${formatMonto(Math.abs(diff))}`;
  } else if (tipo === "porcentaje") {
    texto = `${signo} ${Math.abs(diff).toFixed(2)}pp`;
  } else {
    texto = `${signo} ${Math.abs(diff).toLocaleString("es-MX")}`;
  }
  return { texto, diff };
}

// ─── UTILIDAD: ordena entidades numéricamente por prefijo ────────────────────
// "5 Total Banca..." → 5, "59 G-7" → 59, "40002 Banamex" → 40002

// ─── MODAL HISTÓRICO DE INDICADOR ────────────────────────────────────────────
function HistoricoModal({ item, onClose }) {
  // Hooks siempre al inicio, antes de cualquier return condicional
  const plotRef = useRef(null);
  useEffect(() => {
    if (!item || !item.historico || item.historico.length === 0) return;
    if (!plotRef.current || !window.Plotly) return;

    const fmtPeriodo = (p) => { const m = String(p % 100).padStart(2,"0"); const y = Math.floor(p / 100); return `${y}-${m}`; };
    const esPct   = item.tipo === "porcentaje";
    const fmtVal  = (v) => v == null ? null : esPct ? `${v.toFixed(2)}%` : formatMonto(v);
    const deltaLabel = esPct ? "Δ pp" : "Δ";
    const labels  = item.historico.map(h => fmtPeriodo(h.periodo));
    const valores = item.historico.map(h => h.valor);
    const deltas  = item.historico.map(h => h.delta);
    const titulo  = `${item.label} — ${item.nombre_entidad} (Consolidado)`;

    const trace1 = {
      x: labels, y: valores, name: item.label,
      type: "scatter", mode: "lines+markers",
      line: { color: "#c8a96e", width: 2 },
      marker: { size: 5, color: "#c8a96e" },
      yaxis: "y1",
      hovertemplate: `%{x}<br>${item.label}: %{customdata}<extra></extra>`,
      customdata: valores.map(fmtVal),
    };
    const trace2 = {
      x: labels, y: deltas, name: deltaLabel,
      type: "scatter", mode: "lines+markers",
      line: { color: "#60a5fa", width: 1.5, dash: "dot" },
      marker: { size: 4, color: "#60a5fa" },
      yaxis: "y2",
      hovertemplate: `%{x}<br>${deltaLabel}: %{customdata}<extra></extra>`,
      customdata: deltas.map(fmtVal),
    };
    const layout = {
      title: { text: titulo, font: { color: "#dde4ee", size: 15 }, x: 0.02 },
      paper_bgcolor: "transparent", plot_bgcolor: "transparent",
      font: { color: "#8aa4b8", family: "monospace", size: 13 },
      margin: { l: 55, r: 55, t: 48, b: 70 },
      legend: { orientation: "h", y: -0.25, font: { color: "#8aa4b8", size: 12 }, bgcolor: "transparent" },
      xaxis: { gridcolor: "#1a2535", linecolor: "#1a2535", tickfont: { color: "#8aa4b8", size: 12 }, tickangle: -45 },
      yaxis: {
        title: { text: item.label, font: { color: "#c8a96e", size: 12 } },
        gridcolor: "#1a2535", linecolor: "#1a2535",
        tickfont: { color: "#c8a96e", size: 12 },
        tickformat: esPct ? ".2f" : ".3s", side: "left",
      },
      yaxis2: {
        title: { text: deltaLabel, font: { color: "#60a5fa", size: 12 } },
        gridcolor: "transparent", linecolor: "#1a2535",
        tickfont: { color: "#60a5fa", size: 12 },
        tickformat: esPct ? ".2f" : ".3s",
        overlaying: "y", side: "right", showgrid: false,
      },
      hovermode: "x unified",
      hoverlabel: { bgcolor: "#111b28", bordercolor: "#1a2535", font: { color: "#dde4ee", size: 13 } },
    };

    window.Plotly.newPlot(plotRef.current, [trace1, trace2], layout, {
      responsive: true, displayModeBar: false,
    });
  }, [item]);

  if (!item || !item.historico || item.historico.length === 0) return null;

  return (
    <div
      onClick={onClose}
      style={{
        position: "fixed", inset: 0, zIndex: 9999,
        background: "rgba(7,12,18,0.85)",
        display: "flex", alignItems: "center", justifyContent: "center",
        backdropFilter: "blur(3px)",
      }}
    >
      <div
        onClick={e => e.stopPropagation()}
        style={{
          background: "#0d1520", border: "1px solid #1a2535",
          borderRadius: 12, padding: "20px 20px 12px",
          width: "min(820px, 95vw)", maxHeight: "85vh",
          display: "flex", flexDirection: "column", gap: 8,
          boxShadow: "0 24px 64px rgba(0,0,0,0.6)",
        }}
      >
        {/* Header */}
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
          <span style={{ fontSize: 13, fontFamily: "monospace", color: "#c8a96e", letterSpacing: "0.1em" }}>
            HISTÓRICO · ÚLTIMOS 12 MESES
          </span>
          <button
            onClick={onClose}
            style={{ background: "none", border: "none", color: "#556a7a", fontSize: 16, cursor: "pointer", lineHeight: 1 }}
          >✕</button>
        </div>
        {/* Gráfica */}
        <div ref={plotRef} style={{ width: "100%", height: 340 }} />
      </div>
    </div>
  );
}


// ─── COMPONENTE TICKER BANNER ─────────────────────────────────────────────────
// ─── SELECTOR UNIFICADO DE ENTIDAD ──────────────────────────────────────────
// Muestra los grupos disponibles en los datos; si el grupo tiene bancos
// individuales en los datos, los muestra como segundo nivel.
function EntidadSelector({ entidadFiltro, setEntidadFiltro, showBanners, onToggleBanners }) {
  const [menuOpen, setMenuOpen] = useState(false);
  const [grupoExpanded, setGrupoExpanded] = useState(null);
  const menuRef = useRef(null);

  useEffect(() => {
    function handleClick(e) {
      if (menuRef.current && !menuRef.current.contains(e.target)) {
        setMenuOpen(false);
        setGrupoExpanded(null);
      }
    }
    document.addEventListener("mousedown", handleClick);
    return () => document.removeEventListener("mousedown", handleClick);
  }, []);

  // Entidades disponibles en banner2 (fuente de verdad para el menú)
  const enData2 = new Set(BANNERS_DATA.banner2.map(r => r.nombre_entidad));
  const enData3 = new Set(BANNERS_DATA.banner3.map(r => r.nombre_entidad));
  const enData  = new Set([...enData2, ...enData3]);

  // Nombre corto para mostrar en el botón
  const labelCorto = (nombre) => nombre ? nombre.replace(/^\d+ /, "") : "Todos";

  // Construir lista de grupos disponibles (los que tienen al menos 1 entrada en los datos)
  const gruposDisponibles = GRUPOS_CNBV.filter(g => {
    const nombreGrupo = Object.values(INSTITUCIONES_CNBV[g.clave] || [])
      .map(i => i.nombre);
    // Agregar el nombre del grupo mismo (ej "59 G-7")
    const nombreComoEntidad = [...enData].find(n => n.startsWith(g.clave + " ") || n === g.clave + " " + g.nombre);
    return nombreComoEntidad || nombreGrupo.some(n => enData.has(n));
  });

  // Para cada grupo, entidades individuales disponibles en los datos
  const entidadesDeGrupo = (claveGrupo) =>
    (INSTITUCIONES_CNBV[claveGrupo] || []).filter(i => enData.has(i.nombre));

  // Nombre del grupo como aparece en los datos (ej "59 G-7")
  const nombreGrupoEnData = (g) =>
    [...enData].find(n => n.startsWith(g.clave + " ")) || null;

  const CC = {
    surface: "#0d1520", border: "#1a2535",
    text: "#dde4ee", muted: "#8aa4b8",
    gold: "#c8a96e",
  };

  const selectorLabel = entidadFiltro ? labelCorto(entidadFiltro) : "Todos";

  return (
    <div ref={menuRef} style={{
      background: CC.surface, borderBottom: `1px solid ${CC.border}`,
      height: 32, display: "flex", alignItems: "center",
      padding: "0 12px", flexShrink: 0, position: "relative",
      gap: 8,
    }}>
      <span style={{ fontSize: 12, fontFamily: "monospace", color: CC.muted, letterSpacing: "0.08em" }}>
        ENTIDAD
      </span>
      <button
        onClick={() => setMenuOpen(o => !o)}
        style={{
          background: "none", border: `1px solid ${menuOpen ? CC.gold + "66" : CC.border}`,
          borderRadius: 4, padding: "2px 10px", color: entidadFiltro ? CC.gold : CC.muted,
          fontSize: 13, fontFamily: "monospace", cursor: "pointer",
          display: "flex", alignItems: "center", gap: 5,
          transition: "all 0.15s",
        }}
      >
        {selectorLabel}
        <span style={{ fontSize: 10, opacity: 0.6 }}>{menuOpen ? "▲" : "▼"}</span>
      </button>
      {entidadFiltro && (
        <button onClick={() => setEntidadFiltro(null)}
          style={{ background: "none", border: "none", cursor: "pointer", color: CC.muted, fontSize: 14, lineHeight: 1 }}
          title="Limpiar filtro"
        >&#10005;</button>
      )}

      {/* Toggle banners — extremo derecho */}
      {onToggleBanners && (
        <button
          onClick={onToggleBanners}
          title={showBanners ? "Ocultar teleprompter" : "Mostrar teleprompter"}
          style={{
            marginLeft: "auto",
            background: "none",
            border: `1px solid ${CC.border}`,
            borderRadius: 4,
            padding: "2px 9px",
            cursor: "pointer",
            color: CC.muted,
            fontSize: 12,
            fontFamily: "monospace",
            letterSpacing: 0.5,
            display: "flex", alignItems: "center", gap: 4,
            transition: "all 0.15s",
          }}
          onMouseEnter={e => { e.currentTarget.style.borderColor = CC.gold + "66"; e.currentTarget.style.color = CC.gold; }}
          onMouseLeave={e => { e.currentTarget.style.borderColor = CC.border; e.currentTarget.style.color = CC.muted; }}
        >
          <span>{showBanners ? "▲" : "▼"}</span>
          <span>{showBanners ? "OCULTAR" : "BANNERS"}</span>
        </button>
      )}

      {menuOpen && (
        <div style={{
          position: "absolute", top: "100%", left: 0,
          background: "#0d1520", border: `1px solid ${CC.border}`,
          borderRadius: 6, zIndex: 200,
          boxShadow: "0 4px 20px rgba(0,0,0,0.6)",
          display: "flex", minWidth: 200,
        }}>
          {/* Columna izquierda: Todos + grupos */}
          <div style={{ minWidth: 190, borderRight: grupoExpanded !== null ? `1px solid ${CC.border}` : "none" }}>
            {/* Todos */}
            <div
              onClick={() => { setEntidadFiltro(null); setMenuOpen(false); setGrupoExpanded(null); }}
              style={{
                padding: "7px 14px", cursor: "pointer", fontSize: 13, fontFamily: "monospace",
                borderBottom: `1px solid ${CC.border}`,
                color: entidadFiltro === null ? CC.gold : CC.text,
                background: entidadFiltro === null ? CC.gold + "12" : "transparent",
              }}
              onMouseEnter={e => { if (entidadFiltro !== null) e.currentTarget.style.background = "#1a2535"; }}
              onMouseLeave={e => { e.currentTarget.style.background = entidadFiltro === null ? CC.gold + "12" : "transparent"; }}
            >
              Todos
            </div>

            {/* Grupos */}
            {gruposDisponibles.map(g => {
              const nombreEnData = nombreGrupoEnData(g);
              const hijos = entidadesDeGrupo(g.clave);
              const tieneHijos = hijos.length > 0;
              const isSelGrupo = entidadFiltro === nombreEnData;
              const isExpanded = grupoExpanded === g.clave;

              return (
                <div key={g.clave}
                  onMouseEnter={() => { if (tieneHijos) setGrupoExpanded(g.clave); else setGrupoExpanded(null); }}
                  style={{
                    padding: "7px 14px", cursor: "pointer", fontSize: 13, fontFamily: "monospace",
                    color: isSelGrupo ? CC.gold : CC.text,
                    background: isSelGrupo ? CC.gold + "12" : isExpanded ? "#1a2535" : "transparent",
                    display: "flex", justifyContent: "space-between", alignItems: "center",
                    transition: "background 0.1s",
                  }}
                  onClick={() => {
                    if (nombreEnData) { setEntidadFiltro(nombreEnData); setMenuOpen(false); setGrupoExpanded(null); }
                  }}
                >
                  <span>{g.nombre}</span>
                  {tieneHijos && <span style={{ fontSize: 11, opacity: 0.5 }}>›</span>}
                </div>
              );
            })}
          </div>

          {/* Columna derecha: entidades del grupo expandido */}
          {grupoExpanded !== null && entidadesDeGrupo(grupoExpanded).length > 0 && (
            <div style={{ minWidth: 180, maxHeight: 300, overflowY: "auto" }}>
              {entidadesDeGrupo(grupoExpanded).map(inst => {
                const isSel = entidadFiltro === inst.nombre;
                return (
                  <div key={inst.clave}
                    onClick={() => { setEntidadFiltro(inst.nombre); setMenuOpen(false); setGrupoExpanded(null); }}
                    style={{
                      padding: "7px 14px", cursor: "pointer", fontSize: 13, fontFamily: "monospace",
                      color: isSel ? CC.gold : CC.text,
                      background: isSel ? CC.gold + "12" : "transparent",
                      transition: "background 0.1s",
                    }}
                    onMouseEnter={e => { if (!isSel) e.currentTarget.style.background = "#1a2535"; }}
                    onMouseLeave={e => { e.currentTarget.style.background = isSel ? CC.gold + "12" : "transparent"; }}
                  >
                    {inst.nombre.replace(/^\d+ /, "")}
                  </div>
                );
              })}
            </div>
          )}
        </div>
      )}
    </div>
  );
}

function TickerBanner({ data, bannerLabel, accentColor, entidadFiltro }) {
  const [modalItem, setModalItem] = useState(null);

  const C_local = {
    bg: "#070c12", surface: "#0d1520", border: "#1a2535",
    text: "#dde4ee", muted: "#8aa4b8",
    green: "#34d399", red: "#f87171",
    gold: accentColor || "#c8a96e",
  };

  // Filtrar por entidad seleccionada globalmente
  // Para banner1 (A-0417) hay entidades que no reportan — en ese caso mostrar todos
  const itemsFiltrados = entidadFiltro ? data.filter(r => r.nombre_entidad === entidadFiltro) : data;
  const sinDatos = entidadFiltro && itemsFiltrados.length === 0;
  const items = sinDatos ? data : itemsFiltrados;

  // Periodo formateado
  const meses = ["","Ene","Feb","Mar","Abr","May","Jun","Jul","Ago","Sep","Oct","Nov","Dic"];
  const periodoLabel = (() => {
    const p = BANNERS_PERIODO;
    const m = p % 100;
    const y = Math.floor(p / 100);
    return (meses[m] || m) + " " + y;
  })();

  const scrollDuration = Math.max(items.length * 10, 90);

  return (
    <>
    <div style={{
      background: C_local.surface,
      borderBottom: `1px solid ${C_local.border}`,
      display: "flex",
      alignItems: "center",
      height: 42,
      overflow: "hidden",
      flexShrink: 0,
      position: "relative",
    }}>
      {/* Etiqueta fija izquierda */}
      <div style={{
        flexShrink: 0,
        padding: "0 12px",
        borderRight: `1px solid ${C_local.border}`,
        fontSize: 13,
        fontFamily: "monospace",
        color: C_local.gold,
        letterSpacing: "0.08em",
        whiteSpace: "nowrap",
        height: "100%",
        display: "flex",
        alignItems: "center",
        gap: 6,
        minWidth: 100,
      }}>
        <span>{bannerLabel}</span>
        <span style={{ color: C_local.muted, fontSize: 12 }}>{periodoLabel}</span>
        {sinDatos && (
          <span style={{ color: C_local.muted, fontSize: 11, fontStyle: "italic" }}>· sin datos</span>
        )}
      </div>

      {/* Ticker scrolling */}
      <div style={{ flex: 1, overflow: "hidden", position: "relative" }}>
        <style>{`
          @keyframes ticker-scroll-${bannerLabel.replace(/\s/g,"")} {
            0%   { transform: translateX(0); }
            100% { transform: translateX(-50%); }
          }
          .ticker-track-${bannerLabel.replace(/\s/g,"")} {
            display: flex;
            width: max-content;
            animation: ticker-scroll-${bannerLabel.replace(/\s/g,"")} ${scrollDuration}s linear infinite;
          }
          .ticker-track-${bannerLabel.replace(/\s/g,"")}:hover { animation-play-state: paused; }
        `}</style>
        <div className={`ticker-track-${bannerLabel.replace(/\s/g,"")}`}>
          {[...items, ...items].map((item, i) => {
            const { texto: deltaTexto, diff } = formatDelta(
              item.valor_actual, item.valor_anterior, item.tipo, item.es_pp
            );
            const esSube = diff > 0;
            const colorDelta = diff === 0 || diff == null
              ? C_local.muted
              : (item.invert_delta ? (esSube ? C_local.red : C_local.green)
                                   : (esSube ? C_local.green : C_local.red));
            const tieneHistorico = item.historico && item.historico.length > 0;
            return (
              <div
                key={i}
                onClick={tieneHistorico ? () => setModalItem(item) : undefined}
                style={{
                  display: "flex", alignItems: "center", gap: 7,
                  padding: "0 18px",
                  borderRight: `1px solid ${C_local.border}`,
                  whiteSpace: "nowrap", height: 42,
                  cursor: tieneHistorico ? "pointer" : "default",
                  transition: "background 0.15s",
                }}
                onMouseEnter={e => { if (tieneHistorico) e.currentTarget.style.background = "#111b28"; }}
                onMouseLeave={e => { e.currentTarget.style.background = "transparent"; }}
              >
                <span style={{ fontSize: 15, color: "#e8eef5", fontFamily: "monospace", letterSpacing: "0.06em", fontWeight: 500 }}>
                  {item.label.toUpperCase()}
                </span>
                <span style={{ fontSize: 14, color: "#d8b67a", opacity: 1 }}>·</span>
                <span style={{ fontSize: 14, color: "#f0d9a6", fontFamily: "monospace", opacity: 1 }}>
                  {item.nombre_entidad.replace(/^\d+ /, "")}
                </span>
                <span style={{ fontSize: 18, fontWeight: 800, color: "#ffffff", fontFamily: "monospace", letterSpacing: "-0.01em" }}>
                  {formatValor(item.valor_actual, item.tipo)}
                </span>
                {deltaTexto && (
                  <span style={{ fontSize: 15, fontFamily: "monospace", color: colorDelta, fontWeight: 600 }}>
                    {deltaTexto}
                  </span>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </div>
    {modalItem && <HistoricoModal item={modalItem} onClose={() => setModalItem(null)} />}
    </>
  );
}


// ─── DARK PLOTLY THEME ───────────────────────────────────────────────────────
function applyDarkTheme(layout = {}) {
  const out = {
    ...layout,
    paper_bgcolor: "transparent",
    plot_bgcolor: "transparent",
    hovermode: "closest",
    colorway: [C.gold, C.blue, C.green, C.purple, C.red, "#f472b6", "#2dd4bf", "#fb923c"],
    font: { color: C.muted, family: "sans-serif" },
    xaxis: { ...layout.xaxis, gridcolor: "#1a2535", zerolinecolor: "#1a2535" },
    yaxis: { ...layout.yaxis, gridcolor: "#1a2535", zerolinecolor: "#1a2535", tickformat: ".2s" },
    margin: { t: 40, r: 20, l: 50, b: 40 }
  };
  // Homologar el grid en los ejes SECUNDARIOS del small-multiples (xaxis2.., yaxis2..)
  // para que todos los paneles se vean como el primero (grid oscuro sutil, no gris claro).
  // No se toca el tickformat: cada panel conserva su formato de número del backend.
  Object.keys(layout).forEach(k => {
    if (/^[xy]axis\d+$/.test(k)) {
      out[k] = { ...layout[k], gridcolor: "#1a2535", zerolinecolor: "#1a2535" };
    }
  });
  return out;
}

// ─── APLICA COLORES DORADOS A TRAZOS + TABLA LEGIBLE ────────────────────────
function applyGoldToTraces(data) {
  const hasMultipleTraces = (data || []).length > 1;
  return (data || []).map(trace => {
    const t = trace.type || "scatter";
    if (t === "scatter" || t === "scattergl") {
      // Multi-traza (small multiples / multi-serie): RESPETAR el color por entidad
      // que asigna el backend; NO borrarlo, o el colorway lo repinta por orden de
      // traza y una misma entidad sale de distinto color en cada panel.
      const _cl = trace.line && trace.line.color;
      const _cm = trace.marker && trace.marker.color;
      return {
        ...trace,
        line: { ...(trace.line || {}), color: hasMultipleTraces ? (_cl || undefined) : C.gold, width: (trace.line && trace.line.width) || 2 },
        marker: { ...(trace.marker || {}), color: hasMultipleTraces ? (_cm || undefined) : C.gold, size: 8 },
        hoverinfo: "all"
      };
    }
    if (t === "table") {
      return {
        ...trace,
        header: {
          ...(trace.header || {}),
          fill: { color: "#16202c" },
          font: { color: C.gold, size: 14 },
          line: { width: 1, color: C.border }
        },
        cells: {
          ...(trace.cells || {}),
          fill: { color: [["#0d1520", "#111b28"]] },
          font: { color: C.text, size: 13 },
          line: { width: 1, color: C.border }
        },
      };
    }
    return trace;
  });
}

// ─── DOWNLOAD CHART AS HTML ──────────────────────────────────────────────────
const downloadChartHtml = (fig, title, narrativaDeSesion, hallazgos = [], alertas = [], notaMetodologica = "", confianzas = "", resumen = null) => {
  // Verificamos que el texto exista, si no, ponemos un mensaje de error
  const textoLimpio = narrativaDeSesion ? String(narrativaDeSesion) : "Análisis no disponible";

  // Badges y secciones de hallazgos/alertas del analista
  const badgeHtml = (label, color) =>
    `<span style="display:inline-block;margin:0 3px;padding:1px 7px;border-radius:4px;background:${color}20;border:1px solid ${color}55;color:${color};font-size:12px;font-weight:700;letter-spacing:0.08em;vertical-align:middle;">${label}</span>`;

  const hallazgosHtml = (hallazgos || []).map(h => {
    let txt = formatItem(h);
    txt = txt.replace(/\[(alt[ao]|medi[ao]|baj[ao])\]/gi, (m0, nivel) => {
      const c = /^alt/i.test(nivel) ? "#3b82f6" : /^med/i.test(nivel) ? "#60a5fa" : "#93c5fd";
      // "RELEVANCIA ALTA" en vez de "ALTA": evita confundir con severidad de riesgo
      return badgeHtml("RELEVANCIA " + nivel.toUpperCase(), c);
    });
    return `<div style="margin-bottom:8px;">◆ ${txt}</div>`;
  }).join("");

  const alertasHtml = (alertas || []).map(a => {
    const txt = formatItem(a);
    const nivelMatch = txt.match(/\[(CRITICO|MODERADO|INFORMATIVO)\]/i);
    const nivel = nivelMatch ? nivelMatch[1].toUpperCase() : null;
    const c = nivel === "CRITICO" ? "#f87171" : nivel === "MODERADO" ? "#f59e0b" : nivel === "INFORMATIVO" ? "#60a5fa" : "#8aa4b8";
    const cuerpo = txt.replace(/[⚠\s]*\[(CRITICO|MODERADO|INFORMATIVO)\]\s*/i, "").trim();
    return `<div style="margin-bottom:10px;">${nivel ? badgeHtml("⚠ " + nivel, c) + " " : ""}${cuerpo}</div>`;
  }).join("");
  
  // Convertimos saltos de línea y negritas para el HTML
  const narrativaHtml = textoLimpio
    .replace(/\n/g, "<br/>")
    .replace(/\*\*(.*?)\*\*/g, "<strong>$1</strong>");

  // Resumen ejecutivo (narrativa_corta): solo si existe y es distinto del analisis largo
  const resumenTxt = resumen ? String(resumen).trim() : "";
  const resumenHtml = (resumenTxt && resumenTxt !== textoLimpio.trim())
    ? resumenTxt.replace(/\n/g, "<br/>").replace(/\*\*(.*?)\*\*/g, "<strong>$1</strong>")
    : "";

  // Periodo analizado — derivado de la columna Periodo de la tabla embebida (si existe)
  let periodoTxt = "";
  try {
    const tt = (fig?.data || []).find(t => t.type === "table");
    const hdrs = (tt?.header?.values || []).map(h => String(h).replace(/<[^>]+>/g, "").trim().toLowerCase());
    const iPer = hdrs.indexOf("periodo");
    if (tt && iPer >= 0) {
      const vals = (tt.cells?.values?.[iPer] || [])
        .map(v => parseInt(String(v).replace(/[^0-9]/g, ""), 10))
        .filter(n => !isNaN(n) && n > 190000 && n % 100 >= 1 && n % 100 <= 12);
      if (vals.length) {
        const M = ["ene","feb","mar","abr","may","jun","jul","ago","sep","oct","nov","dic"];
        const fmtP = p => `${M[(p % 100) - 1]}-${Math.floor(p / 100)}`;
        periodoTxt = `${fmtP(Math.min(...vals))} a ${fmtP(Math.max(...vals))}`;
      }
    }
  } catch (e) { /* opcional — sin periodo no se muestra la línea */ }

  const fuenteMetodologiaHtml = `
        <div class="card">
          <div class="label">Fuente y metodología</div>
          <div class="analysis-text" style="font-size:12px;color:#8aa4b8;line-height:1.7;">
            <strong>Fuente:</strong> Elaboración EMRISK con información pública de la CNBV (Portafolio de Información).<br/>
            ${periodoTxt ? `<strong>Periodo analizado:</strong> ${periodoTxt} · <strong>Periodicidad:</strong> mensual<br/>` : ""}
            <strong>Fecha de generación:</strong> ${new Date().toLocaleDateString("es-MX", { year: "numeric", month: "long", day: "numeric" })}<br/>
            Las cifras pueden presentar diferencias menores por redondeo. Los rangos de referencia utilizados
            (p. ej. niveles bajo/intermedio/elevado) son criterios analíticos internos de EMRISK y no corresponden
            a límites regulatorios ni a clasificaciones oficiales de la CNBV.
          </div>
        </div>`;

  const htmlContent = `
    <!DOCTYPE html>
    <html lang="es">
    <head>
      <meta charset="utf-8">
      <title>EMRISK - ${title || "Reporte"}</title>
      <script src="https://cdn.plot.ly/plotly-2.24.1.min.js"></script>
      <style>
        body { background: #070c12; color: #dde4ee; font-family: 'Segoe UI', sans-serif; padding: 30px; }
        .container { max-width: 1100px; margin: 0 auto; display: flex; flex-direction: column; gap: 20px; }
        header { border-bottom: 1px solid #1a2535; padding-bottom: 15px; display: flex; align-items: center; gap: 10px; }
        .logo { width: 32px; height: 32px; background: linear-gradient(135deg, #c8a96e, #8a6d3b); border-radius: 6px; display: flex; align-items: center; justify-content: center; color: #070c12; font-weight: bold; }
        .card { background: #0d1520; border: 1px solid #1a2535; border-radius: 12px; padding: 20px; }
        .label { color: #c8a96e; font-size: 12px; text-transform: uppercase; margin-bottom: 15px; letter-spacing: 1px; }
        .analysis-text { line-height: 1.6; color: #b0bac5; font-size: 15px; }
        .analysis-text strong { color: #c8a96e; }
      </style>
    </head>
    <body>
      <div class="container">
        <header>
          <div class="logo">E</div>
          <div style="color: #c8a96e; font-size: 16px;">EMRISK Intelligence System</div>
        </header>
        <div class="card">
          <div class="label">Visualización Dinámica</div>
          <div id="plotly-chart"></div>
        </div>
        ${resumenHtml ? `
        <div class="card" style="border-left: 4px solid #34d399;">
          <div class="label">Resumen Ejecutivo</div>
          <div class="analysis-text">${resumenHtml}</div>
        </div>` : ""}
        <div class="card" style="border-left: 4px solid #c8a96e;">
          <div class="label">Análisis Estratégico</div>
          <div class="analysis-text">${narrativaHtml}</div>
          ${confianzas ? `<div style="margin-top:10px;font-size:12px;color:#8aa4b8;border-top:1px solid #1a2535;padding-top:8px;">${confianzas}</div>` : ""}
        </div>
        ${hallazgosHtml ? `
        <div class="card" style="border-left: 4px solid #60a5fa;">
          <div class="label">Hallazgos del Analista</div>
          <div class="analysis-text">${hallazgosHtml}</div>
        </div>` : ""}
        ${alertasHtml ? `
        <div class="card" style="border-left: 4px solid #f59e0b;">
          <div class="label">Alertas</div>
          <div class="analysis-text">${alertasHtml}</div>
        </div>` : ""}
        ${notaMetodologica ? `
        <div class="card">
          <div class="label">Metodología y alcance</div>
          <div class="analysis-text" style="font-size:13px;color:#8aa4b8;">${notaMetodologica}</div>
        </div>` : ""}
        ${fuenteMetodologiaHtml}
      </div>
      <script>
        const plotData = ${JSON.stringify(fig)};
        // Forzamos fondo transparente para que se integre al card
plotData.layout = plotData.layout || {};

// Fondo y tipografía
plotData.layout.paper_bgcolor = 'rgba(0,0,0,0)';
plotData.layout.plot_bgcolor = 'rgba(0,0,0,0)';
plotData.layout.font = { ...(plotData.layout.font || {}), color: '#dde4ee' };
plotData.layout.title = {
  ...(plotData.layout.title || {}),
  font: { ...((plotData.layout.title || {}).font || {}), color: '#dde4ee', size: 16 }
};
plotData.layout.legend = {
  ...(plotData.layout.legend || {}),
  bgcolor: 'rgba(0,0,0,0)',
  font: { ...((plotData.layout.legend || {}).font || {}), color: '#dde4ee' }
};

// Ejes — conservar el título del eje X ("Periodo"), solo re-estilizarlo
plotData.layout.xaxis = {
  ...(plotData.layout.xaxis || {}),
  title: { ...((plotData.layout.xaxis || {}).title || {}), font: { color: '#8ea2bb' } },
  tickfont: { ...((plotData.layout.xaxis || {}).tickfont || {}), color: '#8ea2bb' },
  gridcolor: 'rgba(142,162,187,0.10)',
  linecolor: 'rgba(142,162,187,0.18)'
};

plotData.layout.yaxis = {
  ...(plotData.layout.yaxis || {}),
  tickfont: { ...((plotData.layout.yaxis || {}).tickfont || {}), color: '#8ea2bb' },
  title: { ...((plotData.layout.yaxis || {}).title || {}), font: { color: '#8ea2bb' } },
  gridcolor: 'rgba(142,162,187,0.10)',
  linecolor: 'rgba(142,162,187,0.18)'
};

// Small multiples (grilla): detectado por meta.sm_grid (robusto con 2 paneles) o
// por yaxis3 (3+). El backend ya calculó los dominios de cada panel y de la tabla —
// NO sobreescribirlos. El ajuste de dominios aplica SOLO al layout viejo de 1 gráfica + 1 tabla.
const isGrid = !!(plotData.layout.meta && plotData.layout.meta.sm_grid) || plotData.layout.yaxis3 !== undefined;
if (!isGrid && (plotData.data || []).some(t => t.type === 'table')) {
  plotData.layout.yaxis  = { ...(plotData.layout.yaxis || {}),  domain: [0.44, 1.0] };
  plotData.data.forEach(t => {
    if (t.type === 'table') {
      t.domain = { ...(t.domain || {}), y: [0.00, 0.34] };
    }
  });
  plotData.layout.margin = { ...(plotData.layout.margin || {}), t: 80, r: 40, l: 60, b: 40 };
}

// Colores más vivos como el frontend
const vividColors = ['#c8a96e', '#60a5fa', '#34d399', '#a78bfa', '#f87171', '#fb923c', '#e879f9'];

if (plotData.data) {
  // Color POR ENTIDAD (nombre de traza), NO por orden de traza: en small multiples
  // una misma entidad tiene una traza por panel; colorear por orden le daba un color
  // distinto en cada panel. Se mapea nombre -> color estable (mismo en los 4 paneles).
  const _nameColor = {};
  const _colorFor = function(name) {
    const k = (name == null) ? '' : String(name);
    if (!(k in _nameColor)) { _nameColor[k] = vividColors[Object.keys(_nameColor).length % vividColors.length]; }
    return _nameColor[k];
  };
  let barIdx = 0;

  plotData.data.forEach(t => {
    if (t.type === 'scatter' || t.type === 'scattergl') {
      const c = _colorFor(t.name);
      t.line = { ...(t.line || {}), color: c, width: (t.line && t.line.width) || 3 };
      t.marker = { ...(t.marker || {}), color: c, size: (t.marker && t.marker.size) || 7 };
    }

    // Barras (ranking): paleta viva por su propio indice (el navy del backend
    // se pierde contra el fondo oscuro del reporte)
    if (t.type === 'bar') {
      const c = vividColors[barIdx % vividColors.length];
      t.marker = { ...(t.marker || {}), color: c };
      barIdx++;
    }

    if (t.type === 'table') {
      t.header = t.header || {};
      t.cells = t.cells || {};
      t.header.fill = { ...(t.header.fill || {}), color: '#16202c' };
      t.header.font = { ...(t.header.font || {}), color: '#c8a96e' };
      t.cells.fill = { ...(t.cells.fill || {}), color: '#0d1520' };
      t.cells.font = { ...(t.cells.font || {}), color: '#dde4ee' };
    }
  });
}
        Plotly.newPlot('plotly-chart', plotData.data, plotData.layout, {responsive: true});
      </script>
    </body>
    </html>
  `;

  const blob = new Blob([htmlContent], { type: "text/html" });
  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.download = "Reporte_Ejecutivo_EMRISK.html";
  link.click();
  URL.revokeObjectURL(url);
};
// ─── EXCEL DOWNLOAD ──────────────────────────────────────────────────────────
function hasTablaDatos(fig) {
  return !!(fig?.data || []).find(t => t.type === "table");
}

function downloadExcel(fig, title) {
  if (!window.XLSX) return;
  const tableTrace = (fig?.data || []).find(t => t.type === "table");
  if (!tableTrace) return;

  const headers = (tableTrace.header?.values || []).map(h => String(h).replace(/<[^>]+>/g, "").trim());
  const columns = tableTrace.cells?.values || [];
  const rowCount = columns[0]?.length || 0;
  const dataForExcel = [headers];

  for (let r = 0; r < rowCount; r++) {
    const row = columns.map(col => {
      const val = col[r];
      return typeof val === "string" ? val.replace(/<[^>]+>/g, "").trim() : val;
    });
    dataForExcel.push(row);
  }

  const ws = window.XLSX.utils.aoa_to_sheet(dataForExcel);
  const wb = window.XLSX.utils.book_new();
  window.XLSX.utils.book_append_sheet(wb, ws, "Datos");
  window.XLSX.writeFile(wb, "EMRISK_Reporte.xlsx");
}

// ─── BACKEND CLIENT ──────────────────────────────────────────────────────────
async function callBackend(pregunta, session_id, usuario) {
  const body = { pregunta };
  if (session_id) body.session_id = session_id;
  if (usuario)    body.usuario    = usuario;
  const resp = await fetch(`${BACKEND_URL}/consulta`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(body),
  });
  if (!resp.ok) {
    const txt = await resp.text().catch(() => "");
    throw new Error(`Error ${resp.status}${txt ? ": " + txt : ""}`);
  }
  return resp.json();
}

// ─── PLOTLY CHART COMPONENT (usa window.Plotly cargado desde CDN) ─────────────
function PlotlyChart({ fig, compact }) {
  const divRef = useRef(null);
  const hasSubplot = !!(fig?.layout?.yaxis2 !== undefined);

// Small multiples (grilla): el backend arma los paneles con sus dominios y títulos
// ya calculados. Se detecta por el marcador meta.sm_grid (robusto incluso con 2
// paneles, donde yaxis3 no existe) o por yaxis3 (3+ paneles). Se respeta tal cual —
// NO aplicarle el manejo del layout viejo de 1 gráfica + 1 tabla.
const isGrid = !!(fig?.layout?.meta?.sm_grid) || !!(fig?.layout?.yaxis3 !== undefined);

const height = isGrid
  ? (fig?.layout?.height || 1140)   // respetar el alto del backend (evita compresión)
  : compact
    ? (hasSubplot ? 700 : 450)  // Aumentamos un poco el compacto
    : (hasSubplot ? 950 : 600); // El modo extendido ahora tiene 950px para dar espacio real

// Localiza la función PlotlyChart y reemplaza su useEffect:
useEffect(() => {
  if (!fig || !divRef.current || !window.Plotly) return;

  // 1. Clonamos la figura para no mutar el estado original
  const figClon = JSON.parse(JSON.stringify(fig));
  
  // 2. Aplicamos el tema base, pero guardamos el resultado en layout
  let layout = { ...applyDarkTheme(figClon.layout || {}), height, autosize: true };

  if (isGrid) {
    // Small multiples: el backend ya calculó la grilla (dominios, títulos de panel,
    // un eje por métrica). Se respeta tal cual; solo se ajusta el margen general.
    // NO tocar domains ni annotations (romperían la grilla).
    layout.margin = { ...layout.margin, t: 60, r: 20, l: 60, b: 40 };
  } else if (hasSubplot) {
    // --- MOVEMOS LA TABLA HACIA ABAJO ---
    // Gráfica: del 60% al 100% del alto. Tabla: del 0% al 30%. 
    // Esto deja un "gap" de aire entre el 30% y el 60%.
    layout.yaxis = { ...layout.yaxis, domain: [0.60, 1.0] };
    layout.yaxis2 = { ...layout.yaxis2, domain: [0.00, 0.30] };

    // --- ELIMINACIÓN RADICAL DEL TÍTULO DEL EJE X ---
    // Plotly a veces ignora el 'null' si el objeto title ya existe, 
    // por lo que forzamos un objeto con texto vacío.
    const noTitle = { text: "" };
    layout.xaxis = { ...layout.xaxis, title: noTitle, tickangle: -45, automargin: true };
    layout.xaxis2 = { ...layout.xaxis2, title: noTitle, automargin: true };

    // --- ELIMINAR LA ANOTACIÓN "PERIODO" ---
    // En subplots, Plotly suele poner el título como una 'annotation' central.
    // Filtramos cualquier anotación que contenga la palabra "periodo".
    if (layout.annotations) {
      layout.annotations = layout.annotations.filter(a => {
        const txt = String(a.text || "").toLowerCase();
        return !txt.includes("periodo");
      });
    }

    // --- AJUSTE DE MÁRGENES ---
    // Aumentamos el margen inferior (b) para que las etiquetas inclinadas no se corten
    layout.margin = { ...layout.margin, t: 50, r: 30, l: 60, b: 80 };
  } else {
    // Si no hay subplot, igual quitamos el título del eje X
    if (layout.xaxis) layout.xaxis.title = { text: "" };
  }

  const data = applyGoldToTraces(figClon.data);

  window.Plotly.newPlot(divRef.current, data, layout, {
    displayModeBar: false,
    responsive: true,
  });

  const el = divRef.current;
  return () => {
    if (el && window.Plotly) window.Plotly.purge(el);
  };
}, [fig, compact, height, hasSubplot, isGrid]);

  return <div ref={divRef} style={{ width: "100%", height }} />;
}

// ─── CHART CARD ──────────────────────────────────────────────────────────────
function ChartCard({ fig, title, narrative = null, resumen = null, hallazgos = [], alertas = [], notaMetodologica = null, confianzas = null, compact = false, inDash = false, onRemove }) {
  const chartTitle = title || getChartTitle(fig);
  return (
    <div style={{
      background: C.card, border: `1px solid ${C.border}`, borderRadius: 10,
      padding: compact ? "12px 14px" : "16px 18px",
      boxShadow: `0 0 24px ${C.goldGlow}`,
    }}>
      {/* Header */}
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", marginBottom: 10 }}>
        <div>
          <div style={{ fontSize: compact ? 13 : 14, fontFamily: "monospace", color: C.gold, letterSpacing: "0.07em", marginBottom: 2 }}>
            {chartTitle.toUpperCase()}
          </div>
        </div>
        <div style={{ display: "flex", alignItems: "center", gap: 6 }}>
          {/* Botón descarga HTML */}
        <button
  	onClick={() => downloadChartHtml(fig, chartTitle, narrative, hallazgos, alertas, notaMetodologica, confianzas, resumen)}
  	style={{ background: "none", border: `1px solid ${C.border}`, borderRadius: 5, padding: "3px 8px", fontSize: 14, color: C.muted, cursor: "pointer", fontFamily: "monospace" }}
	>
  	↓ HTML
	</button>

          {/* Botón descarga Excel — solo si hay tabla de datos */}
          {hasTablaDatos(fig) && (
            <button
              onClick={() => downloadExcel(fig, chartTitle)}
              title="Descargar tabla de datos como Excel (.xlsx)"
              style={{ background: "none", border: `1px solid ${C.border}`, borderRadius: 4, padding: "2px 8px", fontSize: 13, color: C.muted, cursor: "pointer", fontFamily: "monospace", transition: "all 0.15s" }}
              onMouseEnter={e => { e.currentTarget.style.borderColor = C.green; e.currentTarget.style.color = C.green; }}
              onMouseLeave={e => { e.currentTarget.style.borderColor = C.border; e.currentTarget.style.color = C.muted; }}
            >↓ XLS</button>
          )}

          {!inDash && (
            <div style={{ display: "flex", alignItems: "center", gap: 4, padding: "2px 7px", borderRadius: 4, background: `${C.green}15`, border: `1px solid ${C.green}33` }}>
              <div style={{ width: 4, height: 4, borderRadius: "50%", background: C.green }} />
              <span style={{ fontSize: 13, color: C.green, fontFamily: "monospace" }}>EN DASHBOARD</span>
            </div>
          )}
          {inDash && onRemove && (
            <button
              onClick={onRemove}
              style={{ background: "none", border: `1px solid ${C.border}`, borderRadius: 4, padding: "2px 7px", fontSize: 13, color: C.muted, cursor: "pointer", fontFamily: "monospace", transition: "all 0.15s" }}
              onMouseEnter={e => { e.currentTarget.style.borderColor = C.red; e.currentTarget.style.color = C.red; }}
              onMouseLeave={e => { e.currentTarget.style.borderColor = C.border; e.currentTarget.style.color = C.muted; }}
            >✕</button>
          )}
        </div>
      </div>
      {/* Plot */}
      {fig && <PlotlyChart fig={fig} compact={compact} />}
      {/* Narrativa */}
      {narrative && (
        <div style={{
          marginTop: 10, padding: "10px 12px",
          background: C.surface, borderLeft: `3px solid ${C.gold}`,
          borderRadius: 6, fontSize: 15, color: C.sub,
          fontFamily: "monospace", lineHeight: 1.7,
        }}>
          <span style={{ color: C.gold, marginRight: 6 }}>✦ EMRISK AI</span>
          {narrative}
        </div>
      )}
    </div>
  );
}

// ─── FEEDBACK BLOCK ───────────────────────────────────────────────────────────
function FeedbackBlock({ idPregunta, usuario }) {
  const [rating,   setRating]   = useState(null);     // "positivo" | "negativo"
  const [comment,  setComment]  = useState("");
  const [showBox,  setShowBox]  = useState(false);
  const [sent,     setSent]     = useState(false);
  const [sending,  setSending]  = useState(false);

  const submit = async (cal, com) => {
    if (!idPregunta || sending) return;
    setSending(true);
    try {
      const fbBody = { id_pregunta: idPregunta, calificacion: cal, comentario: com || null };
      if (usuario) fbBody.usuario = usuario;
      await fetch(`${BACKEND_URL}/feedback`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(fbBody),
      });
      setSent(true);
    } catch (e) {
      console.error("[Feedback]", e);
      setSent(true); // marcar enviado de todas formas para no bloquear UX
    }
    setSending(false);
  };

  if (sent) {
    return (
      <div style={{ marginTop: 6, fontSize: 13, color: C.green, fontFamily: "monospace", display: "flex", alignItems: "center", gap: 5 }}>
        <span>✓</span><span>Gracias por tu feedback</span>
      </div>
    );
  }

  return (
    <div style={{ marginTop: 8 }}>
      <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
        <span style={{ fontSize: 13, color: C.muted, fontFamily: "monospace" }}>¿Fue útil?</span>
        {[
          { emoji: "🔥", cal: "positivo" },
          { emoji: "👍", cal: "positivo" },
          { emoji: "👎", cal: "negativo" },
        ].map(({ emoji, cal }) => (
          <button key={emoji}
            onClick={() => { setRating(cal); setShowBox(true); }}
            style={{
              background: "none", border: "none", cursor: "pointer",
              fontSize: 18, padding: "0 2px", lineHeight: 1,
              opacity: rating ? (rating === cal ? 1 : 0.4) : 0.75,
              transition: "opacity 0.15s, transform 0.15s",
            }}
            onMouseEnter={e => { e.currentTarget.style.transform = "scale(1.25)"; }}
            onMouseLeave={e => { e.currentTarget.style.transform = "scale(1)"; }}
          >{emoji}</button>
        ))}
      </div>

      {showBox && (
        <div style={{ marginTop: 6, display: "flex", gap: 6, alignItems: "center" }}>
          <input
            value={comment}
            onChange={e => setComment(e.target.value)}
            onKeyDown={e => { if (e.key === "Enter") submit(rating, comment); }}
            placeholder="Comentario opcional (Enter para enviar)..."
            style={{
              flex: 1, background: C.card, border: `1px solid ${C.border}`,
              borderRadius: 5, padding: "4px 9px", fontSize: 14,
              color: C.text, fontFamily: "monospace",
            }}
          />
          <button
            onClick={() => submit(rating, comment)}
            disabled={sending}
            style={{
              background: "none", border: `1px solid ${C.gold}55`, borderRadius: 5,
              padding: "3px 10px", fontSize: 13, color: C.gold,
              cursor: "pointer", fontFamily: "monospace", opacity: sending ? 0.5 : 1,
            }}
          >{sending ? "..." : "Enviar"}</button>
        </div>
      )}
    </div>
  );
}

// ─── WELCOME SCREEN DATA ─────────────────────────────────────────────────────

// Prompts estáticos: respuesta fija, no van al pipeline
const STATIC_PROMPTS = [
  {
    id: "about",
    icon: "◈",
    title: "¿Qué información contiene EMRISK?",
    tag: "Acerca de",
    staticResponse: `EMRISK integra la información supervisada que la CNBV publica mensualmente para la **banca múltiple mexicana**. Los datos están organizados en los siguientes bloques:

**Balanza General (Balance)**
Activo, pasivo y capital de cada institución: cartera de crédito vigente y vencida, captación tradicional, inversiones en valores, instrumentos derivados, capital contable y más.

**Estado de Resultados**
Ingresos y gastos financieros, margen financiero, estimaciones preventivas (EPRC), comisiones, resultado de operación, resultado neto — en cifras mensuales y flujo de 12 meses.

**Indicadores Financieros**
Razones calculadas: IMOR, IMORA, ROA, ROE, MIN, índice de eficiencia, cobertura de cartera vencida, tasa activa y pasiva implícita, entre otros.

**Capitalización (ICAP)**
Capital neto (Tier 1 y Tier 2), activos ponderados por riesgo (crédito, mercado y operativo) e Índice de Capitalización por institución.

**Calificación de Cartera (Reservas)**
Distribución de la cartera por etapa de riesgo (Etapas 1, 2 y 3) y estimaciones preventivas por segmento: comercial, consumo (tarjeta, nómina, personal, automotriz) y vivienda.

**Cobertura temporal:** datos mensuales desde enero 2000 hasta **julio 2026** (último periodo disponible).

**Grupos bancarios disponibles:** ${LISTA_GRUPOS_CNBV}.`,
  },
  {
    id: "groups",
    icon: "⬡",
    title: "¿Qué bancos y grupos están disponibles?",
    tag: "Acerca de",
    staticResponse: `EMRISK cubre **todas las instituciones de banca múltiple** autorizadas por la CNBV. Están organizadas en los siguientes grupos:

${TEXTO_GRUPOS_CNBV}

Puedes preguntar por cualquier banco de forma individual, comparar instituciones dentro de un grupo, o consultar agregados del sistema completo. Para ver la lista completa actualizada escribe: *"enlista todas las instituciones disponibles"*.`,
  },
  {
    id: "metrics",
    icon: "◆",
    title: "¿Qué métricas puedo consultar por tema?",
    tag: "Acerca de",
    staticResponse: `Aquí un resumen de las principales métricas disponibles por tema:

**Tamaño y Balance**
Activo total, cartera de crédito total (comercial, consumo, vivienda), captación tradicional, capital contable, instrumentos derivados, inversiones en valores.

**Calidad de Cartera**
• IMOR — Índice de Morosidad (cartera vencida / cartera total)
• IMORA — Índice de Morosidad Ajustado (incluye quitas y castigos)
• Reservas (EPRC) por segmento y etapa de riesgo (1, 2, 3)
• Cobertura de cartera vencida

**Rentabilidad**
• ROA — Rendimiento sobre activos
• ROE — Rendimiento sobre capital
• Margen Financiero y Margen Financiero Ajustado
• Resultado neto mensual y flujo de 12 meses
• Ingresos por intereses y comisiones

**Capitalización**
• ICAP — Índice de Capitalización
• Capital Neto (Tier 1 básico + Tier 2 complementario)
• Activos Ponderados por Riesgo: crédito, mercado y operativo
• Requerimientos de capital por tipo de riesgo

**Eficiencia y Fondeo**
• Índice de eficiencia operativa
• Tasa activa y pasiva implícita
• MIN — Margen de Interés Neto

Puedes pedir series históricas, comparativos entre periodos, rankings, gráficas y análisis narrativo para cualquiera de estas métricas.`,
  },
  {
    id: "tree-balance",
    icon: "📊",
    title: "Métricas de Balance: ¿qué puedo consultar?",
    tag: "Acerca de",
    staticResponse: `**Bloque: Balanza General**
Fuente: Reporte de Situación Financiera · Escala: millones de pesos

├── **ACTIVO**
│   ├── Efectivo y equivalentes
│   │   ├── Caja
│   │   ├── Bancos
│   │   └── Efectivo restringido / garantía
│   ├── Inversiones en instrumentos financieros
│   │   ├── Negociables
│   │   ├── Para cobrar o vender
│   │   └── Para cobrar principal e interés (neto)
│   ├── **Cartera de crédito total**
│   │   ├── Créditos comerciales
│   │   │   ├── Actividad empresarial o comercial
│   │   │   ├── Entidades financieras
│   │   │   └── Entidades gubernamentales
│   │   ├── Créditos de consumo
│   │   │   ├── Tarjeta de crédito
│   │   │   ├── Personales
│   │   │   ├── Nómina
│   │   │   └── Automotriz (ABCD)
│   │   └── Créditos a la vivienda
│   │       ├── Media y residencial
│   │       ├── De interés social
│   │       └── Adquiridos al Infonavit o Fovissste
│   └── EPRC — Estimación preventiva (saldo en balance)
│       ├── Comercial · Consumo · Vivienda
│       └── Adicional
├── **CAPTACIÓN TOTAL**
│   ├── Captación tradicional
│   │   ├── Depósitos de exigibilidad inmediata
│   │   ├── Depósitos a plazo
│   │   └── Títulos de crédito emitidos (mercado de dinero)
│   └── Préstamos interbancarios y de otros organismos
│       ├── Exigibilidad inmediata
│       ├── Corto plazo
│       └── Largo plazo
└── **CAPITAL CONTABLE**
    ├── Capital contribuido
    ├── Capital ganado
    └── Participación no controladora

Puedes consultar cualquier concepto para un banco específico, un grupo o el total del sistema, en un periodo puntual o como serie histórica.`,
  },
  {
    id: "tree-resultados",
    icon: "📈",
    title: "Métricas de Resultados: ¿qué puedo consultar?",
    tag: "Acerca de",
    staticResponse: `**Bloque: Estado de Resultados**
Fuente: Reporte de Resultado Integral · Escala: millones de pesos
Disponible como: saldo acumulado al cierre, flujo del mes, o flujo acumulado 12 meses

├── **Ingresos por intereses**
│   ├── Intereses de cartera de crédito
│   │   ├── Créditos comerciales (empresarial, financieras, gubernamental)
│   │   ├── Créditos de consumo (tarjeta de crédito)
│   │   └── Créditos a la vivienda
│   ├── Intereses de inversiones en instrumentos financieros
│   ├── Intereses en operaciones de reporto
│   └── Ingresos de derivados de negociación
├── **Gastos por intereses**
│   ├── Intereses por depósitos (vista y plazo)
│   ├── Intereses préstamos interbancarios
│   ├── Intereses por emisión de instrumentos (obligaciones subordinadas)
│   └── Gastos de derivados de negociación
├── **Margen Financiero** (= Ingresos − Gastos por intereses)
├── **EPRC — cargo a resultados** (≠ saldo en balance)
│   ├── Créditos comerciales (empresarial, financieras, gubernamental)
│   ├── Créditos de consumo (tarjeta, no revolvente)
│   └── Créditos a la vivienda
├── **Margen Financiero Ajustado** (= Margen − EPRC)
│   ├── Comisiones y tarifas cobradas
│   │   ├── Operaciones de crédito (comercial, consumo, vivienda)
│   │   └── Servicios (manejo de cuenta, transferencias, banca electrónica)
│   ├── Comisiones y tarifas pagadas
│   ├── Resultado por intermediación
│   └── Gastos de administración y promoción
├── **Resultado de la Operación**
│   ├── Otros productos
│   ├── Otros gastos
│   └── Participación en resultado neto de otras entidades
├── Resultado antes de impuestos
└── **Resultado Neto**

Puedes pedir cualquier concepto para un banco, grupo o sistema, en cifras mensuales, acumuladas o flujo de 12 meses.`,
  },
  {
    id: "tree-indicadores",
    icon: "⚠️",
    title: "Indicadores financieros: ¿qué puedo consultar?",
    tag: "Acerca de",
    staticResponse: `**Bloque: Indicadores Financieros**
Fuente: Catálogo de Indicadores CNBV · Escala: porcentaje (ya calculados)

├── **Rentabilidad**
│   ├── ROA — Retorno sobre Activos
│   ├── ROE — Retorno sobre Capital
│   └── NIM / MIN — Margen de Intermediación Financiera
├── **Liquidez**
│   └── Índice de Liquidez
├── **Calidad de cartera — IMOR** (Índice de Morosidad)
│   ├── IMOR total
│   ├── IMOR > Créditos comerciales
│   │   ├── Actividad empresarial o comercial
│   │   ├── Entidades financieras
│   │   └── Entidades gubernamentales
│   ├── IMOR > Créditos de consumo
│   │   ├── Tarjeta de crédito
│   │   ├── Personales · Nómina · Automotriz
│   │   └── Consumo no revolvente
│   └── IMOR > Créditos a la vivienda
│       ├── Media y residencial
│       ├── De interés social
│       └── Adquiridos al Infonavit o Fovissste
├── **Calidad de cartera — IMORA** (Índice de Morosidad Ajustado)
│   ├── IMORA total
│   └── (mismos desgloses que IMOR: comercial, consumo, vivienda)
├── **Calidad de cartera — TDA** (Tasa de Deterioro Ajustada)
│   ├── TDA total
│   └── (mismos desgloses que IMOR: comercial, consumo, vivienda)
└── **Cobertura — ICOR** (Índice de Cobertura)
    ├── ICOR total
    ├── ICOR > Créditos comerciales
    │   ├── Actividad empresarial
    │   ├── Entidades financieras
    │   └── Entidades gubernamentales
    ├── ICOR > Créditos de consumo
    │   ├── Tarjeta de crédito
    │   └── Consumo no revolvente (personales, nómina, automotriz)
    └── ICOR > Créditos a la vivienda
        ├── Media y residencial · Interés social
        └── Adquiridos al Infonavit o Fovissste

Todos los indicadores pueden consultarse por banco individual, grupo bancario o total del sistema, en un periodo puntual o como serie histórica.`,
  },
  {
    id: "tree-icap",
    icon: "🏛️",
    title: "Capitalización (ICAP): ¿qué puedo consultar?",
    tag: "Acerca de",
    staticResponse: `**Bloque: Índice de Capitalización (ICAP)**
Fuente: Reporte R01C de Capitalización · Escala: importes en pesos / coeficientes en %

├── **I. Requerimientos de Capital**
│   ├── Por Riesgo de Mercado
│   │   ├── Operaciones con tasa nominal (m.n. y m.e.)
│   │   ├── Operaciones con tasa real / UDIs / INPC
│   │   ├── Operaciones en divisas
│   │   └── Posiciones en acciones y oro
│   ├── Por Riesgo de Crédito
│   │   ├── Por derivados (contrapartes no relacionadas y relacionadas)
│   │   ├── Por posición en títulos de deuda
│   │   ├── De los acreditados en operaciones de crédito
│   │   ├── Por avales y líneas de crédito otorgadas
│   │   └── Bursatilizaciones
│   ├── Por Riesgo Operacional
│   └── **Requerimiento Total** (suma de los tres tipos)
├── **II. Cómputo de Capital**
│   ├── **Capital Neto** (total disponible)
│   │   ├── Capital Básico — Tier 1
│   │   │   ├── Capital Fundamental (CET1)
│   │   │   └── Capital No Fundamental (AT1)
│   │   └── Capital Complementario — Tier 2
│   └── Sobrante / (Faltante) de capital
├── **III. Activos Ponderados por Riesgo (APR)**
│   ├── APR por Riesgo de Mercado
│   ├── APR por Riesgo de Crédito
│   ├── APR por Riesgo Operacional
│   └── **APR Totales**
└── **IV. Coeficientes**
    ├── **ICAP** = Capital Neto / APR Totales  (mínimo regulatorio: 10.5%)
    ├── Colchón de Conservación de Capital (CCB)
    ├── Colchón de Capital Fundamental (CCF)
    └── Alertas Tempranas (categorías I a V)

Puedes consultar cualquier sección para un banco específico, un grupo o el sistema, en un periodo puntual o como serie histórica.`,
  },
  {
    id: "tree-reservas",
    icon: "🗂️",
    title: "Reservas y Calificación: ¿qué puedo consultar?",
    tag: "Acerca de",
    staticResponse: `**Bloque: Calificación de Cartera y Reservas (A-0417)**
Fuente: Reporte Regulatorio R04 · Escala: pesos
Disponible: cartera base (saldo calificado) y EPRC (reserva constituida) por segmento y etapa IFRS9

├── **I. Cartera base + EPRC — Etapa 1** (crédito sin deterioro significativo)
│   ├── Créditos comerciales
│   │   ├── Actividad empresarial o comercial
│   │   ├── Entidades financieras
│   │   └── Entidades gubernamentales
│   ├── Créditos de consumo
│   │   ├── Tarjeta de crédito
│   │   ├── Personales · Nómina
│   │   └── Automotriz (ABCD)
│   └── Créditos a la vivienda
│       ├── Media y residencial
│       └── Interés social · Infonavit / Fovissste
├── **II. Cartera base + EPRC — Etapa 2** (deterioro significativo, sin incumplimiento)
│   └── (mismos desgloses: comercial, consumo, vivienda)
├── **III. Cartera base + EPRC — Etapa 3** (en incumplimiento / cartera vencida)
│   ├── Créditos comerciales (empresarial, financieras, gubernamental)
│   ├── Créditos de consumo (tarjeta, nómina, personales, automotriz)
│   └── Créditos a la vivienda (media/residencial, social, Infonavit)
└── **IV. EPRC Adicional** (solo reserva, sin cartera base)
    └── Reserva ordenada / reconocida / intereses devengados etapa 3

**Consultas disponibles:**
• Reservas (EPRC) por segmento y etapa para cualquier banco
• Cartera base calificada por etapa IFRS9
• Índice de cobertura = EPRC etapa 3 / Cartera etapa 3
• Tasa de reserva = EPRC total / Cartera total
• Comparativo entre instituciones de un grupo`,
  },
  {
    id: "guia-preguntas",
    icon: "💡",
    title: "¿Cómo formular preguntas para obtener mejores respuestas?",
    tag: "Acerca de",
    staticResponse: `EMRISK interpreta lenguaje natural, pero preguntas más precisas producen respuestas más exactas y rápidas. Aquí las claves para aprovechar el sistema al máximo.

---

**1. Especifica el indicador y el segmento**

El mismo término puede referirse a variantes distintas. Ser explícito evita ambigüedades.

| En lugar de... | Prefiere... |
|---|---|
| "el IMOR de los bancos" | "el IMOR de consumo (tarjeta de crédito) del G-7" |
| "las reservas de Banamex" | "la EPRC etapa 3 de créditos de consumo de Banamex" |
| "la cartera" | "la cartera vencida de vivienda del sistema" |

---

**2. Indica el periodo o el horizonte de comparación**

Sin periodo explícito, EMRISK usa el último disponible. Si quieres comparar, di exactamente qué contra qué.

✅ **Buenas formulaciones:**
- "...a diciembre 2025"
- "...entre enero 2024 y diciembre 2025"
- "...variación interanual dic-2024 vs dic-2025"
- "...evolución mensual durante 2025"

❌ **Formulaciones que pueden generar confusión:**
- "...en 2025" → ¿es el último mes de 2025, el promedio, o la serie completa?
- "...el año pasado" → especifica el año directamente

---

**3. Para comparar dos indicadores distintos, nómbralos explícitamente**

Cuando quieres cruzar dos métricas (por ejemplo IMOR de consumo vs IMOR total), menciona ambas con su nombre completo.

✅ **Ejemplo claro:**
> "Para cada banco, calcula el cambio en puntos porcentuales del IMOR de consumo y del IMOR total entre diciembre 2024 y diciembre 2025. Identifica los que tuvieron mayor aceleración en consumo."

❌ **Ejemplo ambiguo:**
> "Bancos donde el IMOR de consumo creció más que el IMOR total como señal de deterioro temprano"
→ "deterioro temprano" y "señal" son interpretaciones, no datos. El sistema puede no saber si quieres comparar bancos entre sí o cada banco contra sí mismo en el tiempo.

---

**4. Especifica el universo de entidades**

Sin instrucción, EMRISK incluye todos los bancos. Si quieres acotar:

- Por grupo: *"del G-7"*, *"del grupo Crédito a los Hogares"*, *"de Comercial Mediano"*
- Por institución: *"de BBVA México y Banorte"*, *"de Bancoppel"*
- Por sistema: *"del sistema (Total Banca Múltiple)"*

---

**5. Di qué tipo de resultado esperas**

EMRISK elige la visualización automáticamente, pero puedes orientarlo:

- *"muéstrame la evolución histórica"* → gráfica de líneas
- *"ordena de mayor a menor"* → gráfica de barras con ranking
- *"compara los dos periodos"* → gráfica comparativa
- *"dame solo el número"* → respuesta puntual sin gráfica
- *"identifica los que superan el umbral del sistema"* → filtra y resalta

---

**6. Ejemplos de preguntas bien estructuradas**

> "¿Cuál fue el IMOR total de cada banco del G-7 a diciembre 2025, ordenado de mayor a menor?"

> "Muestra la evolución mensual del ROA del sistema de enero 2023 a julio 2026."

> "Compara el ICAP de Banorte y BBVA México en diciembre 2024 vs diciembre 2025."

> "¿Qué bancos del sistema tuvieron un incremento en el IMOR de consumo de más de 1 punto porcentual entre diciembre 2024 y diciembre 2025?"

> "Dame el top 5 de bancos por EPRC etapa 3 de tarjeta de crédito a julio 2026."`,
  },
];

// Prompts de ejemplo: van al pipeline normalmente
const EXAMPLE_PROMPTS = [
  // Categoría: Balance y Tamaño
  {
    id: "e1", cat: "Balance y Tamaño", icon: "📊",
    title: "Activo total por grupo bancario",
    text: "Muestra el activo total del sistema bancario desglosado por grupo (G-7, Crédito a los Hogares, Comercial Mediano, etc.) a julio 2026.",
  },
  {
    id: "e2", cat: "Balance y Tamaño", icon: "📊",
    title: "Top 10 bancos por cartera de crédito",
    text: "Dame el top 10 de bancos por cartera de crédito total a julio 2026, ordenado de mayor a menor.",
  },
  {
    id: "e3", cat: "Balance y Tamaño", icon: "📊",
    title: "Desglose de cartera de crédito",
    text: "Muestra el desglose de la cartera de crédito del sistema por tipo: comercial, consumo y vivienda a julio 2026.",
  },
  // Categoría: Rentabilidad
  {
    id: "e4", cat: "Rentabilidad", icon: "📈",
    title: "ROA y ROE del G-7: 2024 vs 2025",
    text: "Compara el ROA y el ROE de los bancos del G-7 entre diciembre 2024 y julio 2026.",
  },
  {
    id: "e5", cat: "Rentabilidad", icon: "📈",
    title: "Rentabilidad del sistema en 2025",
    text: "¿Qué tan rentable fue 2025? Muestra la utilidad neta del sistema bancario y los principales drivers: margen financiero, comisiones y estimaciones preventivas.",
  },
  {
    id: "e6", cat: "Rentabilidad", icon: "📈",
    title: "Resultado neto histórico de un banco",
    text: "De la información Financiera, toma el indicador Resultado neto (Flujo 12 meses) para Banco Inmobiliario Mexicano y muestra su comportamiento desde enero 2024 al último periodo disponible.",
  },
  // Categoría: Riesgo y Morosidad
  {
    id: "e7", cat: "Riesgo y Morosidad", icon: "⚠️",
    title: "Evolución del IMOR por tipo de cartera en 2025",
    text: "Muestra la evolución mensual del IMOR por tipo de cartera — comercial, consumo y vivienda — para el total del sistema bancario a lo largo de 2025.",
  },
  {
    id: "e8", cat: "Riesgo y Morosidad", icon: "⚠️",
    title: "IMOR vs IMORA: grupo Crédito a los Hogares",
    text: "Compara el IMORA e IMOR en un scatterplot para julio 2026 para los siguientes bancos: Banco Azteca, Banco Bineo, Bancoppel, Banfeliz (Antes Forjadores), Compartamos, Consubanco, Hey Banco, Openbank, Revolut Bank y Volkswagen Bank.",
  },
  {
    id: "e9", cat: "Riesgo y Morosidad", icon: "⚠️",
    title: "Bancos con deterioro temprano en consumo",
    text: "Identifica los bancos donde el IMOR de la cartera de consumo creció más que el IMOR total durante 2025, como señal de deterioro temprano.",
  },
  // Categoría: Capitalización
  {
    id: "e10", cat: "Capitalización", icon: "🏛️",
    title: "ICAP del sistema y bancos en mínimos",
    text: "Muestra el ICAP promedio del sistema bancario a julio 2026 e identifica cuáles instituciones están por debajo del mínimo regulatorio.",
  },
  {
    id: "e11", cat: "Capitalización", icon: "🏛️",
    title: "Requerimientos de capital por tipo de riesgo",
    text: "Utiliza la información de Capitalización para mostrar los distintos tipos de requerimientos por riesgo de crédito para Multiva desde enero 2024 al último periodo disponible. Genera una gráfica de líneas con el eje X = periodo y el eje Y = monto del requerimiento, una línea por tipo de riesgo.",
  },
  {
    id: "e12", cat: "Capitalización", icon: "🏛️",
    title: "Variación del ICAP y ROE del G-7",
    text: "Compara la variación del ICAP y el ROE de los bancos del G-7 entre 2024 y 2025.",
  },
  // Categoría: Reservas y Calificación
  {
    id: "e13", cat: "Reservas y Calificación", icon: "🗂️",
    title: "Reservas por segmento de cartera",
    text: "Muestra la información de Reservas por segmento de cartera para Multiva en el periodo de julio 2026.",
  },
  {
    id: "e14", cat: "Reservas y Calificación", icon: "🗂️",
    title: "Cobertura de cartera vencida al cierre 2025",
    text: "Muestra la cobertura de cartera vencida al cierre de 2025 para el sistema bancario: estimaciones preventivas sobre cartera vencida.",
  },
  {
    id: "e15", cat: "Reservas y Calificación", icon: "🗂️",
    title: "Concentración de riesgo en cartera de consumo",
    text: "¿Se concentra el riesgo en tarjeta de crédito, nómina o crédito personal? Muestra la distribución de la cartera de consumo por producto a julio 2026.",
  },
  // Categoría: Directorio
  {
    id: "e16", cat: "Directorio", icon: "📋",
    title: "Bancos del grupo Comercial Pequeño",
    text: "Enlista los bancos que pertenecen al Grupo Comercial Pequeño.",
  },
  {
    id: "e17", cat: "Directorio", icon: "📋",
    title: "Instituciones del sistema a julio 2026",
    text: "¿Cuántos bancos hay en el sistema bancario al cierre de julio 2026? Genera una tabla con el nombre de cada institución y el grupo al que pertenece.",
  },
  {
    id: "e18", cat: "Directorio", icon: "📋",
    title: "¿Qué bancos forman el G-7?",
    text: "¿Qué bancos conforman el grupo G-7 y cuál es su participación en el activo total del sistema a julio 2026?",
  },
];

const EXAMPLE_CATS = ["Balance y Tamaño", "Rentabilidad", "Riesgo y Morosidad", "Capitalización", "Reservas y Calificación", "Directorio"];
const CAT_COLORS = {
  "Balance y Tamaño":       C.blue,
  "Rentabilidad":           C.green,
  "Riesgo y Morosidad":     C.red,
  "Capitalización":         C.purple,
  "Reservas y Calificación":C.gold,
  "Directorio":             C.muted,
};

// ─── WELCOME SCREEN ───────────────────────────────────────────────────────────
function WelcomeScreen({ onStaticPrompt, onExamplePrompt, onGoToPrompts }) {
  const [activeCat, setActiveCat] = useState(EXAMPLE_CATS[0]);

  return (
    <div style={{ flex: 1, overflowY: "auto", padding: "28px 32px", display: "flex", flexDirection: "column", gap: 28 }}>
      <style>{`
        .wp-card:hover { border-color: ${C.gold}88 !important; transform: translateY(-2px); box-shadow: 0 6px 24px ${C.goldGlow}; }
        .wp-card { transition: all 0.18s; }
        .wp-static:hover { border-color: ${C.gold}66 !important; background: ${C.card} !important; }
        .wp-static { transition: all 0.18s; }
        .wp-cat:hover { border-color: ${C.gold}55 !important; color: ${C.text} !important; }
      `}</style>

      {/* Sección: Explora EMRISK */}
      <div>
        <div style={{ fontSize: 14, fontFamily: "monospace", color: C.gold, letterSpacing: "0.1em", marginBottom: 12 }}>
          CONOCE EL SISTEMA
        </div>
        <div style={{ display: "grid", gridTemplateColumns: "repeat(3, 1fr)", gap: 10 }}>
          {STATIC_PROMPTS.map(p => (
            <button key={p.id} className="wp-static" onClick={() => onStaticPrompt(p)}
              style={{
                textAlign: "left", cursor: "pointer", padding: "14px 16px",
                background: "#0d1a2a", border: `1px solid ${C.border}`,
                borderRadius: 10, display: "flex", flexDirection: "column", gap: 8,
              }}>
              <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                <span style={{ fontSize: 16, color: C.gold }}>{p.icon}</span>
                <span style={{ fontSize: 12, fontFamily: "monospace", color: C.gold, letterSpacing: "0.07em",
                  padding: "2px 7px", borderRadius: 3, background: `${C.gold}15`, border: `1px solid ${C.gold}22` }}>
                  {p.tag}
                </span>
              </div>
              <div style={{ fontSize: 16, color: C.text, fontWeight: 500, lineHeight: 1.4 }}>{p.title}</div>
            </button>
          ))}
        </div>
      </div>

      {/* Separador */}
      <div style={{ borderTop: `1px solid ${C.border}` }} />

      {/* Sección: Consultas de ejemplo */}
      <div>
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 14 }}>
          <div style={{ fontSize: 14, fontFamily: "monospace", color: C.gold, letterSpacing: "0.1em" }}>
            CONSULTAS DE EJEMPLO
          </div>
          <button onClick={onGoToPrompts}
            style={{ background: "none", border: "none", cursor: "pointer", fontSize: 14,
              color: C.muted, fontFamily: "monospace", textDecoration: "underline", textUnderlineOffset: 3 }}>
            Ver repositorio completo →
          </button>
        </div>

        {/* Selector de categoría */}
        <div style={{ display: "flex", gap: 6, flexWrap: "wrap", marginBottom: 14 }}>
          {EXAMPLE_CATS.map(cat => (
            <button key={cat} className="wp-cat"
              onClick={() => setActiveCat(cat)}
              style={{
                padding: "4px 11px", borderRadius: 5, fontSize: 14, cursor: "pointer",
                fontFamily: "monospace", transition: "all 0.15s",
                background: activeCat === cat ? `${CAT_COLORS[cat]}18` : "none",
                border: `1px solid ${activeCat === cat ? CAT_COLORS[cat] + "66" : C.border}`,
                color: activeCat === cat ? CAT_COLORS[cat] : C.muted,
              }}>
              {cat}
            </button>
          ))}
        </div>

        {/* Tarjetas de la categoría activa */}
        <div style={{ display: "grid", gridTemplateColumns: "repeat(3, 1fr)", gap: 10 }}>
          {EXAMPLE_PROMPTS.filter(p => p.cat === activeCat).map(p => (
            <button key={p.id} className="wp-card" onClick={() => onExamplePrompt(p.text)}
              style={{
                textAlign: "left", cursor: "pointer", padding: "14px 16px",
                background: C.card, border: `1px solid ${C.border}`,
                borderRadius: 10, display: "flex", flexDirection: "column", gap: 8,
              }}>
              <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start" }}>
                <span style={{ fontSize: 12, fontFamily: "monospace", letterSpacing: "0.06em",
                  padding: "2px 7px", borderRadius: 3,
                  background: `${CAT_COLORS[activeCat]}15`,
                  color: CAT_COLORS[activeCat],
                  border: `1px solid ${CAT_COLORS[activeCat]}33` }}>
                  {p.icon} {p.cat}
                </span>
              </div>
              <div style={{ fontSize: 16, color: C.text, fontWeight: 500, lineHeight: 1.4 }}>{p.title}</div>
              <div style={{ fontSize: 14, color: C.muted, lineHeight: 1.55 }}>{p.text}</div>
              <div style={{ marginTop: 2, fontSize: 13, color: C.gold, fontFamily: "monospace" }}>→ Usar en el chat</div>
            </button>
          ))}
        </div>
      </div>
    </div>
  );
}

// ─── HOME SCREEN ──────────────────────────────────────────────────────────────
const HOME_MODULES = [
  { id: "reporte",     icon: "▤", color: C.gold,   title: "Reportes Ejecutivos",     desc: "Informes narrativos con análisis generado por IA, exportables a Word." },
  { id: "reportes_op", icon: "◫", color: C.blue,   title: "Monitor de Carteras",    desc: "Reportes operativos de captación, comercialización, consumo y vivienda." },
  { id: "graficas",    icon: "◱", color: C.green,  title: "Constructor Visual",      desc: "Arma tu dashboard con las gráficas que generas en tus consultas." },
  { id: "chat",        icon: "◈", color: C.gold,   title: "Analista IA",             desc: "Conversa en lenguaje natural sobre 583 conceptos del sector bancario." },
  { id: "mineria",     icon: "◉", color: C.purple, title: "Radar de Riesgos",        desc: "Concentración (HHI), detección de anomalías y proyecciones." },
  { id: "prompts",     icon: "⬡", color: C.amber,  title: "Biblioteca de Consultas", desc: "Repositorio de preguntas listas para usar y tu historial." },
];

function HomeScreen({ onNavigate, onSearch, onStaticPrompt, onExamplePrompt, onGoToPrompts }) {
  const [q, setQ] = useState("");
  return (
    <div style={{ flex: 1, overflowY: "auto", padding: "36px 40px 20px" }}>
      <style>{`
        .home-mod:hover { border-color: ${C.gold}88 !important; transform: translateY(-2px); box-shadow: 0 6px 24px ${C.goldGlow}; }
        .home-mod { transition: all 0.18s; }
      `}</style>
      <div style={{ maxWidth: 1060, margin: "0 auto" }}>

        {/* Hero */}
        <div style={{ textAlign: "center", marginBottom: 22 }}>
          <div style={{ fontSize: 27, fontWeight: 600, color: C.text }}>¿Qué quieres saber del sector bancario hoy?</div>
          <div style={{ fontSize: 15, color: C.muted, marginTop: 6 }}>Pregunta en lenguaje natural — EMRISK analiza los datos oficiales de la CNBV por ti.</div>
        </div>
        <form onSubmit={(e) => { e.preventDefault(); if (q.trim()) onSearch(q.trim()); }}
          style={{ display: "flex", gap: 10, maxWidth: 780, margin: "0 auto 36px" }}>
          <input value={q} onChange={e => setQ(e.target.value)}
            placeholder="Ej. top 10 bancos por cartera de crédito a julio 2026…"
            style={{ flex: 1, background: C.card, border: `1px solid ${C.gold}55`, borderRadius: 10,
              padding: "14px 18px", color: C.text, fontSize: 15, outline: "none", fontFamily: "inherit" }} />
          <button type="submit" style={{ background: C.gold, color: C.bg, border: "none", borderRadius: 10,
            padding: "0 24px", fontSize: 15, fontWeight: 600, cursor: "pointer" }}>Consultar →</button>
        </form>

        {/* Módulos */}
        <div style={{ fontSize: 14, fontFamily: "monospace", color: C.gold, letterSpacing: "0.1em", marginBottom: 12 }}>
          MÓDULOS
        </div>
        <div style={{ display: "grid", gridTemplateColumns: "repeat(3, 1fr)", gap: 12, marginBottom: 26 }}>
          {HOME_MODULES.map(m => (
            <button key={m.id} className="home-mod" onClick={() => onNavigate(m.id)}
              style={{
                textAlign: "left", cursor: "pointer", padding: "16px 18px",
                background: C.card, border: `1px solid ${C.border}`,
                borderRadius: 12, display: "flex", flexDirection: "column", gap: 7,
              }}>
              <div style={{ display: "flex", alignItems: "center", gap: 9 }}>
                <span style={{ fontSize: 19, color: m.color }}>{m.icon}</span>
                <span style={{ fontSize: 16, fontWeight: 600, color: C.text }}>{m.title}</span>
              </div>
              <div style={{ fontSize: 14, color: C.muted, lineHeight: 1.5 }}>{m.desc}</div>
              <div style={{ marginTop: 2, fontSize: 13, color: m.color, fontFamily: "monospace" }}>Abrir →</div>
            </button>
          ))}
        </div>

        <div style={{ borderTop: `1px solid ${C.border}` }} />

        {/* Conoce el sistema + consultas de ejemplo */}
        <WelcomeScreen onStaticPrompt={onStaticPrompt} onExamplePrompt={onExamplePrompt} onGoToPrompts={onGoToPrompts} />
      </div>
    </div>
  );
}

// ─── LOGIN SCREEN ─────────────────────────────────────────────────────────────
function LoginScreen({ onLoginGoogle, onLoginEmail, onRegisterEmail, onResetPassword, loading, error }) {
  const [mode, setMode] = useState("login"); // "login" | "register" | "reset"
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [resetSent, setResetSent] = useState(false);

  const handleEmailSubmit = async (e) => {
    e.preventDefault();
    if (mode === "reset") {
      const ok = await onResetPassword(email);
      if (ok) setResetSent(true);
    } else if (mode === "register") {
      if (password !== confirmPassword) return;
      await onRegisterEmail(email, password);
    } else {
      await onLoginEmail(email, password);
    }
  };

  const inputStyle = {
    width: "100%", padding: "10px 14px",
    background: C.card, border: `1px solid ${C.border}`,
    borderRadius: 8, color: C.text, fontSize: 16,
    fontFamily: "'DM Sans','Helvetica Neue',sans-serif",
    outline: "none", transition: "border-color 0.2s",
    boxSizing: "border-box",
  };

  return (
    <div style={{
      minHeight: "100vh", background: C.bg, display: "flex", flexDirection: "column",
      alignItems: "center", justifyContent: "center",
      fontFamily: "'DM Sans','Helvetica Neue',sans-serif",
    }}>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=DM+Sans:wght@300;400;500;600&family=DM+Mono:wght@400;500&display=swap');
        *{box-sizing:border-box;margin:0;padding:0}
        .login-card{animation:fadeUp 0.4s ease}
        @keyframes fadeUp{from{opacity:0;transform:translateY(16px)}to{opacity:1;transform:translateY(0)}}
        .google-btn:hover:not(:disabled){border-color:${C.gold} !important;box-shadow:0 0 20px ${C.goldGlow}}
        .google-btn:disabled{opacity:0.6;cursor:not-allowed}
        .email-btn:hover:not(:disabled){border-color:${C.gold} !important;box-shadow:0 0 20px ${C.goldGlow}}
        .email-btn:disabled{opacity:0.6;cursor:not-allowed}
        .login-input:focus{border-color:${C.gold} !important}
        .link-btn:hover{color:${C.gold} !important}
      `}</style>

      <div className="login-card" style={{
        width: 360, padding: "40px 36px",
        background: C.surface, border: `1px solid ${C.border}`,
        borderRadius: 16, boxShadow: `0 0 60px rgba(0,0,0,0.6)`,
        display: "flex", flexDirection: "column", alignItems: "center", gap: 0,
      }}>
        {/* Logo */}
        <img
          src="/omega_logo.png"
          alt="EMRISK"
          style={{ width: 64, height: 64, marginBottom: 20, filter: `drop-shadow(0 0 16px ${C.goldGlow})` }}
        />

        {/* Títulos */}
        <div style={{ fontSize: 22, fontWeight: 600, letterSpacing: "0.02em", marginBottom: 6 }}>EMRISK</div>
        <div style={{ fontSize: 14, color: C.muted, fontFamily: "monospace", letterSpacing: "0.1em", marginBottom: 28 }}>
          INTELIGENCIA FINANCIERA CON DATOS CNBV
        </div>

        {/* Botón Google */}
        {mode !== "reset" && (
          <>
            <button
              className="google-btn"
              onClick={onLoginGoogle}
              disabled={loading}
              style={{
                width: "100%", padding: "12px 20px",
                background: C.card, border: `1px solid ${C.border}`,
                borderRadius: 10, cursor: "pointer", color: C.text,
                fontSize: 17, fontWeight: 500,
                display: "flex", alignItems: "center", justifyContent: "center", gap: 12,
                transition: "all 0.2s",
              }}
            >
              <svg width="18" height="18" viewBox="0 0 48 48">
                <path fill="#EA4335" d="M24 9.5c3.54 0 6.71 1.22 9.21 3.6l6.85-6.85C35.9 2.38 30.47 0 24 0 14.62 0 6.51 5.38 2.56 13.22l7.98 6.19C12.43 13.72 17.74 9.5 24 9.5z"/>
                <path fill="#4285F4" d="M46.98 24.55c0-1.57-.15-3.09-.38-4.55H24v9.02h12.94c-.58 2.96-2.26 5.48-4.78 7.18l7.73 6c4.51-4.18 7.09-10.36 7.09-17.65z"/>
                <path fill="#FBBC05" d="M10.53 28.59c-.48-1.45-.76-2.99-.76-4.59s.27-3.14.76-4.59l-7.98-6.19C.92 16.46 0 20.12 0 24c0 3.88.92 7.54 2.56 10.78l7.97-6.19z"/>
                <path fill="#34A853" d="M24 48c6.48 0 11.93-2.13 15.89-5.81l-7.73-6c-2.18 1.48-4.97 2.31-8.16 2.31-6.26 0-11.57-4.22-13.47-9.91l-7.98 6.19C6.51 42.62 14.62 48 24 48z"/>
                <path fill="none" d="M0 0h48v48H0z"/>
              </svg>
              {loading ? "Iniciando sesión..." : "Continuar con Google"}
            </button>

            {/* Separador */}
            <div style={{ width: "100%", display: "flex", alignItems: "center", gap: 10, margin: "18px 0" }}>
              <div style={{ flex: 1, height: 1, background: C.border }} />
              <span style={{ fontSize: 14, color: C.muted, fontFamily: "monospace" }}>o</span>
              <div style={{ flex: 1, height: 1, background: C.border }} />
            </div>
          </>
        )}

        {/* Formulario email/contraseña */}
        <form onSubmit={handleEmailSubmit} style={{ width: "100%", display: "flex", flexDirection: "column", gap: 10 }}>

          {mode === "reset" && (
            <div style={{ fontSize: 16, color: C.muted, textAlign: "center", marginBottom: 8, lineHeight: 1.5 }}>
              Ingresa tu correo y te enviaremos un enlace para restablecer tu contraseña.
            </div>
          )}

          <input
            className="login-input"
            type="email"
            placeholder="Correo electrónico"
            value={email}
            onChange={e => setEmail(e.target.value)}
            required
            disabled={loading}
            style={inputStyle}
          />

          {mode !== "reset" && (
            <input
              className="login-input"
              type="password"
              placeholder="Contraseña"
              value={password}
              onChange={e => setPassword(e.target.value)}
              required
              disabled={loading}
              style={inputStyle}
            />
          )}

          {mode === "register" && (
            <input
              className="login-input"
              type="password"
              placeholder="Confirmar contraseña"
              value={confirmPassword}
              onChange={e => setConfirmPassword(e.target.value)}
              required
              disabled={loading}
              style={{
                ...inputStyle,
                borderColor: confirmPassword && password !== confirmPassword ? C.red : C.border,
              }}
            />
          )}

          {mode === "register" && confirmPassword && password !== confirmPassword && (
            <div style={{ fontSize: 14, color: C.red, fontFamily: "monospace" }}>Las contraseñas no coinciden</div>
          )}

          {resetSent ? (
            <div style={{ fontSize: 15, color: C.green, textAlign: "center", fontFamily: "monospace", padding: "8px 0" }}>
              ✓ Correo enviado. Revisa tu bandeja de entrada.
            </div>
          ) : (
            <button
              className="email-btn"
              type="submit"
              disabled={loading || (mode === "register" && password !== confirmPassword)}
              style={{
                width: "100%", padding: "11px 20px", marginTop: 2,
                background: `linear-gradient(135deg,${C.gold},${C.goldDim})`,
                border: "none", borderRadius: 10, cursor: "pointer",
                color: C.bg, fontSize: 17, fontWeight: 600,
                transition: "all 0.2s",
              }}
            >
              {loading
                ? "..."
                : mode === "register"
                  ? "Crear cuenta"
                  : mode === "reset"
                    ? "Enviar correo"
                    : "Iniciar sesión"}
            </button>
          )}
        </form>

        {/* Links de navegación */}
        <div style={{ marginTop: 16, display: "flex", flexDirection: "column", alignItems: "center", gap: 8, width: "100%" }}>
          {mode === "login" && (
            <>
              <button className="link-btn" onClick={() => { setMode("reset"); setResetSent(false); }} style={{ background: "none", border: "none", cursor: "pointer", fontSize: 15, color: C.muted, transition: "color 0.2s" }}>
                ¿Olvidaste tu contraseña?
              </button>
              <button className="link-btn" onClick={() => setMode("register")} style={{ background: "none", border: "none", cursor: "pointer", fontSize: 15, color: C.muted, transition: "color 0.2s" }}>
                ¿No tienes cuenta? <span style={{ color: C.gold }}>Regístrate</span>
              </button>
            </>
          )}
          {mode === "register" && (
            <button className="link-btn" onClick={() => setMode("login")} style={{ background: "none", border: "none", cursor: "pointer", fontSize: 15, color: C.muted, transition: "color 0.2s" }}>
              ¿Ya tienes cuenta? <span style={{ color: C.gold }}>Inicia sesión</span>
            </button>
          )}
          {mode === "reset" && (
            <button className="link-btn" onClick={() => { setMode("login"); setResetSent(false); }} style={{ background: "none", border: "none", cursor: "pointer", fontSize: 15, color: C.muted, transition: "color 0.2s" }}>
              ← Volver al inicio de sesión
            </button>
          )}
        </div>

        {/* Error */}
        {error && (
          <div style={{ marginTop: 12, fontSize: 15, color: C.red, textAlign: "center", fontFamily: "monospace" }}>
            {error}
          </div>
        )}

        {/* Footer */}
        <div style={{ marginTop: 24, fontSize: 13, color: C.dim, textAlign: "center", fontFamily: "monospace", lineHeight: 1.6 }}>
          Acceso restringido · Solo cuentas autorizadas<br />
          Datos CNBV confidenciales
        </div>
      </div>
    </div>
  );
}

// ─── MAIN APP ─────────────────────────────────────────────────────────────────
// ─────────────────────────────────────────────────────────────────────────────
// SOLICITAR DEMO — página de reservas nativa de Google (Appointment schedule).
// Pega aquí el enlace público de tu horario de citas de 15 min. Para EMBEBER en el
// modal usa la variante que termina en "?gv=true" (Google la sirve embebible).
// Ej.: https://calendar.google.com/calendar/appointments/schedules/AcZssZ...XYZ?gv=true
// ─────────────────────────────────────────────────────────────────────────────
const DEMO_BOOKING_URL = "https://calendar.app.google/RHhXQTrTzPv7Gr1c6";  // página de reservas (Agenda de citas, 15 min)

export default function App() {
  // ── TODOS LOS HOOKS PRIMERO (regla de React: nunca hooks después de un return) ──

  // Auth
  const [user,         setUser]         = useState(undefined); // undefined = cargando
  const [authLoading,  setAuthLoading]  = useState(false);
  const [authError,    setAuthError]    = useState(null);
  const [showDisclaimer, setShowDisclaimer] = useState(false);
  const [disclaimerChecked, setDisclaimerChecked] = useState(false);

  // App state
  const [tab,          setTab]          = useState("inicio");
  const [demoOpen,     setDemoOpen]     = useState(false);   // modal "Solicita Demo"
  useEffect(() => {
    if (!demoOpen) return;
    const onKey = e => { if (e.key === "Escape") setDemoOpen(false); };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [demoOpen]);
  const [input,        setInput]        = useState("");
  const [msgs,         setMsgs]         = useState([{
    role: "assistant",
    text: "Bienvenido a EMRISK.",
    isWelcome: true,
    time: now(), fig: null, hallazgos: [], alertas: [],
  }]);
  const [sessionId,    setSessionId]    = useState(null);
  const [agentActive,  setAgentActive]  = useState(false);
  const [agentStep,    setAgentStep]    = useState(-1);
  const [dashCharts,   setDashCharts]   = useState([]);
  const [newCount,     setNewCount]     = useState(0);
  const [toast,        setToast]        = useState(null);
  const [promptSearch, setPromptSearch] = useState("");
  const [promptSubTab, setPromptSubTab] = useState("prompts"); // "prompts" | "historial"
  const [entidadFiltro, setEntidadFiltro] = useState(null); // null = Todos
  const [showBanners,   setShowBanners]   = useState(true);
  const [promptCat,    setPromptCat]    = useState("Todos");
  const [historial,    setHistorial]    = useState([]);
  const [histLoading,  setHistLoading]  = useState(false);
  const [slashMenu,    setSlashMenu]    = useState(false);
  const [slashFilter,  setSlashFilter]  = useState("");
  const endRef = useRef(null);

  // ─── SLASH COMMANDS ──────────────────────────────────────────────────────────
  const SLASH_COMMANDS = [
    { cmd: "/balance",       label: "Balanza General",            desc: "Activo, cartera, captación, capital, EPRC",      icon: "⚖" },
    { cmd: "/resultados",    label: "Estado de Resultados",       desc: "Ingresos, gastos, margen financiero, resultado", icon: "📊" },
    { cmd: "/indicadores",   label: "Indicadores Financieros",    desc: "IMOR, ROE, ROA, NIM, TDA, ICOR",                icon: "📈" },
    { cmd: "/capitalizacion",label: "Índice de Capitalización",   desc: "ICAP, capital tier 1 y 2, solvencia",           icon: "🏦" },
    { cmd: "/calificacion",  label: "Calificación y Reservas",    desc: "Reservas, calificación de cartera A-0417",      icon: "🔍" },
  ];

  // Effects
  useEffect(() => {
    const unsub = onAuthChange(u => {
      setUser(u ?? null);
      // Mostrar disclaimer si el usuario acaba de iniciar sesión y no lo ha aceptado antes
      if (u && !localStorage.getItem(`emrisk_disclaimer_${u.email}`)) {
        setShowDisclaimer(true);
      }
    });
    return unsub;
  }, []);

  useEffect(() => { endRef.current?.scrollIntoView({ behavior: "smooth" }); }, [msgs, agentActive]);

  // Scroll al final del chat cuando se entra al tab chat (ej: desde historial o prompts)
  // o cuando cambia la cantidad de mensajes (nuevo mensaje agregado).
  // Usa "auto" para scroll instantáneo en cambio de tab; requestAnimationFrame asegura DOM listo.
  useEffect(() => {
    if (tab === "chat") {
      requestAnimationFrame(() => {
        endRef.current?.scrollIntoView({ behavior: "auto" });
      });
    }
  }, [tab, msgs.length]);

  useEffect(() => { if (tab === "graficas") setNewCount(0); }, [tab]);

  // Carga historial desde BigQuery cuando el usuario abre el tab o se autentica
  useEffect(() => {
    if (!user?.email || !(tab === "history" || (tab === "prompts" && promptSubTab === "historial"))) return;
    if (historial.length > 0) return; // ya cargado, no volver a pedir
    setHistLoading(true);
    const url = `${BACKEND_URL}/historial?usuario=${encodeURIComponent(user.email)}&limit=20`;
    console.log("[HISTORIAL] Fetching:", url);
    fetch(url)
      .then(r => { if (!r.ok) throw new Error(`HTTP ${r.status}`); return r.json(); })
      .then(data => { console.log("[HISTORIAL] items:", data.items?.length); setHistorial(data.items || []); })
      .catch(e => { console.error("[HISTORIAL] Error:", e); setHistorial([]); })
      .finally(() => setHistLoading(false));
  }, [user, tab, promptSubTab]); // eslint-disable-line

  // ── AUTH HANDLERS ────────────────────────────────────────────────────────────
  const handleLoginGoogle = async () => {
    setAuthLoading(true);
    setAuthError(null);
    try {
      await loginWithGoogle();
    } catch (e) {
      if (e.code !== "auth/popup-closed-by-user") {
        setAuthError("No se pudo iniciar sesión. Intenta de nuevo.");
      }
    }
    setAuthLoading(false);
  };

  const handleLoginEmail = async (email, password) => {
    setAuthLoading(true);
    setAuthError(null);
    try {
      await loginWithEmail(email, password);
    } catch (e) {
      const msgs = {
        "auth/user-not-found":   "No existe una cuenta con ese correo.",
        "auth/wrong-password":   "Contraseña incorrecta.",
        "auth/invalid-email":    "Correo inválido.",
        "auth/too-many-requests":"Demasiados intentos. Intenta más tarde.",
        "auth/invalid-credential": "Correo o contraseña incorrectos.",
      };
      setAuthError(msgs[e.code] || "No se pudo iniciar sesión. Intenta de nuevo.");
    }
    setAuthLoading(false);
  };

  const handleRegisterEmail = async (email, password) => {
    setAuthLoading(true);
    setAuthError(null);
    try {
      await registerWithEmail(email, password);
    } catch (e) {
      const msgs = {
        "auth/email-already-in-use": "Ya existe una cuenta con ese correo.",
        "auth/weak-password":        "La contraseña debe tener al menos 6 caracteres.",
        "auth/invalid-email":        "Correo inválido.",
      };
      setAuthError(msgs[e.code] || "No se pudo crear la cuenta. Intenta de nuevo.");
    }
    setAuthLoading(false);
  };

  const handleResetPassword = async (email) => {
    setAuthLoading(true);
    setAuthError(null);
    try {
      await resetPassword(email);
      setAuthLoading(false);
      return true;
    } catch (e) {
      const msgs = {
        "auth/user-not-found": "No existe una cuenta con ese correo.",
        "auth/invalid-email":  "Correo inválido.",
      };
      setAuthError(msgs[e.code] || "No se pudo enviar el correo. Intenta de nuevo.");
      setAuthLoading(false);
      return false;
    }
  };

  const handleLogout = () => logout();

  // ── RENDERS CONDICIONALES (después de todos los hooks) ───────────────────────
  if (user === undefined) {
    return (
      <div style={{ minHeight: "100vh", background: C.bg, display: "flex", alignItems: "center", justifyContent: "center" }}>
        <div style={{ fontSize: 14, color: C.muted, fontFamily: "monospace", letterSpacing: "0.1em" }}>VERIFICANDO SESIÓN...</div>
      </div>
    );
  }

  if (!user) {
    return (
      <LoginScreen
        onLoginGoogle={handleLoginGoogle}
        onLoginEmail={handleLoginEmail}
        onRegisterEmail={handleRegisterEmail}
        onResetPassword={handleResetPassword}
        loading={authLoading}
        error={authError}
      />
    );
  }

  const showToast = (title) => {
    setToast(title);
    setTimeout(() => setToast(null), 3200);
  };

  // ── AGENT RUNNER (conectado al backend real) ──────────────────────────────
  const runAgent = async (query) => {
    if (!query.trim() || agentActive) return;
    setAgentActive(true);
    setMsgs(prev => [...prev, { role: "user", text: query, time: now(), fig: null, hallazgos: [], alertas: [] }]);
    setInput("");

    // Lanzar la llamada al backend en paralelo con la animación
    let apiResult = null;
    let apiError  = null;
    const fetchDone = callBackend(query, sessionId, user?.email)
      .then(r  => { apiResult = r; })
      .catch(e => { apiError  = e; });

    // Animación proporcional a tiempos reales (~45s total):
    // Orch(1s=2%) → Clarif(15s=33%) → SQL(7.5s=17%) → Análisis(19s=42%) → Viz(3.5s=8%)
    // Usamos variable local `currentStep` para no depender del closure de agentStep.
    let currentStep = 0;
    const advanceTo = (step) => { currentStep = step; setAgentStep(step); };

    advanceTo(0); await sleep(1000);  // Orquestador ~1s
    advanceTo(1);                     // Clarificador

    // Cada paso: avanza si el timer vence antes de que llegue la respuesta
    const runStep = async (step, duration) => {
      await Promise.race([fetchDone, sleep(duration)]);
      if (apiResult === null && apiError === null) {
        advanceTo(step);
        return false;  // aún esperando
      }
      return true;  // respuesta llegó
    };

    const done1 = await runStep(2, 15000);  // SQL tras 15s de Clarificador
    if (!done1) {
      const done2 = await runStep(3, 7500); // Análisis tras 7.5s de SQL
      if (!done2) {
        const done3 = await runStep(4, 19000); // Viz tras 19s de Análisis
        if (!done3) {
          await fetchDone;  // esperar respuesta final en Visualizador
        }
      }
    }

    // ── Error de red ──────────────────────────────────────────────────────
    if (apiError) {
      setMsgs(prev => [...prev, {
        role: "assistant", time: now(), fig: null, hallazgos: [], alertas: [], isError: true,
        text: `No se pudo conectar con el backend: ${apiError.message}. Verifica que el servicio en Cloud Run esté activo.`,
      }]);
      setAgentActive(false); setAgentStep(-1);
      return;
    }

    // Guardar session_id para conversación multi-turno
    setSessionId(apiResult.session_id);

    // ── Clarificación: el backend pide más información ────────────────────
    if (apiResult.necesita_clarificacion) {
      setMsgs(prev => [...prev, {
        role: "assistant", time: now(), fig: null, hallazgos: [], alertas: [], isClarification: true,
        text: apiResult.pregunta_clarificacion || "Necesito más información para procesar tu consulta.",
      }]);
      setAgentActive(false); setAgentStep(-1);
      return;
    }

    // ── Respuesta completa: completar pasos pendientes rápido ─────────────
    if (currentStep < 2) { advanceTo(2); await sleep(250); }
    if (currentStep < 3) { advanceTo(3); await sleep(250); }
    if (currentStep < 4) { advanceTo(4); await sleep(250); }

    const fig        = apiResult.grafica || null;
    const chartTitle = fig ? getChartTitle(fig) : null;
    // DEBUG — quitar después de confirmar
    console.log("[EMRISK] grafica:", fig ? `✅ tipo=${fig.data?.[0]?.type}, traces=${fig.data?.length}` : "❌ null/undefined");
    console.log("[EMRISK] apiResult keys:", Object.keys(apiResult));
    if (!fig && apiResult.error) console.warn("[EMRISK][DIAG]", apiResult.error);

    setMsgs(prev => [...prev, {
      role: "assistant", time: now(),
      text:          apiResult.narrativa      || "Análisis completado con los datos disponibles.",
      fig,
      hallazgos:     apiResult.hallazgos      || [],
      alertas:       apiResult.alertas        || [],
      narrativaLarga:apiResult.narrativa_larga || null,
      notaMetodologica:  apiResult.nota_metodologica  || null,
      confianzaHallazgo: apiResult.confianza_hallazgo || null,
      confianzaCausa:    apiResult.confianza_causa    || null,
      tiempoTotal:   apiResult.tiempo_total   || null,
      id_pregunta:   apiResult.id_pregunta    || null,   // FK para feedback en BQ
    }]);

    // Auto-agregar gráfica al dashboard
if (fig && chartTitle) {
  setDashCharts(prev => {
    const narrativaExport = apiResult.narrativa_larga || apiResult.narrativa || null;
    const resumenExport   = apiResult.narrativa_larga ? (apiResult.narrativa || null) : null;
    const exists = prev.find(c => c.title === chartTitle);
    if (exists) {
      return prev.map(c =>
        c.title === chartTitle
          ? { fig, title: chartTitle, narrativa: narrativaExport, resumen: resumenExport, addedAt: Date.now() }
          : c
      );
    }
    return [...prev, { fig, title: chartTitle, narrativa: narrativaExport, resumen: resumenExport, addedAt: Date.now() }];
  });

  if (tab !== "dashboard") {
    setNewCount(n => n + 1);
    showToast(chartTitle);
  }
}

    setAgentActive(false); setAgentStep(-1);
  };

  const filteredPrompts = PROMPTS.filter(p => {
    const matchSearch = !promptSearch ||
      p.title.toLowerCase().includes(promptSearch.toLowerCase()) ||
      p.text.toLowerCase().includes(promptSearch.toLowerCase());
    const matchCat = promptCat === "Todos" || p.tag === promptCat;
    return matchSearch && matchCat;
  });

  // ── WELCOME SCREEN HANDLERS ──────────────────────────────────────────────────
  // Prompt estático: inyecta la respuesta directamente sin llamar al backend
  const handleStaticPrompt = (p) => {
    setTab("chat");
    setMsgs(prev => [
      ...prev,
      { role: "user",      text: p.title, time: now(), fig: null, hallazgos: [], alertas: [] },
      { role: "assistant", text: p.staticResponse, time: now(), fig: null, hallazgos: [], alertas: [], isStatic: true },
    ]);
  };

  // Prompt de ejemplo: pone el texto en el input para editar antes de enviar
  const handleExamplePrompt = (text) => {
    setTab("chat");
    setInput(text);
  };

  // Flag: mostrar pantalla de bienvenida solo mientras no hay msgs del usuario
  const showWelcome = msgs.length === 1 && msgs[0].isWelcome;

  return (
    <div style={{ height: "100vh", background: C.bg, color: C.text, fontFamily: "'DM Sans','Helvetica Neue',sans-serif", display: "flex", flexDirection: "column", overflow: "hidden" }}>

      {/* ── DISCLAIMER MODAL ── */}
      {showDisclaimer && (
        <div style={{
          position: "fixed", inset: 0, zIndex: 9999,
          background: "rgba(7,12,18,0.92)",
          display: "flex", alignItems: "center", justifyContent: "center",
          padding: 24,
        }}>
          <div style={{
            background: C.card, border: `1px solid ${C.border}`,
            borderRadius: 14, maxWidth: 580, width: "100%",
            padding: "32px 36px", display: "flex", flexDirection: "column", gap: 20,
            boxShadow: `0 0 60px ${C.goldGlow}`,
          }}>
            {/* Header */}
            <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
              <div style={{ width: 36, height: 36, borderRadius: 8, background: `linear-gradient(135deg, ${C.gold}, ${C.goldDim})`, display: "flex", alignItems: "center", justifyContent: "center", color: C.bg, fontWeight: 700, fontSize: 16 }}>E</div>
              <div>
                <div style={{ fontSize: 18, fontWeight: 600, color: C.text }}>EMRISK</div>
                <div style={{ fontSize: 13, color: C.muted, fontFamily: "monospace", letterSpacing: 1 }}>AVISO DE USO Y LIMITACIÓN DE RESPONSABILIDAD</div>
              </div>
            </div>

            {/* Texto */}
            <div style={{ fontSize: 15, color: C.sub, lineHeight: 1.75, fontFamily: "monospace", background: C.surface, borderRadius: 8, padding: "16px 18px", border: `1px solid ${C.border}`, maxHeight: 280, overflowY: "auto" }}>
              <p style={{ marginBottom: 12 }}>
                La información presentada en EMRISK proviene de los reportes regulatorios publicados por la <strong style={{ color: C.text }}>Comisión Nacional Bancaria y de Valores (CNBV)</strong> a través de sus portales oficiales. EMRISK es una herramienta independiente de análisis y visualización de datos; <strong style={{ color: C.text }}>no tiene afiliación, patrocinio ni respaldo de la CNBV</strong> ni de ninguna autoridad financiera mexicana.
              </p>
              <p style={{ marginBottom: 12 }}>
                La información se actualiza conforme a los periodos disponibles en las fuentes originales. La CNBV puede realizar <strong style={{ color: C.text }}>revisiones y actualizaciones retroactivas</strong> a datos de periodos previamente publicados, por lo que las cifras mostradas pueden diferir de versiones posteriores de los mismos reportes.
              </p>
              <p>
                EMRISK <strong style={{ color: C.text }}>no garantiza</strong> la exactitud, integridad, vigencia ni idoneidad de la información para ningún propósito específico. El uso de esta plataforma no constituye asesoría financiera, legal ni regulatoria. Las decisiones tomadas con base en la información aquí presentada son <strong style={{ color: C.text }}>responsabilidad exclusiva del usuario</strong>.
              </p>
            </div>

            {/* Checkbox */}
            <label style={{ display: "flex", alignItems: "center", gap: 10, cursor: "pointer" }}>
              <input type="checkbox" checked={disclaimerChecked} onChange={e => setDisclaimerChecked(e.target.checked)}
                style={{ accentColor: C.gold, width: 16, height: 16, cursor: "pointer" }} />
              <span style={{ fontSize: 15, color: C.text, fontFamily: "monospace" }}>
                He leído y acepto los términos de uso de EMRISK
              </span>
            </label>

            {/* Botón */}
            <button
              disabled={!disclaimerChecked}
              onClick={() => {
                localStorage.setItem(`emrisk_disclaimer_${user.email}`, "1");
                setShowDisclaimer(false);
                setDisclaimerChecked(false);
              }}
              style={{
                padding: "12px 0", borderRadius: 8, border: "none",
                background: disclaimerChecked ? C.gold : C.muted + "44",
                color: disclaimerChecked ? C.bg : C.muted,
                fontFamily: "monospace", fontWeight: 700, fontSize: 16,
                cursor: disclaimerChecked ? "pointer" : "not-allowed",
                transition: "all 0.2s",
              }}>
              Entendido — Continuar a EMRISK
            </button>
          </div>
        </div>
      )}
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=DM+Sans:wght@300;400;500;600&family=DM+Mono:wght@400;500&display=swap');
        *{box-sizing:border-box;margin:0;padding:0}
        ::-webkit-scrollbar{width:3px;height:3px}
        ::-webkit-scrollbar-thumb{background:#c8a96e33;border-radius:2px}
        button,input,textarea{font-family:inherit}
        input:focus,textarea:focus{outline:none}
        .nav-btn{transition:all 0.15s}.nav-btn:hover{opacity:0.9}
        .demo-cta{animation:demoGlow 2.8s ease-in-out infinite;transition:transform .15s,box-shadow .15s,filter .15s}
        .demo-cta:hover{transform:translateY(-1px);filter:brightness(1.06)}
        @keyframes demoGlow{0%,100%{box-shadow:0 0 0 rgba(216,182,122,0)}50%{box-shadow:0 0 16px rgba(216,182,122,.5)}}
        .pulse{animation:pulse 1.4s ease-in-out infinite}
        @keyframes pulse{0%,100%{opacity:.3}50%{opacity:1}}
        .msg{animation:msgIn 0.25s ease}
        @keyframes msgIn{from{opacity:0;transform:translateY(6px)}to{opacity:1;transform:translateY(0)}}
        .chip:hover{border-color:#c8a96e !important;color:#c8a96e !important}
        .pcard:hover{border-color:#c8a96e !important;transform:translateY(-2px)}
        .hitem:hover{background:#1a2535 !important}
        .toast{animation:toastIn 0.3s ease}
        @keyframes toastIn{from{opacity:0;transform:translateY(10px)}to{opacity:1;transform:translateY(0)}}
      `}</style>

      {/* ── TOAST ── */}
      {toast && (
        <div className="toast" style={{
          position: "fixed", bottom: 24, right: 24, zIndex: 999,
          background: C.card, border: `1px solid ${C.gold}44`,
          borderRadius: 8, padding: "10px 16px",
          display: "flex", alignItems: "center", gap: 10,
          boxShadow: `0 4px 24px ${C.goldGlow}`,
        }}>
          <div style={{ width: 6, height: 6, borderRadius: "50%", background: C.green, boxShadow: `0 0 6px ${C.green}` }} />
          <div>
            <div style={{ fontSize: 14, color: C.muted, fontFamily: "monospace", marginBottom: 2 }}>AGREGADO AL DASHBOARD</div>
            <div style={{ fontSize: 16, color: C.text }}>{toast}</div>
          </div>
          <div style={{ fontSize: 14, color: C.gold, fontFamily: "monospace", cursor: "pointer" }} onClick={() => setTab("graficas")}>VER →</div>
        </div>
      )}

      {/* ── HEADER ── */}
      <header style={{ background: C.surface, borderBottom: `1px solid ${C.border}`, padding: "0 28px", display: "flex", alignItems: "center", justifyContent: "space-between", height: 52, flexShrink: 0 }}>
        <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
          <img src="/omega_logo.png" alt="EMRISK" onClick={() => setTab("inicio")} style={{ width: 30, height: 30, filter: `drop-shadow(0 0 6px ${C.goldGlow})`, cursor: "pointer" }} />
          <div>
            <div style={{ fontSize: 17, fontWeight: 600, letterSpacing: "0.04em" }}>EMRISK</div>
            <div style={{ fontSize: 13, color: C.muted, fontFamily: "monospace", letterSpacing: "0.08em" }}>INTELIGENCIA FINANCIERA CON DATOS CNBV</div>
          </div>
        </div>
        <div style={{ display: "flex", alignItems: "center", gap: 16 }}>
          {/* Solicita Demo — CTA destacado en el banner */}
          <button
            className="demo-cta"
            onClick={() => setDemoOpen(true)}
            title="Agenda una demo de 15 min"
            style={{
              display: "flex", alignItems: "center", gap: 8,
              background: `linear-gradient(135deg, ${C.gold}, #b8935a)`,
              border: "none", borderRadius: 8, padding: "9px 18px",
              fontSize: 15.5, fontWeight: 700, letterSpacing: "0.01em",
              color: C.bg, cursor: "pointer",
            }}>
            <span style={{ fontSize: 16 }}>📅</span>
            <span style={{ whiteSpace: "nowrap" }}>Solicita tu Demo</span>
          </button>
          {dashCharts.length > 0 && (
            <button className="nav-btn" onClick={() => setTab("graficas")} style={{ background: "none", border: `1px solid ${C.gold}44`, borderRadius: 5, padding: "3px 10px", fontSize: 14, color: C.gold, cursor: "pointer", fontFamily: "monospace" }}>
              ⊞ {dashCharts.length} panel{dashCharts.length !== 1 ? "es" : ""}
            </button>
          )}
          {/* Usuario autenticado */}
          <div style={{ display: "flex", alignItems: "center", gap: 8, paddingLeft: 12, borderLeft: `1px solid ${C.border}` }}>
            {user.photoURL
              ? <img src={user.photoURL} alt="" style={{ width: 26, height: 26, borderRadius: "50%", border: `1px solid ${C.border}` }} referrerPolicy="no-referrer" />
              : <div style={{ width: 26, height: 26, borderRadius: "50%", background: C.card, border: `1px solid ${C.border}`, display: "flex", alignItems: "center", justifyContent: "center", fontSize: 14, color: C.gold }}>
                  {user.displayName?.[0] || user.email?.[0] || "U"}
                </div>
            }
            <div>
              <div style={{ fontSize: 15, color: C.text, fontWeight: 500, lineHeight: 1.2 }}>
                {user.displayName || user.email}
              </div>
              <div style={{ fontSize: 13, color: C.muted, fontFamily: "monospace" }}>
                {user.email}
              </div>
            </div>
            <button
              onClick={handleLogout}
              title="Cerrar sesión"
              style={{ background: "none", border: `1px solid ${C.border}`, borderRadius: 5, padding: "3px 9px", fontSize: 13, color: C.muted, cursor: "pointer", fontFamily: "monospace", transition: "all 0.15s", marginLeft: 4 }}
              onMouseEnter={e => { e.currentTarget.style.borderColor = C.red; e.currentTarget.style.color = C.red; }}
              onMouseLeave={e => { e.currentTarget.style.borderColor = C.border; e.currentTarget.style.color = C.muted; }}
            >Salir</button>
          </div>
        </div>
      </header>

      {/* ── SELECTOR DE ENTIDAD — arriba de los 3 banners ── */}
      <EntidadSelector
        entidadFiltro={entidadFiltro}
        setEntidadFiltro={setEntidadFiltro}
        showBanners={showBanners}
        onToggleBanners={() => setShowBanners(v => !v)}
      />

      {/* ── BANNERS (colapsables) ── TEMP: deshabilitado para diagnóstico */}
      {/* {showBanners && <>
        <TickerBanner
          data={BANNERS_DATA.banner1}
          bannerLabel="CALIFICACIÓN · RESERVAS"
          accentColor="#2dd4bf"
          entidadFiltro={entidadFiltro}
        />
        <TickerBanner
          data={BANNERS_DATA.banner2}
          bannerLabel="BALANCE · RESULTADOS"
          accentColor={C.gold}
          entidadFiltro={entidadFiltro}
        />
        <TickerBanner
          data={BANNERS_DATA.banner3}
          bannerLabel="KRIs · KPIs"
          accentColor={C.blue}
          entidadFiltro={entidadFiltro}
        />
      </>} */}

      {/* ── LAYOUT ── */}
      <div style={{ display: "flex", flex: 1, overflow: "hidden", minHeight: 0 }}>

        {/* Sidebar */}
        <nav style={{ width: 208, background: C.surface, borderRight: `1px solid ${C.border}`, display: "flex", flexDirection: "column", paddingTop: 14, gap: 3, flexShrink: 0 }}>
          {[
            { id: "inicio",      icon: "⌂", label: "Inicio"                  },
            { id: "reporte",     icon: "▤", label: "Reportes Ejecutivos"     },
            { id: "reportes_op", icon: "◫", label: "Monitor de Carteras"    },
            { id: "graficas",    icon: "◱", label: "Constructor Visual"      },
            { id: "chat",        icon: "◈", label: "Analista IA"             },
            { id: "mineria",     icon: "◉", label: "Radar de Riesgos"        },
            { id: "prompts",     icon: "⬡", label: "Biblioteca de Consultas" },
          ].map(n => (
            <button key={n.id} className="nav-btn" title={n.label} onClick={() => setTab(n.id)} style={{
              margin: "0 8px", padding: "9px 11px", borderRadius: 8,
              border:     tab === n.id ? `1px solid ${C.gold}44` : "1px solid transparent",
              borderLeft: tab === n.id ? `3px solid ${C.gold}` : "3px solid transparent",
              background: tab === n.id ? C.card : "none",
              color:      tab === n.id ? C.gold  : C.muted,
              cursor: "pointer", textAlign: "left",
              display: "flex", alignItems: "center", gap: 10,
              position: "relative",
            }}>
              <span style={{ fontSize: 16, width: 18, textAlign: "center", flexShrink: 0 }}>{n.icon}</span>
              <span style={{ fontSize: 14, fontWeight: tab === n.id ? 600 : 400, whiteSpace: "nowrap" }}>{n.label}</span>
              {n.id === "graficas" && newCount > 0 && (
                <div style={{
                  position: "absolute", top: "50%", right: 8, transform: "translateY(-50%)",
                  width: 16, height: 16, borderRadius: "50%",
                  background: C.gold, color: C.bg,
                  fontSize: 11, fontWeight: 700, fontFamily: "monospace",
                  display: "flex", alignItems: "center", justifyContent: "center",
                  boxShadow: `0 0 6px ${C.goldGlow}`,
                }}>{newCount}</div>
              )}
            </button>
          ))}

        </nav>

        {/* ── MODAL SOLICITA DEMO ── */}
        {demoOpen && (
          <div
            onClick={() => setDemoOpen(false)}
            style={{
              position: "fixed", inset: 0, zIndex: 1000,
              background: "rgba(0,0,0,0.55)", display: "flex",
              alignItems: "center", justifyContent: "center", padding: 16,
            }}>
            <div
              onClick={e => e.stopPropagation()}
              style={{
                width: "min(760px, 96vw)", height: "min(720px, 92vh)",
                background: C.surface, border: `1px solid ${C.border}`, borderRadius: 12,
                display: "flex", flexDirection: "column", overflow: "hidden",
                boxShadow: "0 20px 60px rgba(0,0,0,0.5)",
              }}>
              {/* Header */}
              <div style={{
                display: "flex", alignItems: "center", justifyContent: "space-between",
                padding: "12px 16px", borderBottom: `1px solid ${C.border}`, flexShrink: 0,
              }}>
                <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                  <span style={{ fontSize: 16 }}>📅</span>
                  <span style={{ fontSize: 15, fontWeight: 600, color: C.text }}>Solicita una demo · 15 min</span>
                </div>
                <button onClick={() => setDemoOpen(false)} title="Cerrar" style={{
                  background: "none", border: "none", color: C.muted, cursor: "pointer",
                  fontSize: 20, lineHeight: 1, padding: 4,
                }}>✕</button>
              </div>
              {/* Intro + CTA (siempre funciona, aunque el iframe se bloquee) */}
              <div style={{ padding: "16px 18px", flexShrink: 0 }}>
                <p style={{ margin: "0 0 6px", fontSize: 13.5, lineHeight: 1.55, color: C.sub }}>
                  Recorrido de 15 minutos por el alcance de EMRISK y sus componentes —reportes ejecutivos,
                  monitor de carteras, analista IA y radar de riesgos— con espacio para resolver tus dudas.
                </p>
                <p style={{ margin: "0 0 12px", fontSize: 12.5, color: C.muted }}>
                  Disponibilidad: <b>martes y viernes, 10:00–13:00</b> (hora Ciudad de México).
                </p>
                <a
                  href={DEMO_BOOKING_URL || "#"}
                  target="_blank" rel="noopener noreferrer"
                  style={{
                    display: "inline-flex", alignItems: "center", gap: 8,
                    fontSize: 14, fontWeight: 700, color: C.bg, background: C.gold,
                    textDecoration: "none", borderRadius: 8, padding: "10px 18px",
                    pointerEvents: DEMO_BOOKING_URL ? "auto" : "none", opacity: DEMO_BOOKING_URL ? 1 : 0.5,
                  }}>
                  📅 Agendar en Google Calendar ↗
                </a>
              </div>
              {/* Intento de calendario embebido (por si el navegador lo permite) */}
              <div style={{ flex: 1, minHeight: 0, background: "#fff", borderTop: `1px solid ${C.border}` }}>
                {DEMO_BOOKING_URL ? (
                  <iframe
                    src={DEMO_BOOKING_URL}
                    title="Agenda tu demo"
                    style={{ width: "100%", height: "100%", border: "none" }}
                  />
                ) : (
                  <div style={{
                    height: "100%", display: "flex", flexDirection: "column",
                    alignItems: "center", justifyContent: "center", gap: 12, padding: 24,
                    color: "#334155", textAlign: "center",
                  }}>
                    <div style={{ fontSize: 15, fontWeight: 600 }}>Falta configurar el enlace de reservas</div>
                    <div style={{ fontSize: 13, maxWidth: 420, lineHeight: 1.5 }}>
                      Pega tu página de reservas de Google en la constante <code>DEMO_BOOKING_URL</code> de <code>App.js</code>.
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        )}

        {/* ── INICIO TAB ── */}
        {tab === "inicio" && (
          <HomeScreen
            onNavigate={setTab}
            onSearch={(q) => { setTab("chat"); runAgent(q); }}
            onStaticPrompt={handleStaticPrompt}
            onExamplePrompt={handleExamplePrompt}
            onGoToPrompts={() => setTab("prompts")}
          />
        )}

        {/* ── CHAT TAB ── */}
        {tab === "chat" && (
          <div style={{ flex: 1, display: "flex", flexDirection: "column", overflow: "hidden" }}>

            {/* Pipeline bar */}
            {agentActive && (
              <div style={{ padding: "8px 20px", background: "#0a1520", borderBottom: `1px solid ${C.border}`, display: "flex", alignItems: "center", gap: 4, flexShrink: 0 }}>
                {STEPS.map((s, i) => (
                  <div key={s.id} style={{ display: "flex", alignItems: "center", gap: 4 }}>
                    <div style={{
                      display: "flex", alignItems: "center", gap: 5, padding: "3px 9px", borderRadius: 4,
                      background: i === agentStep ? C.card : "none",
                      border: `1px solid ${i === agentStep ? C.gold + "44" : C.border}`,
                    }}>
                      <span className={i === agentStep ? "pulse" : ""} style={{ fontSize: 15, color: i < agentStep ? C.green : i === agentStep ? C.gold : C.dim }}>
                        {i < agentStep ? "✓" : s.icon}
                      </span>
                      <span style={{ fontSize: 13, fontFamily: "monospace", color: i < agentStep ? C.green : i === agentStep ? C.gold : C.dim }}>{s.label}</span>
                    </div>
                    {i < STEPS.length - 1 && <div style={{ width: 12, height: 1, background: i < agentStep ? C.green + "44" : C.dim }} />}
                  </div>
                ))}
              </div>
            )}

            {/* Welcome Screen o Messages */}
            {showWelcome ? (
              <WelcomeScreen
                onStaticPrompt={handleStaticPrompt}
                onExamplePrompt={handleExamplePrompt}
                onGoToPrompts={() => setTab("prompts")}
              />
            ) : (
            <div style={{ flex: 1, overflowY: "auto", padding: "20px 24px", display: "flex", flexDirection: "column", gap: 14 }}>
              {msgs.map((m, i) => (
                <div key={i} className="msg" style={{ display: "flex", justifyContent: m.role === "user" ? "flex-end" : "flex-start", gap: 9, alignItems: "flex-start" }}>
                  {m.role === "assistant" && (
                    <div style={{ width: 26, height: 26, flexShrink: 0, background: `${C.gold}18`, border: `1px solid ${C.gold}33`, borderRadius: 6, display: "flex", alignItems: "center", justifyContent: "center", fontSize: 15, color: C.gold }}>Σ</div>
                  )}
                  <div style={{ maxWidth: m.fig ? "90%" : "72%" }}>
                    {/* Burbuja principal */}
                    <div style={{
                      padding: "10px 14px", fontSize: 18, lineHeight: 1.7, color: "#c8d8e8",
                      borderRadius: m.role === "user" ? "10px 3px 10px 10px" : "3px 10px 10px 10px",
                      background: m.isError
                        ? `${C.red}10`
                        : m.isClarification
                          ? `${C.blue}10`
                          : m.role === "user"
                            ? "linear-gradient(135deg,#1a3558,#1a2a44)"
                            : C.card,
                      border: `1px solid ${m.isError ? C.red + "33" : m.isClarification ? C.blue + "33" : m.role === "user" ? "#2563eb22" : C.border}`,
                    }}>
                      {m.isWelcome ? (
                        <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>
                          <div>
                            Bienvenido a <strong style={{ color: C.gold }}>EMRISK</strong> — Inteligencia financiera con datos CNBV.
                          </div>
                          <div style={{ color: C.muted, fontSize: 16, lineHeight: 1.7 }}>
                            Tengo acceso a los datos supervisados de la banca múltiple mexicana hasta <strong style={{ color: C.text }}>julio 2026</strong>. Puedo ayudarte a explorar indicadores de riesgo (IMOR, IMORA, cobertura), rentabilidad (ROA, ROE), solvencia (ICAP), balances (activo total, cartera, captación) y comparativos entre instituciones y grupos como G‑7, Hogares y Comercial Mediano.
                          </div>
                          <div style={{ fontSize: 16, color: C.muted }}>
                            Para ver ejemplos de lo que puedes consultar, revisa la sección{" "}
                            <button
                              onClick={() => setTab("prompts")}
                              style={{
                                background: "none", border: "none", padding: 0,
                                color: C.gold, cursor: "pointer", fontSize: 16,
                                fontFamily: "inherit", textDecoration: "underline",
                                textUnderlineOffset: 3,
                              }}
                            >→ Consultas de ejemplo</button>.
                          </div>
                          <div style={{ fontSize: 17, color: "#c8d8e8", marginTop: 2 }}>
                            ¿Qué análisis quieres realizar hoy?
                          </div>
                        </div>
                      ) : m.isStatic ? (
                        <div style={{ display: "flex", flexDirection: "column", gap: 2 }}>
                          {m.text.split("\n").map((line, li) => {
                            if (!line.trim()) return <div key={li} style={{ height: 6 }} />;
                            const isTree = /^[│├└─•]/.test(line.trim());
                            const parts = line.split(/(\*\*[^*]+\*\*)/g);
                            return (
                              <div key={li} style={{
                                fontSize: isTree ? 15 : 16,
                                lineHeight: 1.6,
                                fontFamily: isTree ? "monospace" : "inherit",
                                color: isTree ? C.muted : "#c8d8e8",
                                whiteSpace: "pre",
                              }}>
                                {parts.map((p, pi) =>
                                  p.startsWith("**") && p.endsWith("**")
                                    ? <strong key={pi} style={{ color: C.gold, fontFamily: "inherit" }}>{p.slice(2, -2)}</strong>
                                    : p
                                )}
                              </div>
                            );
                          })}
                        </div>
                      ) : m.text}
                    </div>

                    {/* Hallazgos */}
                    {m.hallazgos?.length > 0 && (
                      <div style={{ marginTop: 7, padding: "9px 12px", background: `${C.blue}10`, border: `1px solid ${C.blue}30`, borderRadius: 7 }}>
                        {m.hallazgos.map((h, hi) => {
                          const txt = formatItem(h);
                          // Detectar etiquetas de relevancia [alta/alto/media/medio/baja/bajo]
                          const relevanciaRegex = /\[(alt[ao]|medi[ao]|baj[ao])\]/gi;
                          const partes = [];
                          let ultimo = 0;
                          let match;
                          while ((match = relevanciaRegex.exec(txt)) !== null) {
                            if (match.index > ultimo) partes.push({ tipo: "texto", val: txt.slice(ultimo, match.index) });
                            const nivel = match[1].toLowerCase();
                            const color = /^alt/.test(nivel) ? "#3b82f6"
                                        : /^med/.test(nivel) ? "#60a5fa"
                                        : "#93c5fd";
                            partes.push({ tipo: "badge", val: match[1].toUpperCase(), color });
                            ultimo = match.index + match[0].length;
                          }
                          if (ultimo < txt.length) partes.push({ tipo: "texto", val: txt.slice(ultimo) });
                          return (
                            <div key={hi} style={{ fontSize: 16, color: "#9ab4cc", fontFamily: "monospace", marginBottom: hi < m.hallazgos.length - 1 ? 5 : 0, lineHeight: 1.55 }}>
                              ◆ {partes.map((p, pi) => p.tipo === "badge"
                                ? <span key={pi} style={{
                                    display: "inline-block", margin: "0 3px",
                                    padding: "1px 6px", borderRadius: 4,
                                    background: `${p.color}20`, border: `1px solid ${p.color}55`,
                                    color: p.color, fontSize: 13, fontWeight: 700,
                                    letterSpacing: "0.08em", verticalAlign: "middle",
                                  }}>{p.val}</span>
                                : p.val
                              )}
                            </div>
                          );
                        })}
                      </div>
                    )}

                    {/* Alertas */}
                    {m.alertas?.length > 0 && (
                      <div style={{ marginTop: 6, padding: "9px 12px", background: "#0d1a26", border: `1px solid #1e2e40`, borderRadius: 7 }}>
                        {m.alertas.map((a, ai) => {
                          const txt = formatItem(a);
                          // Detectar nivel por badge en el texto
                          const nivelMatch = txt.match(/\[(CRITICO|MODERADO|INFORMATIVO)\]/i);
                          const nivel = nivelMatch ? nivelMatch[1].toUpperCase() : null;
                          const badgeColor = nivel === "CRITICO" ? "#f87171"
                                          : nivel === "MODERADO" ? "#f59e0b"
                                          : nivel === "INFORMATIVO" ? "#60a5fa"
                                          : "#8aa4b8";
                          // Separar el badge del resto del texto
                          const textoSinBadge = txt.replace(/[⚠\s]*\[(CRITICO|MODERADO|INFORMATIVO)\]\s*/i, "").trim();
                          return (
                            <div key={ai} style={{ fontSize: 16, color: "#9ab4cc", fontFamily: "monospace", marginBottom: ai < m.alertas.length - 1 ? 8 : 0, lineHeight: 1.55 }}>
                              {nivel && (
                                <span style={{
                                  display: "inline-block", marginRight: 7, marginBottom: 2,
                                  padding: "1px 7px", borderRadius: 4,
                                  background: `${badgeColor}20`, border: `1px solid ${badgeColor}55`,
                                  color: badgeColor, fontSize: 13, fontWeight: 700,
                                  letterSpacing: "0.08em", verticalAlign: "middle",
                                }}>⚠ {nivel}</span>
                              )}
                              {textoSinBadge}
                            </div>
                          );
                        })}
                      </div>
                    )}

                    {/* Indicadores de confianza */}
                    {(m.confianzaHallazgo || m.confianzaCausa) && (
                      <div style={{ marginTop: 6, display: "flex", gap: 8, alignItems: "center", flexWrap: "wrap" }}>
                        <span style={{ fontSize: 12, fontFamily: "monospace", color: C.dim, letterSpacing: "0.08em" }}>CONFIANZA</span>
                        {m.confianzaHallazgo && (
                          <span style={{ fontSize: 12, fontFamily: "monospace", padding: "1px 8px", borderRadius: 4,
                            background: `${C.green}15`, border: `1px solid ${C.green}44`, color: C.green }}>
                            hallazgo: {m.confianzaHallazgo}</span>
                        )}
                        {m.confianzaCausa && (
                          <span style={{ fontSize: 12, fontFamily: "monospace", padding: "1px 8px", borderRadius: 4,
                            background: `${C.amber}15`, border: `1px solid ${C.amber}44`, color: C.amber }}>
                            causa: {m.confianzaCausa}</span>
                        )}
                      </div>
                    )}

                    {/* Nota metodológica (desplegable) */}
                    {m.notaMetodologica && (
                      <details style={{ marginTop: 6 }}>
                        <summary style={{ cursor: "pointer", fontSize: 12, fontFamily: "monospace", color: C.muted }}>
                          Metodología y alcance
                        </summary>
                        <div style={{ marginTop: 5, padding: "8px 11px", background: C.surface,
                          border: `1px solid ${C.border}`, borderRadius: 6, fontSize: 13,
                          color: C.sub, lineHeight: 1.6, fontFamily: "monospace" }}>
                          {m.notaMetodologica}
                        </div>
                      </details>
                    )}

                    {/* Gráfica Plotly */}
                    {m.fig && (
                      <div style={{ marginTop: 18 }}>
                        <ChartCard fig={m.fig} narrative={m.narrativaLarga || m.text} resumen={m.narrativaLarga ? m.text : null} hallazgos={m.hallazgos} alertas={m.alertas}
                          notaMetodologica={m.notaMetodologica}
                          confianzas={(m.confianzaHallazgo || m.confianzaCausa)
                            ? `Confianza del hallazgo: ${m.confianzaHallazgo || "n/d"} · ${m.confianzaCausa === "no_aplica" ? "Análisis causal: no aplica" : `Confianza de la causa: ${m.confianzaCausa || "n/d"}`}`
                            : null} compact />
                      </div>
                    )}

                    {/* Timestamp + tiempo de respuesta */}
                    <div style={{ fontSize: 13, color: C.dim, marginTop: 6, fontFamily: "monospace", display: "flex", gap: 8, justifyContent: m.role === "user" ? "flex-end" : "flex-start" }}>
                      <span>{m.time}</span>
                      {m.tiempoTotal && <span>· {m.tiempoTotal}s</span>}
                    </div>

                    {/* Feedback — conectado a BigQuery vía /feedback */}
                    {m.role === "assistant" && m.id_pregunta && !m.isError && !m.isClarification && (
                      <FeedbackBlock idPregunta={m.id_pregunta} usuario={user?.email} />
                    )}
                  </div>
                </div>
              ))}

              {/* Typing indicator — pipeline horizontal progresivo */}
              {agentActive && (
                <div style={{ display: "flex", gap: 9, alignItems: "flex-start" }}>
                  <div style={{ width: 26, height: 26, flexShrink: 0, background: `${C.gold}18`, border: `1px solid ${C.gold}33`, borderRadius: 6, display: "flex", alignItems: "center", justifyContent: "center", fontSize: 15, color: C.gold }}>Σ</div>
                  <div style={{ padding: "10px 14px", background: C.card, border: `1px solid ${C.border}`, borderRadius: "3px 10px 10px 10px", display: "flex", alignItems: "center", gap: 4, flexWrap: "wrap" }}>
                    {STEPS.map((s, i) => (
                      <div key={s.id} style={{ display: "flex", alignItems: "center", gap: 4 }}>
                        {/* Paso */}
                        <div style={{ display: "flex", alignItems: "center", gap: 4 }}>
                          <span className={i === agentStep ? "pulse" : ""} style={{
                            fontSize: 14,
                            color: i < agentStep ? C.green : i === agentStep ? C.gold : C.dim,
                          }}>
                            {i < agentStep ? "✓" : s.icon}
                          </span>
                          <span style={{
                            fontSize: 13, fontFamily: "monospace",
                            color: i < agentStep ? C.green : i === agentStep ? C.gold : C.dim,
                            fontWeight: i === agentStep ? 600 : 400,
                          }}>
                            {s.label}
                          </span>
                          {/* Puntitos animados solo en el paso activo */}
                          {i === agentStep && (
                            <div style={{ display: "flex", gap: 3, alignItems: "center", marginLeft: 3 }}>
                              {[0, 1, 2].map(j => (
                                <div key={j} className="pulse" style={{ width: 4, height: 4, borderRadius: "50%", background: C.gold, animationDelay: `${j * 0.2}s` }} />
                              ))}
                            </div>
                          )}
                        </div>
                        {/* Separador → entre pasos */}
                        {i < STEPS.length - 1 && (
                          <span style={{ fontSize: 12, color: i < agentStep ? C.green + "88" : C.dim, marginLeft: 2 }}>→</span>
                        )}
                      </div>
                    ))}
                  </div>
                </div>
              )}
              <div ref={endRef} />
            </div>
            )}

            {/* Input */}
            <div style={{ padding: "14px 20px", borderTop: `1px solid ${C.border}`, background: C.surface, flexShrink: 0 }}>

              {/* Slash-command menu flotante */}
              {slashMenu && (() => {
                const filtered = SLASH_COMMANDS.filter(c =>
                  c.cmd.includes(slashFilter) || c.label.toLowerCase().includes(slashFilter.toLowerCase())
                );
                return filtered.length > 0 ? (
                  <div style={{
                    position: "relative", marginBottom: 8,
                    background: C.card, border: `1px solid ${C.gold}44`,
                    borderRadius: 10, overflow: "hidden",
                    boxShadow: `0 -4px 24px rgba(0,0,0,0.4)`,
                  }}>
                    <div style={{ padding: "7px 14px 5px", fontSize: 13, color: C.muted, letterSpacing: 1, borderBottom: `1px solid ${C.border}` }}>
                      ACCESO RÁPIDO — escribe para filtrar
                    </div>
                    {filtered.map((c, i) => (
                      <div key={c.cmd}
                        onClick={() => {
                          // Reemplazar todo hasta el espacio del slash-command con el comando seleccionado
                          const afterSlash = input.slice(input.lastIndexOf("/"));
                          const hasSpace = afterSlash.includes(" ");
                          const resto = hasSpace ? input.slice(input.lastIndexOf("/") + afterSlash.indexOf(" ")) : " ";
                          setInput(c.cmd + resto);
                          setSlashMenu(false);
                          setSlashFilter("");
                        }}
                        style={{
                          display: "flex", alignItems: "center", gap: 12,
                          padding: "9px 14px", cursor: "pointer",
                          borderBottom: i < filtered.length - 1 ? `1px solid ${C.border}` : "none",
                          transition: "background 0.12s",
                        }}
                        onMouseEnter={e => e.currentTarget.style.background = `${C.gold}11`}
                        onMouseLeave={e => e.currentTarget.style.background = "transparent"}
                      >
                        <span style={{ fontSize: 16, width: 22, textAlign: "center" }}>{c.icon}</span>
                        <div style={{ flex: 1, minWidth: 0 }}>
                          <div style={{ display: "flex", alignItems: "baseline", gap: 8 }}>
                            <span style={{ fontFamily: "monospace", fontSize: 15, color: C.gold, fontWeight: 600 }}>{c.cmd}</span>
                            <span style={{ fontSize: 15, color: C.text, fontWeight: 500 }}>{c.label}</span>
                          </div>
                          <div style={{ fontSize: 14, color: C.muted, marginTop: 1, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>{c.desc}</div>
                        </div>
                      </div>
                    ))}
                  </div>
                ) : null;
              })()}

              <div style={{ display: "flex", gap: 10, background: C.card, border: `1px solid ${slashMenu ? C.gold + "66" : C.border}`, borderRadius: 10, padding: "10px 14px", alignItems: "flex-end", transition: "border-color 0.15s" }}>
                <textarea
                  value={input}
                  onChange={e => {
                    const val = e.target.value;
                    setInput(val);
                    // Detectar si hay un "/" activo para mostrar el menú
                    const lastSlash = val.lastIndexOf("/");
                    if (lastSlash !== -1) {
                      const afterSlash = val.slice(lastSlash + 1);
                      // Mostrar menú si no hay espacio después del slash (usuario aún escribiendo el comando)
                      if (!afterSlash.includes(" ")) {
                        setSlashMenu(true);
                        setSlashFilter(afterSlash);
                        return;
                      }
                    }
                    setSlashMenu(false);
                    setSlashFilter("");
                  }}
                  onKeyDown={e => {
                    if (e.key === "Escape") { setSlashMenu(false); setSlashFilter(""); return; }
                    if (e.key === "Enter" && !e.shiftKey) { e.preventDefault(); runAgent(input); setSlashMenu(false); }
                  }}
                  placeholder="Consulta a EMRISK… escribe / para filtrar por bloque"
                  rows={1} style={{ flex: 1, background: "none", border: "none", color: C.text, fontSize: 17, resize: "none", lineHeight: 1.5 }}
                />
                <button onClick={() => { runAgent(input); setSlashMenu(false); }} disabled={!input.trim() || agentActive}
                  style={{ background: input.trim() && !agentActive ? C.gold : C.card, color: input.trim() && !agentActive ? C.bg : C.dim,
                    border: "none", borderRadius: 10, padding: "10px 22px", fontSize: 15, fontWeight: 600,
                    cursor: input.trim() && !agentActive ? "pointer" : "default", transition: "all 0.15s", flexShrink: 0 }}>Consultar →</button>
              </div>
              <div style={{ marginTop: 8 }}>
                <button onClick={() => setTab("prompts")} style={{
                  background: "none", border: "none", cursor: "pointer",
                  fontSize: 14, color: C.gold, fontFamily: "monospace", textDecoration: "underline",
                  textUnderlineOffset: 3, padding: "3px 0",
                }}>Ver ejemplos &#8594;</button>
              </div>
            </div>
          </div>
        )}

        {/* ── DASHBOARD TAB ── */}
        {tab === "dashboard" && (
          <div style={{ flex: 1, overflowY: "auto", padding: 24 }}>
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 20 }}>
              <div>
                <div style={{ fontSize: 16, fontWeight: 600 }}>Constructor Visual</div>
                <div style={{ fontSize: 15, color: C.muted }}>Gráficas generadas por el análisis · {dashCharts.length} panel{dashCharts.length !== 1 ? "es" : ""}</div>
              </div>
              {dashCharts.length > 0 && (
                <button onClick={() => setDashCharts([])} style={{ background: "none", border: `1px solid ${C.border}`, borderRadius: 5, padding: "4px 12px", fontSize: 14, color: C.muted, cursor: "pointer", fontFamily: "monospace" }}>Limpiar</button>
              )}
            </div>

            {dashCharts.length === 0 ? (
              <div style={{ textAlign: "center", padding: "60px 0", color: C.muted }}>
                <div style={{ fontSize: 32, marginBottom: 12, opacity: 0.3 }}>⊞</div>
                <div style={{ fontSize: 17, marginBottom: 6 }}>Tu dashboard está vacío</div>
                <div style={{ fontSize: 15 }}>Las gráficas se agregan automáticamente al realizar una consulta en el chat</div>
              </div>
            ) : (
              <div style={{ display: "grid", gridTemplateColumns: dashCharts.length === 1 ? "1fr" : "1fr 1fr", gap: 16 }}>
                {dashCharts.map((c, i) => (
                  <div key={i}>

		   <ChartCard
  			fig={c.fig}
  			title={c.title}
  			narrative={c.narrativa || null}
  			resumen={c.resumen || null}
  			compact={false}
  			inDash
  			onRemove={() => setDashCharts(prev => prev.filter((_, j) => j !== i))}
		/>
                  </div>
                ))}
              </div>
            )}
          </div>
        )}

        {/* ── HISTORY TAB ── */}
        {tab === "history" && (
          <div style={{ flex: 1, overflowY: "auto", padding: 24 }}>
            <div style={{ marginBottom: 18 }}>
              <div style={{ fontSize: 16, fontWeight: 600, marginBottom: 4 }}>Historial de Consultas</div>
              <div style={{ fontSize: 15, color: C.muted }}>
                Tus últimas 20 consultas exitosas · datos en tiempo real
              </div>
            </div>

            {/* ── Skeleton de carga ── */}
            {histLoading && (
              <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
                {[1,2,3,4,5].map(i => (
                  <div key={i} style={{ padding: "13px 16px", background: C.card, border: `1px solid ${C.border}`, borderRadius: 8 }}>
                    <div style={{ height: 14, borderRadius: 4, background: `${C.border}`, marginBottom: 8, width: `${55 + i * 8}%`,
                      animation: "pulse 1.4s ease-in-out infinite", animationDelay: `${i * 0.1}s` }} />
                    <div style={{ height: 10, borderRadius: 4, background: `${C.border}`, width: "30%",
                      animation: "pulse 1.4s ease-in-out infinite", animationDelay: `${i * 0.15}s` }} />
                  </div>
                ))}
              </div>
            )}

            {/* ── Sin resultados ── */}
            {!histLoading && historial.length === 0 && (
              <div style={{ textAlign: "center", padding: "60px 0", color: C.muted }}>
                <div style={{ fontSize: 32, marginBottom: 12, opacity: 0.3 }}>◎</div>
                <div style={{ fontSize: 17, marginBottom: 6 }}>Sin consultas registradas aún</div>
                <div style={{ fontSize: 15 }}>Tus consultas aparecerán aquí después de realizarlas en el chat</div>
              </div>
            )}

            {/* ── Lista real ── */}
            {!histLoading && historial.length > 0 && (
              <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
                {historial.map(h => {
                  // Formatear timestamp relativo
                  const ts = h.timestamp ? new Date(h.timestamp) : null;
                  const diffMs = ts ? Date.now() - ts.getTime() : null;
                  const diffH  = diffMs ? Math.floor(diffMs / 3600000) : null;
                  const label  = diffH === null      ? ""
                               : diffH < 1           ? "hace menos de 1h"
                               : diffH < 24          ? `hace ${diffH}h`
                               : diffH < 48          ? "ayer"
                               : ts.toLocaleDateString("es-MX", { day: "2-digit", month: "short" });
                  return (
                    <div key={h.id_pregunta} className="hitem"
                      onClick={() => { setTab("chat"); runAgent(h.pregunta_clarificada); }}
                      style={{ padding: "13px 16px", background: C.card, border: `1px solid ${C.border}`,
                        borderRadius: 8, display: "flex", justifyContent: "space-between",
                        gap: 12, cursor: "pointer", transition: "background 0.15s" }}>
                      <div style={{ flex: 1, minWidth: 0 }}>
                        <div style={{ fontSize: 17, color: C.text, marginBottom: 4,
                          overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
                          {h.pregunta_clarificada}
                        </div>
                        <div style={{ fontSize: 14, color: C.dim, fontFamily: "monospace" }}>
                          {ts ? ts.toLocaleString("es-MX", { day: "2-digit", month: "short", hour: "2-digit", minute: "2-digit" }) : ""}
                        </div>
                      </div>
                      <div style={{ fontSize: 14, color: C.muted, fontFamily: "monospace", flexShrink: 0, paddingTop: 2 }}>
                        {label}
                      </div>
                    </div>
                  );
                })}
              </div>
            )}
          </div>
        )}

        {/* ── PROMPTS TAB ── */}
        {tab === "prompts" && (
          <div style={{ flex: 1, overflowY: "auto", padding: 24 }}>
            {/* Header */}
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", marginBottom: 16 }}>
              <div>
                <div style={{ fontSize: 16, fontWeight: 600, marginBottom: 4 }}>
                  {promptSubTab === "prompts" ? "Biblioteca de Consultas" : "Historial de Consultas"}
                </div>
                <div style={{ fontSize: 15, color: C.muted }}>
                  {promptSubTab === "prompts" ? "Consultas de ejemplo · haz clic para enviar al chat" : "Tus últimas 20 consultas exitosas · datos en tiempo real"}
                </div>
              </div>
              <button onClick={() => setTab("chat")} style={{
                background: "none", border: `1px solid ${C.border}`, borderRadius: 5,
                padding: "5px 12px", fontSize: 14, color: C.muted, cursor: "pointer",
                fontFamily: "monospace", transition: "all 0.15s", display: "flex", alignItems: "center", gap: 5,
              }}
                onMouseEnter={e => { e.currentTarget.style.borderColor = C.gold; e.currentTarget.style.color = C.gold; }}
                onMouseLeave={e => { e.currentTarget.style.borderColor = C.border; e.currentTarget.style.color = C.muted; }}
              >&#8592; Volver al chat</button>
            </div>

            {/* Sub-tabs */}
            <div style={{ display: "flex", gap: 4, marginBottom: 18, borderBottom: `1px solid ${C.border}`, paddingBottom: 0 }}>
              {[{ id: "prompts", label: "Prompts" }, { id: "historial", label: "Historial" }].map(st => (
                <button key={st.id} onClick={() => setPromptSubTab(st.id)} style={{
                  background: "none", border: "none", borderBottom: promptSubTab === st.id ? `2px solid ${C.gold}` : "2px solid transparent",
                  padding: "8px 16px", fontSize: 16, cursor: "pointer", fontFamily: "monospace",
                  color: promptSubTab === st.id ? C.gold : C.muted, marginBottom: -1,
                  transition: "all 0.15s",
                }}>{st.label}</button>
              ))}
            </div>

            {/* ── Contenido: Prompts ── */}
            {promptSubTab === "prompts" && (<>
              <div style={{ background: C.card, border: `1px solid ${C.border}`, borderRadius: 8, padding: "9px 14px", display: "flex", gap: 8, marginBottom: 14 }}>
                <span style={{ color: C.muted, fontSize: 17 }}>⌕</span>
                <input value={promptSearch} onChange={e => setPromptSearch(e.target.value)} placeholder="Buscar prompts..."
                  style={{ flex: 1, background: "none", border: "none", color: C.text, fontSize: 17 }} />
              </div>
              <div style={{ display: "flex", gap: 6, flexWrap: "wrap", marginBottom: 16 }}>
                {["Todos", "Balance", "Rentabilidad", "Riesgo", "Capitalización", "Reservas", "Quitas", "Directorio"].map(cat => {
                  const active = promptCat === cat;
                  const color = TAG_COLORS[cat] || C.gold;
                  return (
                    <button key={cat} onClick={() => { setPromptCat(cat); setPromptSearch(""); }} style={{
                      padding: "4px 11px", borderRadius: 5, fontSize: 14, cursor: "pointer",
                      fontFamily: "monospace", transition: "all 0.15s",
                      background: active ? `${color}18` : "none",
                      border: `1px solid ${active ? color + "66" : C.border}`,
                      color: active ? color : C.muted,
                    }}>{cat}</button>
                  );
                })}
              </div>
              <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 12 }}>
                {filteredPrompts.map(p => (
                  <div key={p.id} className="pcard"
                    onClick={() => { setTab("chat"); setInput(p.text); }}
                    style={{ padding: 16, background: C.card, border: `1px solid ${C.border}`, borderRadius: 8, cursor: "pointer", transition: "all 0.18s" }}>
                    <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", marginBottom: 8, gap: 8 }}>
                      <div style={{ fontSize: 17, fontWeight: 500, lineHeight: 1.3 }}>{p.title}</div>
                      <div style={{ flexShrink: 0, padding: "2px 8px", borderRadius: 4, fontSize: 13, fontFamily: "monospace", background: `${TAG_COLORS[p.tag]}18`, color: TAG_COLORS[p.tag], border: `1px solid ${TAG_COLORS[p.tag]}33` }}>{p.tag}</div>
                    </div>
                    <div style={{ fontSize: 14, color: C.muted, lineHeight: 1.55 }}>{p.text}</div>
                    <div style={{ marginTop: 10, fontSize: 13, color: C.gold, fontFamily: "monospace" }}>→ Usar en el chat</div>
                  </div>
                ))}
              </div>
            </>)}

            {/* ── Contenido: Historial ── */}
            {promptSubTab === "historial" && (<>
              {histLoading && (
                <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
                  {[1,2,3,4,5].map(i => (
                    <div key={i} style={{ padding: "13px 16px", background: C.card, border: `1px solid ${C.border}`, borderRadius: 8 }}>
                      <div style={{ height: 14, borderRadius: 4, background: C.border, marginBottom: 8, width: `${55 + i * 8}%`, animation: "pulse 1.4s ease-in-out infinite" }} />
                      <div style={{ height: 10, borderRadius: 4, background: C.border, width: "30%", animation: "pulse 1.4s ease-in-out infinite" }} />
                    </div>
                  ))}
                </div>
              )}
              {!histLoading && historial.length === 0 && (
                <div style={{ textAlign: "center", padding: "60px 0", color: C.muted }}>
                  <div style={{ fontSize: 32, marginBottom: 12, opacity: 0.3 }}>◎</div>
                  <div style={{ fontSize: 17, marginBottom: 6 }}>Sin consultas registradas aún</div>
                  <div style={{ fontSize: 15 }}>Tus consultas aparecerán aquí después de realizarlas en el chat</div>
                </div>
              )}
              {!histLoading && historial.length > 0 && (
                <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
                  {historial.map(h => {
                    const ts = h.timestamp ? new Date(h.timestamp) : null;
                    const diffMs = ts ? Date.now() - ts.getTime() : null;
                    const diffH  = diffMs ? Math.floor(diffMs / 3600000) : null;
                    const label  = diffH === null ? "" : diffH < 1 ? "hace menos de 1h" : diffH < 24 ? `hace ${diffH}h` : diffH < 48 ? "ayer" : ts.toLocaleDateString("es-MX", { day: "2-digit", month: "short" });
                    return (
                      <div key={h.id_pregunta} className="hitem"
                        onClick={() => { setTab("chat"); runAgent(h.pregunta_clarificada); }}
                        style={{ padding: "13px 16px", background: C.card, border: `1px solid ${C.border}`,
                          borderRadius: 8, display: "flex", justifyContent: "space-between",
                          gap: 12, cursor: "pointer", transition: "background 0.15s" }}>
                        <div style={{ flex: 1, minWidth: 0 }}>
                          <div style={{ fontSize: 17, color: C.text, marginBottom: 4, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
                            {h.pregunta_clarificada}
                          </div>
                          <div style={{ fontSize: 14, color: C.dim, fontFamily: "monospace" }}>
                            {ts ? ts.toLocaleString("es-MX", { day: "2-digit", month: "short", hour: "2-digit", minute: "2-digit" }) : ""}
                          </div>
                        </div>
                        <div style={{ fontSize: 14, color: C.muted, fontFamily: "monospace", flexShrink: 0, paddingTop: 2 }}>{label}</div>
                      </div>
                    );
                  })}
                </div>
              )}
            </>)}
          </div>
        )}

        {/* ── REPORTE TAB ── (siempre montado para preservar estado) */}
        <div style={{ display: tab === "reporte" ? "flex" : "none", flex: 1, flexDirection: "column", overflow: "hidden" }}>
          <ReporteView user={user} />
        </div>

        {/* ── REPORTES OPERATIVOS TAB ── */}
        <div style={{ display: tab === "reportes_op" ? "flex" : "none", flex: 1, flexDirection: "column", overflow: "hidden" }}>
          <ReportesOperativosView user={user} />
        </div>

        {/* ── GRÁFICAS TAB ── */}
        <div style={{ display: tab === "graficas" ? "flex" : "none", flex: 1, flexDirection: "column", overflow: "hidden" }}>
          <GraficasView dashCharts={dashCharts} setDashCharts={setDashCharts} ChartCard={ChartCard} userEmail={user?.email || ""} />
        </div>

        {/* ── MINERÍA TAB ── (siempre montado para preservar estado del análisis) */}
        <div style={{ display: tab === "mineria" ? "flex" : "none", flex: 1, flexDirection: "column", overflow: "hidden" }}>
          <MineriaView user={user} />
        </div>

      </div>
    </div>
  );
}
// ─────────────────────────────────────────────────────────────────────────────
// REPORTES OPERATIVOS — contenedor con sub-nav
// ─────────────────────────────────────────────────────────────────────────────
function ReportesOperativosView({ user }) {
  const [subTab, setSubTab] = useState("captacion");

  const SUB_TABS = [
    { id: "captacion",   label: "Captación"         },
    { id: "comercial",   label: "Cartera Comercial"  },
    { id: "consumo",     label: "Cartera Consumo"    },
    { id: "vivienda",    label: "Cartera Vivienda"   },
  ];

  return (
    <div style={{ display: "flex", flex: 1, flexDirection: "column", overflow: "hidden" }}>
      {/* Sub-nav */}
      <div style={{
        display: "flex", alignItems: "center", gap: 2,
        padding: "0 20px",
        background: C.surface, borderBottom: `1px solid ${C.border}`,
        flexShrink: 0,
      }}>
        {SUB_TABS.map(t => (
          <button key={t.id} onClick={() => setSubTab(t.id)} style={{
            padding: "10px 16px", fontSize: 15, fontFamily: "monospace",
            cursor: "pointer", border: "none", background: "none",
            color: subTab === t.id ? C.gold : C.muted,
            borderBottom: `2px solid ${subTab === t.id ? C.gold : "transparent"}`,
            transition: "all 0.15s",
          }}>
            {t.label}
          </button>
        ))}
      </div>
      {/* Contenido */}
      <div style={{ display: subTab === "captacion" ? "flex" : "none", flex: 1, flexDirection: "column", overflow: "hidden" }}>
        <ReporteCaptacion user={user} />
      </div>
      <div style={{ display: subTab === "comercial" ? "flex" : "none", flex: 1, flexDirection: "column", overflow: "hidden" }}>
        <ReporteComercializacion user={user} />
      </div>
      <div style={{ display: subTab === "consumo" ? "flex" : "none", flex: 1, flexDirection: "column", overflow: "hidden" }}>
        <ReporteConsumo user={user} />
      </div>
      <div style={{ display: subTab === "vivienda" ? "flex" : "none", flex: 1, flexDirection: "column", overflow: "hidden" }}>
        <ReporteVivienda user={user} />
      </div>
    </div>
  );
}

// ─────────────────────────────────────────────────────────────────────────────
// REPORTE GENERATIVO — componente autocontenido
// ─────────────────────────────────────────────────────────────────────────────
function ReporteView({ user }) {
  // C — usa la paleta global de theme.js

  const [seleccionados,  setSeleccionados] = useState([]);  // 1 grupo o 1 banco
  const [busquedaBanco, setBusquedaBanco] = useState("");
  const [modoSeleccion, setModoSeleccion] = useState("grupo"); // "grupo" | "banco"
  const [tipoReporte,   setTipoReporte]   = useState("ejecutivo");
  const [horizonte,     setHorizonte]     = useState(3);   // meses de histórico: 3, 6 o 12
  const [instrucciones, setInstrucciones] = useState("");
  const [loading,       setLoading]       = useState(false);
  const [progMsg,       setProgMsg]       = useState("");
  const [resultado,     setResultado]     = useState(null);
  const [error,         setError]         = useState(null);

  const MAX_SELECCION = 1;

  // Lista unificada: grupos primero (incluye "Total Banca Múltiple"), luego instituciones individuales
  const GRUPOS_LISTA = GRUPOS_CNBV
    .map(g => ({ id: "g_" + g.clave, nombre: g.nombre, esGrupo: true, clave: g.clave }));

  const INSTITUCIONES_LISTA = [...new Set(BANNERS_DATA.banner2.map(r => r.nombre_entidad))]
    .sort()
    .map(nombre => ({ id: "i_" + nombre, nombre, esGrupo: false }));

  const LISTA_UNIFICADA = [...GRUPOS_LISTA, ...INSTITUCIONES_LISTA];

  // Mapeo de clave → nombre tal como aparece en bannersData (con prefijo clave)
  const CLAVE_A_NOMBRE_BANNER = {
    5:  "5 Total Banca Múltiple",
    59: "59 G-7",
    60: "60 Bancos Cambiarios",
    61: "61 Inversión y Servicios Financieros",
    62: "62 Comercial Mediano",
    63: "63 Comercial Pequeño",
    64: "64 Créditos a los Hogares",
  };
  // Sub-grupos de "Total Banca Múltiple" (clave 5)
  const SUB_GRUPOS_BANCA_MULTIPLE = [59, 60, 61, 62, 63, 64];

  // Modo banco: dado el nombre-banner de un banco, devuelve el agregado de su grupo padre.
  // Invierte INSTITUCIONES_CNBV (cada grupo 59–64 con sus bancos). Total Banca Múltiple (5) no aplica.
  function grupoDeBanco(nombreBanco) {
    for (const clave of SUB_GRUPOS_BANCA_MULTIPLE) {
      const miembros = INSTITUCIONES_CNBV[clave] || [];
      if (miembros.some(i => i.nombre === nombreBanco)) {
        return { clave, nombre: CLAVE_A_NOMBRE_BANNER[clave] };
      }
    }
    return null;
  }
  // Bandera: modo banco con un banco individual seleccionado.
  const _esModoBanco = modoSeleccion === "banco" && !!seleccionados[0] && !seleccionados[0].esGrupo;

  // Entidades que se envían al backend: grupos expandidos según checkbox "incluir miembros"
  const entidadesSeleccionadas = seleccionados.flatMap(e => {
    // Modo banco: banco foco + agregado de su grupo padre (contexto). No se expanden miembros.
    if (modoSeleccion === "banco" && !e.esGrupo) {
      const g = grupoDeBanco(e.nombre);
      return g ? [e.nombre, g.nombre] : [e.nombre];
    }
    if (!e.esGrupo) return [e.nombre];
    const nombrePadre = CLAVE_A_NOMBRE_BANNER[e.clave] || e.nombre;
    // siempre se envía el grupo junto con sus miembros
    if (e.clave === 5) {
      return [nombrePadre, ...SUB_GRUPOS_BANCA_MULTIPLE.map(c => CLAVE_A_NOMBRE_BANNER[c]).filter(Boolean)];
    }
    return [nombrePadre, ...(INSTITUCIONES_CNBV[e.clave] || []).map(i => i.nombre)];
  });

  const nombreUniverso = seleccionados.length === 0
    ? "Sin selección"
    : _esModoBanco
      ? (() => {
          const g = grupoDeBanco(seleccionados[0].nombre);
          const nb = seleccionados[0].nombre.replace(/^\d+\s+/, "");
          const ng = g ? g.nombre.replace(/^\d+\s+/, "") : "";
          return g ? `${nb} · ${ng}` : nb;
        })()
      : seleccionados.map(e => e.nombre).join(" vs ");

  // Cambiar de modo limpia la selección (un grupo no es válido como banco y viceversa).
  function cambiarModo(nuevo) {
    if (nuevo === modoSeleccion) return;
    setModoSeleccion(nuevo);
    setSeleccionados([]);
    setBusquedaBanco("");
  }

  function toggleEntidad(item) {
    setSeleccionados(prev => {
      const yaEsta = prev.some(x => x.id === item.id);
      if (yaEsta) {
        return prev.filter(x => x.id !== item.id);
      }
      if (prev.length >= MAX_SELECCION) return prev;
      return [...prev, item];
    });
  }

  function filtrarBanners() {
    // ── Modo banco: banco foco + agregado del grupo en b2/b3; solo el banco en b1 (A-0417
    //    no tiene agregado de grupo en el origen). Rama aditiva, no altera el modo grupo. ──
    if (_esModoBanco) {
      const banco = seleccionados[0].nombre;
      const g = grupoDeBanco(banco);
      const entB23 = new Set(g ? [banco, g.nombre] : [banco]);
      const entB1  = new Set([banco]);
      const filtrarBanco = (rows, ents) => rows
        .filter(r => ents.has(r.nombre_entidad))
        .filter(r => !r.reportes || r.reportes[tipoReporte] === true)
        .map(r => ({ ...r, historico: r.historico ? r.historico.slice(-horizonte) : [] }));
      return {
        datos_b1: filtrarBanco(BANNERS_DATA.banner1 || [], entB1),
        datos_b2: filtrarBanco(BANNERS_DATA.banner2,        entB23),
        datos_b3: filtrarBanco(BANNERS_DATA.banner3,        entB23),
      };
    }
    // Conjunto de entidades seleccionadas — mismo esquema para los 3 banners
    const entidades = new Set(
      seleccionados.flatMap(e => {
        if (!e.esGrupo) return [e.nombre];
        const nombrePadre = CLAVE_A_NOMBRE_BANNER[e.clave];
        // siempre se incluyen los miembros del grupo
        if (e.clave === 5)
          return [nombrePadre, ...SUB_GRUPOS_BANCA_MULTIPLE.map(c => CLAVE_A_NOMBRE_BANNER[c]).filter(Boolean)];
        return [nombrePadre, ...(INSTITUCIONES_CNBV[e.clave] || []).map(i => i.nombre)];
      })
    );

    // Banner 1 (A-0417): solo bancos individuales, no hay agregados de subgrupo.
    // Se expanden siempre los miembros de cualquier grupo seleccionado.
    const entidadesB1 = new Set(
      seleccionados.flatMap(e => {
        if (!e.esGrupo) return [e.nombre];
        return (INSTITUCIONES_CNBV[e.clave] || []).map(i => i.nombre);
      })
    );
    // Agregar "5 Total Banca Múltiple" si está seleccionado el grupo clave 5
    if (seleccionados.some(e => e.esGrupo && e.clave === 5)) {
      entidadesB1.add("5 Total Banca Múltiple");
    }

    function filtrar(rows, ents) {
      return rows
        .filter(r => ents.has(r.nombre_entidad))
        .filter(r => !r.reportes || r.reportes[tipoReporte] === true)
        .map(r => ({
          ...r,
          historico: r.historico ? r.historico.slice(-horizonte) : [],
        }));
    }

    return {
      datos_b1: filtrar(BANNERS_DATA.banner1 || [], entidadesB1),
      datos_b2: filtrar(BANNERS_DATA.banner2,        entidades),
      datos_b3: filtrar(BANNERS_DATA.banner3,        entidades),
    };
  }

  async function handleGenerar() {
    if (!entidadesSeleccionadas.length) { setError(modoSeleccion === "banco" ? "Selecciona un banco." : "Selecciona un grupo."); return; }
    setLoading(true); setError(null); setResultado(null);
    const msgs = [
      "Extrayendo señales del ruido regulatorio...",
      "Triangulando posición de riesgo en el sistema...",
      "Calibrando rangos CNBV contra los datos observados...",
      "Descifrando la narrativa detrás de los indicadores...",
      "Construyendo el mapa de exposición crediticia...",
      "Sintetizando variaciones de balance y resultados...",
      "Cotejando ICAP contra mínimos de Basilea III...",
      "Identificando outliers y señales de alerta temprana...",
      "Modelando la lectura ejecutiva del periodo...",
      "Redactando hallazgos con trazabilidad a los datos...",
      "Ponderando el contexto sectorial del universo...",
      "Ensamblando el informe con lógica institucional...",
      "Revisando coherencia entre secciones...",
      "Ajustando el tono para audiencia regulatoria...",
      "Últimos toques al análisis — casi listo...",
    ];
    let mi = Math.floor(Math.random() * 3); // arrancar en posición aleatoria de los primeros 3
    setProgMsg(msgs[mi]);
    const iv = setInterval(() => {
      mi = mi + 1 < msgs.length ? mi + 1 : mi;
      setProgMsg(msgs[mi]);
    }, 3500);
    try {
      // Modo banco: banco foco + su grupo padre como contexto (gated; no afecta el modo grupo).
      const esBanco     = _esModoBanco;
      const entidadFoco = esBanco ? seleccionados[0].nombre : null;
      const _gInfo      = esBanco ? grupoDeBanco(entidadFoco) : null;
      const grupoPadre  = _gInfo ? _gInfo.nombre : null;
      let url, body;
      if (tipoReporte === "cartera") {
        // Reporte de cartera: el backend hace SELECT directo, NO se envían banners.
        url = `${BACKEND_URL}/reporte/cartera`;
        body = {
          nombre_universo: nombreUniverso,
          modo_sistema:    seleccionados.some(e => e.esGrupo && e.clave === 5),
          entidades:       esBanco ? [entidadFoco] : entidadesSeleccionadas,
          entidad_foco:    entidadFoco,
          grupo_padre:     grupoPadre,
          periodo_fin:     BANNERS_PERIODO,
          horizonte_meses: 12,
          instrucciones:   instrucciones.trim(),
          usuario:         user ? user.email : null,
        };
      } else {
        const { datos_b1, datos_b2, datos_b3 } = filtrarBanners();
        url = `${BACKEND_URL}/reporte`;
        body = {
          entidades:       entidadesSeleccionadas,
          nombre_universo: nombreUniverso,
          tipo_universo:   esBanco ? "banco_en_grupo" : (seleccionados.some(e => e.esGrupo) ? "grupo" : "bancos_especificos"),
          modo_sistema:    seleccionados.some(e => e.esGrupo && e.clave === 5),
          periodo:         BANNERS_PERIODO,
          horizonte_meses: horizonte,
          tipo_reporte:    tipoReporte,
          instrucciones:   instrucciones.trim(),
          entidad_foco:    entidadFoco,
          grupo_padre:     grupoPadre,
          datos_b1,
          datos_b2,
          datos_b3,
          usuario:         user ? user.email : null,
        };
      }
      const resp = await fetch(url, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(body),
      });
      if (!resp.ok) {
        const e = await resp.json().catch(() => ({}));
        throw new Error(e.detail || ("Error " + resp.status));
      }
      setResultado(await resp.json());
    } catch (e) {
      setError(e.message || "Error generando el reporte.");
    } finally {
      clearInterval(iv);
      setLoading(false);
      setProgMsg("");
    }
  }

  const tiposReporte = [
    { id: "ejecutivo",              label: "Ejecutivo",              desc: "Vision general balanceada del periodo" },
    { id: "cartera",                label: "Cartera",                desc: "Evolución y calidad de la cartera de crédito (12 meses)" },
  ];

  const cardStyle = { background: C.card, border: "1px solid " + C.border, borderRadius: 8, padding: 13 };
  const labelStyle = { fontSize: 15, color: C.gold, fontFamily: "monospace", marginBottom: 9 };

  return (
    <div style={{ flex: 1, overflowY: "auto", padding: "24px 28px", background: C.bg }}>
      <div style={{ marginBottom: 20 }}>
        <div style={{ fontSize: 18, fontWeight: 600, color: C.text, marginBottom: 3 }}>Reporte Generativo</div>
        <div style={{ fontSize: 14, color: C.muted, fontFamily: "monospace" }}>
          Configura universo y tipo · El LLM analista redacta el informe completo
        </div>
      </div>

      <div style={{ display: "flex", gap: 18, alignItems: "flex-start" }}>

        {/* ── Formulario ── */}
        <div style={{ width: 290, flexShrink: 0, display: "flex", flexDirection: "column", gap: 12 }}>

          {/* 01 Entidades — lista unificada: grupos + instituciones, máx 2 */}
          <div style={cardStyle}>
            <div style={labelStyle}>01 &middot; {modoSeleccion === "banco" ? "BANCO" : "GRUPO"}</div>
            {/* Toggle Grupo | Banco — cambia la unidad de análisis del reporte */}
            <div style={{ display: "flex", gap: 6, marginBottom: 8 }}>
              {[{ id: "grupo", label: "Grupo" }, { id: "banco", label: "Banco" }].map(m => (
                <button key={m.id} onClick={() => cambiarModo(m.id)}
                  style={{
                    flex: 1, padding: "5px 0", borderRadius: 4, cursor: "pointer",
                    border: modoSeleccion === m.id ? ("1px solid " + C.gold) : ("1px solid " + C.border),
                    background: modoSeleccion === m.id ? (C.gold + "15") : "none",
                    color: modoSeleccion === m.id ? C.gold : C.muted,
                    fontSize: 14, fontWeight: modoSeleccion === m.id ? 600 : 400,
                    fontFamily: "monospace",
                  }}>
                  {m.label}
                </button>
              ))}
            </div>
            <input
              type="text"
              placeholder={modoSeleccion === "banco" ? "Buscar banco..." : "Buscar grupo..."}
              value={busquedaBanco}
              onChange={e => setBusquedaBanco(e.target.value)}
              style={{
                width: "100%", boxSizing: "border-box", marginBottom: 6,
                background: C.bg, color: C.text, border: "1px solid " + C.border,
                borderRadius: 4, fontSize: 15, padding: "6px 8px",
              }}
            />
            <div style={{
              maxHeight: 220, overflowY: "auto",
              border: "1px solid " + C.border, borderRadius: 4, padding: "2px 0",
            }}>
              {LISTA_UNIFICADA
                .filter(item => modoSeleccion === "banco" ? !item.esGrupo : item.esGrupo) // grupo → grupos; banco → instituciones individuales
                .filter(item => item.nombre.toLowerCase().includes(busquedaBanco.toLowerCase()))
                .map((item, idx, arr) => {
                  const sel = seleccionados.some(x => x.id === item.id);
                  const bloqueado = !sel && seleccionados.length >= MAX_SELECCION;
                  // separador entre grupos e instituciones
                  const esInicioInstituciones = item.esGrupo === false && (idx === 0 || arr[idx-1].esGrupo === true);
                  return (
                    <div key={item.id}>
                      {esInicioInstituciones && (
                        <div style={{
                          fontSize: 12, color: C.dim, fontFamily: "monospace",
                          padding: "4px 7px 2px", borderTop: "1px solid " + C.border,
                          letterSpacing: 1,
                        }}>INSTITUCIONES INDIVIDUALES</div>
                      )}
                      {idx === 0 && item.esGrupo && (
                        <div style={{
                          fontSize: 12, color: C.dim, fontFamily: "monospace",
                          padding: "4px 7px 2px", letterSpacing: 1,
                        }}>GRUPOS PREDEFINIDOS</div>
                      )}
                      <div
                        onClick={() => !bloqueado && toggleEntidad(item)}
                        style={{
                          padding: "5px 8px", fontSize: 15,
                          fontFamily: "monospace", display: "flex", alignItems: "center", gap: 6,
                          cursor: bloqueado ? "not-allowed" : "pointer",
                          opacity: bloqueado ? 0.35 : 1,
                          background: sel ? C.gold + "18" : "transparent",
                          color: sel ? C.gold : C.text,
                        }}>
                        <span style={{
                          width: 10, height: 10, borderRadius: 2, flexShrink: 0,
                          border: "1px solid " + (sel ? C.gold : C.muted),
                          background: sel ? C.gold : "transparent",
                          display: "inline-block",
                        }} />
                        {item.nombre}
                      </div>
                    </div>
                  );
                })}
            </div>

            {/* Contador + limpiar */}
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginTop: 5 }}>
              <span style={{ fontSize: 12, fontFamily: "monospace", color: seleccionados.length >= MAX_SELECCION ? "#3b82f6" : C.muted }}>
                {seleccionados.length}/{MAX_SELECCION} seleccionadas{seleccionados.length >= MAX_SELECCION ? " · límite alcanzado" : ""}
              </span>
              {seleccionados.length > 0 && (
                <button onClick={() => setSeleccionados([])}
                  style={{ fontSize: 12, color: C.muted, background: "none", border: "none", cursor: "pointer", padding: 0 }}>
                  Limpiar
                </button>
              )}
            </div>

            {/* Resumen */}
            {seleccionados.length > 0 && (
              <div style={{ marginTop: 7, padding: "5px 8px", background: C.gold + "10", border: "1px solid " + C.gold + "25", borderRadius: 4 }}>
                {seleccionados.map(e => (
                  <div key={e.id}>
                    <div style={{ fontSize: 13, color: C.gold, fontFamily: "monospace" }}>· {e.nombre}</div>
                  </div>
                ))}
              </div>
            )}
          </div>

          {/* 02 Tipo de reporte */}
          <div style={cardStyle}>
            <div style={labelStyle}>02 &middot; TIPO DE REPORTE</div>
            {tiposReporte.map(t => (
              <button key={t.id} onClick={() => setTipoReporte(t.id)}
                style={{
                  display: "block", width: "100%", textAlign: "left",
                  padding: "6px 8px", borderRadius: 4, marginBottom: 3, cursor: "pointer",
                  border: tipoReporte === t.id ? ("1px solid " + C.gold) : ("1px solid " + C.border),
                  background: tipoReporte === t.id ? (C.gold + "15") : "none",
                  color: tipoReporte === t.id ? C.gold : C.text,
                }}>
                <div style={{ fontSize: 16, fontWeight: 500 }}>{t.label}</div>
                <div style={{ fontSize: 14, color: tipoReporte === t.id ? C.gold : C.muted, marginTop: 1 }}>{t.desc}</div>
              </button>
            ))}
          </div>

          {/* 03 Horizonte de análisis */}
          <div style={cardStyle}>
            <div style={labelStyle}>03 &middot; HORIZONTE DE ANÁLISIS</div>
            <div style={{ display: "flex", gap: 6 }}>
              {[3, 6, 12].map(n => (
                <button key={n} onClick={() => setHorizonte(n)}
                  style={{
                    flex: 1, padding: "6px 0", borderRadius: 4, cursor: "pointer",
                    border: horizonte === n ? ("1px solid " + C.gold) : ("1px solid " + C.border),
                    background: horizonte === n ? (C.gold + "15") : "none",
                    color: horizonte === n ? C.gold : C.muted,
                    fontSize: 16, fontWeight: horizonte === n ? 600 : 400,
                    fontFamily: "monospace",
                  }}>
                  {n}M
                </button>
              ))}
            </div>
            <div style={{ fontSize: 12, color: C.dim, fontFamily: "monospace", marginTop: 5 }}>
              Periodos históricos incluidos en el análisis
            </div>
          </div>

          {/* 04 Instrucciones */}
          <div style={cardStyle}>
            <div style={labelStyle}>04 &middot; INSTRUCCIONES (opcional)</div>
            <textarea
              value={instrucciones}
              onChange={e => setInstrucciones(e.target.value)}
              rows={3}
              placeholder="Ej: Foco en cartera comercial. Tono para comite de riesgos."
              style={{
                width: "100%", boxSizing: "border-box",
                background: C.bg, color: C.text,
                border: "1px solid " + C.border, borderRadius: 4,
                fontSize: 15, fontFamily: "monospace", padding: 6, resize: "vertical",
              }} />
          </div>

          <div style={{ fontSize: 14, color: C.muted, fontFamily: "monospace", textAlign: "center" }}>
            Periodo: {BANNERS_PERIODO} &middot; Fuente: CNBV — Portafolio de Información y reportes regulatorios aplicables
          </div>

          <button
            onClick={handleGenerar}
            disabled={loading || !entidadesSeleccionadas.length}
            style={{
              width: "100%", padding: "10px 0", borderRadius: 6,
              fontSize: 14, fontWeight: 600, fontFamily: "monospace", letterSpacing: "0.04em",
              border: "1px solid " + C.gold,
              background: (loading || !entidadesSeleccionadas.length) ? C.dim : (C.gold + "20"),
              color: (loading || !entidadesSeleccionadas.length) ? C.muted : C.gold,
              cursor: (loading || !entidadesSeleccionadas.length) ? "not-allowed" : "pointer",
            }}>
            {loading ? "Generando..." : "Generar Reporte"}
          </button>

          {error && (
            <div style={{
              padding: "8px 10px", borderRadius: 4, fontSize: 14, color: "#ef4444",
              background: "#ef444415", border: "1px solid #ef444430",
            }}>
              {error}
            </div>
          )}
        </div>

        {/* ── Resultado ── */}
        <div style={{ flex: 1, minWidth: 0 }}>
          {!loading && !resultado && !error && (
            <div style={{
              display: "flex", flexDirection: "column",
              alignItems: "center", justifyContent: "center",
              height: 260, color: C.muted, gap: 9,
            }}>
              <div style={{ fontSize: 26, opacity: 0.2 }}>&#9636;</div>
              <div style={{ fontSize: 15, textAlign: "center" }}>
                Configura el universo y genera el informe
                <br />
                <span style={{ fontSize: 13, fontFamily: "monospace" }}>El analisis aparecera aqui</span>
              </div>
            </div>
          )}
          {loading && (
            <div style={{
              display: "flex", flexDirection: "column",
              alignItems: "center", justifyContent: "center",
              height: 300, gap: 18, padding: "0 24px",
            }}>
              {/* Pulso animado */}
              <div style={{ position: "relative", width: 48, height: 48 }}>
                <div style={{
                  position: "absolute", inset: 0, borderRadius: "50%",
                  border: "2px solid " + C.gold, opacity: 0.3,
                  animation: "emrisk-pulse 2s ease-in-out infinite",
                }} />
                <div style={{
                  position: "absolute", inset: 8, borderRadius: "50%",
                  border: "2px solid " + C.gold, opacity: 0.6,
                  animation: "emrisk-pulse 2s ease-in-out infinite 0.4s",
                }} />
                <div style={{
                  position: "absolute", inset: 16, borderRadius: "50%",
                  background: C.gold, opacity: 0.9,
                  animation: "emrisk-pulse 2s ease-in-out infinite 0.8s",
                }} />
              </div>
              {/* Mensaje rotante */}
              <div style={{
                fontSize: 15, color: C.gold, fontFamily: "monospace",
                letterSpacing: "0.05em", textAlign: "center",
                minHeight: 32, maxWidth: 340,
                transition: "opacity 0.5s ease",
              }}>
                {progMsg}
              </div>
              {/* Info del universo */}
              <div style={{ fontSize: 13, color: C.dim, textAlign: "center", fontFamily: "monospace", lineHeight: 1.7 }}>
                {entidadesSeleccionadas.length} entidad{entidadesSeleccionadas.length !== 1 ? "es" : ""} &middot; {tipoReporte} &middot; {nombreUniverso}
                <br/>
                <span style={{ color: C.muted }}>El análisis generativo tarda ~90 segundos</span>
              </div>
              {/* Barra de progreso indeterminada */}
              <div style={{ width: 240, height: 2, background: C.border, borderRadius: 1, overflow: "hidden" }}>
                <div style={{
                  height: "100%", width: "40%", background: C.gold, borderRadius: 1,
                  animation: "emrisk-bar 1.8s ease-in-out infinite",
                }} />
              </div>
              <style>{`
                @keyframes emrisk-pulse {
                  0%, 100% { transform: scale(1); opacity: 0.3; }
                  50% { transform: scale(1.15); opacity: 0.8; }
                }
                @keyframes emrisk-bar {
                  0% { transform: translateX(-100%); }
                  100% { transform: translateX(700%); }
                }
              `}</style>
            </div>
          )}
          {resultado && !loading && (
            (resultado.secciones && resultado.graficas) ? (
              <ReporteCarteraResultado resultado={resultado} C={C} />
            ) : (
              <ReporteResultado
                resultado={resultado}
                C={C}
                datosB1={filtrarBanners().datos_b1}
                datosB2={filtrarBanners().datos_b2}
                datosB3={filtrarBanners().datos_b3}
              />
            )
          )}
        </div>
      </div>
    </div>
  );
}

// ─────────────────────────────────────────────────────────────────────────────
// MINI BAR CHART — SVG inline sin dependencias
// ─────────────────────────────────────────────────────────────────────────────
function MiniBarChart({ datos, color, formatVal }) {
  if (!datos || !datos.length) return null;
  const max = Math.max(...datos.map(d => Math.abs(d.valor || 0))) || 1;
  const W = 560, BAR_H = 18, GAP = 6, PAD_LEFT = 170, PAD_RIGHT = 70;
  const H = datos.length * (BAR_H + GAP) + 10;
  return (
    <svg width="100%" viewBox={"0 0 " + W + " " + H} style={{ display: "block", marginTop: 6, maxWidth: 560 }}>
      {datos.map((d, i) => {
        const y = i * (BAR_H + GAP) + 5;
        const barW = Math.max(2, ((Math.abs(d.valor || 0)) / max) * (W - PAD_LEFT - PAD_RIGHT));
        const val = formatVal ? formatVal(d.valor) : (d.valor !== null && d.valor !== undefined ? d.valor.toFixed(2) : "N/D");
        return (
          <g key={i}>
            <text x={PAD_LEFT - 6} y={y + BAR_H * 0.72} textAnchor="end"
              fontSize="11" fill="#64748b" fontFamily="monospace">
              {(d.nombre || "").length > 26 ? (d.nombre || "").slice(0, 25) + "." : (d.nombre || "")}
            </text>
            <rect x={PAD_LEFT} y={y} width={barW} height={BAR_H} rx="2"
              fill={color || "#c8a84b"} opacity="0.75" />
            <text x={PAD_LEFT + barW + 5} y={y + BAR_H * 0.72}
              fontSize="11" fill="#94a3b8" fontFamily="monospace">
              {val}
            </text>
          </g>
        );
      })}
    </svg>
  );
}

// ─────────────────────────────────────────────────────────────────────────────
// TABLA DE METRICAS
// ─────────────────────────────────────────────────────────────────────────────
function TablaMetricas({ filas, C }) {
  if (!filas || !filas.length) return null;
  return (
    <div style={{ overflowX: "auto", marginTop: 10 }}>
      <table style={{ width: "100%", borderCollapse: "collapse", fontSize: 13, fontFamily: "monospace" }}>
        <thead>
          <tr style={{ borderBottom: "1px solid " + C.border }}>
            {Object.keys(filas[0]).map(k => (
              <th key={k} style={{ padding: "4px 8px", color: C.gold, textAlign: "left", fontWeight: 600 }}>{k}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          {filas.map((f, i) => (
            <tr key={i} style={{ borderBottom: "1px solid " + C.border + "55", background: i % 2 === 0 ? "transparent" : C.border + "20" }}>
              {Object.values(f).map((v, j) => (
                <td key={j} style={{ padding: "4px 8px", color: C.text }}>{v}</td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

// ─────────────────────────────────────────────────────────────────────────────
// EXTRACTOR DE DATOS graficables desde datos_b2 / datos_b3
// ─────────────────────────────────────────────────────────────────────────────
function extraerMetricasPorEntidad(datosB2, datosB3, metricas) {
  const all = [...(datosB2 || []), ...(datosB3 || [])];
  return metricas.map(function(m) {
    const filas = all.filter(function(r) { return r.label === m && r.valor_actual !== null && r.valor_actual !== undefined; });
    return { metrica: m, datos: filas.map(function(r) { return { nombre: r.nombre_entidad, valor: r.valor_actual, tipo: r.tipo }; }) };
  }).filter(function(m) { return m.datos.length > 0; });
}

function fmtMDP(v) {
  if (v == null) return "N/D";
  const mdp = v / 1e6;
  return mdp >= 1000 ? (mdp / 1000).toFixed(1) + " mmp" : mdp.toFixed(0) + " mdp";
}

function fmtPct(v) {
  if (v == null) return "N/D";
  return v.toFixed(2) + "%";
}

// GRAFICA REPORTE — renderiza una gráfica de línea o barras con SVG puro
function GraficaReporte({ datos, traces, tipo, palette, C }) {
  if (!datos || !datos.length || !traces || !traces.length) return null;
  const W = 520, H = 200, PL = 52, PR = 12, PT = 24, PB = 30;
  const innerW = W - PL - PR;
  const innerH = H - PT - PB;

  // Para barras: siempre empezar en 0. Para líneas: ajustar al rango real.
  let minV = Infinity, maxV = -Infinity;
  traces.forEach(function(t) {
    t.y.forEach(function(v) { if (v != null) { if (v < minV) minV = v; if (v > maxV) maxV = v; } });
  });
  if (tipo === "barras") { minV = Math.min(0, minV); }  // siempre incluir 0 en barras
  if (minV === maxV) { minV = minV - 1; maxV = maxV + 1; }
  // Añadir 10% de margen superior para etiquetas de valor en barras
  if (tipo === "barras") { maxV = maxV * 1.12; }
  const rangeV = maxV - minV;
  const isBar = tipo === "barras";
  const bw = isBar ? Math.max(4, (innerW / datos.length) * 0.7 / traces.length) : 0;
  const groupHalf = isBar ? ((traces.length - 1) / 2) * (bw + 2) + bw / 2 + 1 : 0;
  const x0 = PL + groupHalf, x1 = W - PR - groupHalf;
  const toX = function(i) { return x0 + (i / Math.max(datos.length - 1, 1)) * (x1 - x0); };
  const toY = function(v) { return PT + innerH - ((v - minV) / rangeV) * innerH; };

  // Formato de etiqueta Y y de valor en barra
  const absMax = Math.max(Math.abs(minV), Math.abs(maxV));
  const fmtY = absMax > 500 ? function(v) { return (v / 1000).toFixed(0) + "k"; }
             : absMax > 1   ? function(v) { return v.toFixed(1); }
             :                function(v) { return v.toFixed(2); };
  const fmtBar = absMax > 500 ? function(v) { return (v / 1000).toFixed(1) + "k"; }
               : absMax > 1   ? function(v) { return v.toFixed(1); }
               :                function(v) { return v.toFixed(2); };

  const nTicks = 4;
  const yTicks = Array.from({ length: nTicks + 1 }, function(_, i) { return minV + (rangeV * i / nTicks); });

  return (
    <svg viewBox={"0 0 " + W + " " + H} style={{ width: "100%", maxWidth: W, display: "block" }}>
      {/* Grid lines */}
      {yTicks.map(function(v, i) {
        const y = toY(v);
        return (
          <g key={i}>
            <line x1={PL} y1={y} x2={W - PR} y2={y} stroke={C.border} strokeWidth={0.5} />
            <text x={PL - 4} y={y + 3.5} textAnchor="end" fontSize={10} fill={C.dim}>{fmtY(v)}</text>
          </g>
        );
      })}
      {/* X labels */}
      {datos.map(function(d, i) {
        if (datos.length <= 8 || i % Math.ceil(datos.length / 6) === 0 || i === datos.length - 1) {
          return <text key={i} x={toX(i)} y={H - 4} textAnchor="middle" fontSize={10} fill={C.dim}>{d.x}</text>;
        }
        return null;
      })}
      {/* Traces */}
      {traces.map(function(t, ti) {
        const color = palette[ti % palette.length];
        if (tipo === "barras") {
          const offset = (ti - (traces.length - 1) / 2) * (bw + 2);
          return (
            <g key={ti}>
              {datos.map(function(d, i) {
                const v = t.y[i];
                if (v == null) return null;
                const x = toX(i) + offset - bw / 2;
                const yTop = toY(v);
                const yBase = toY(0);
                const barH = Math.abs(yTop - yBase);
                return (
                  <g key={i}>
                    <rect x={x} y={Math.min(yTop, yBase)} width={bw} height={Math.max(barH, 1)} fill={color} opacity={0.85} rx={1} />
                    {/* Etiqueta de valor encima de la barra */}
                    <text x={x + bw / 2} y={Math.min(yTop, yBase) - 3} textAnchor="middle" fontSize={9} fill={color}>{fmtBar(v)}</text>
                  </g>
                );
              })}
            </g>
          );
        }
        // Línea
        const pts = t.y.map(function(v, i) { return v != null ? toX(i) + "," + toY(v) : null; }).filter(Boolean);
        if (pts.length < 2) return null;
        return (
          <g key={ti}>
            <polyline points={pts.join(" ")} fill="none" stroke={color} strokeWidth={1.5} strokeLinejoin="round" />
            {t.y.map(function(v, i) {
              if (v == null) return null;
              return <circle key={i} cx={toX(i)} cy={toY(v)} r={2.5} fill={color} />;
            })}
          </g>
        );
      })}
    </svg>
  );
}

// REPORTE RESULTADO
// Representatividad ÚNICA (misma lógica que backend _no_representativo). Se aplica igual en
// resumen (actual/anterior) e histórico → garantiza que coincidan (corrección V8 #1).
function _noRep(metrica, v) {
  if (v == null || typeof v !== "number") return false;
  const m = (metrica || "").toLowerCase();
  if (m === "icor" || m === "eprc_sobre_cartera") return v > 500 || v <= 0;
  if (m === "imor" || m === "imora" || m === "tda") return v >= 99 || v <= 0.0001;
  return false;
}

function SeccionAnexo({ datos, C }) {
  const rows = datos || [];
  // Modo sistema (Total Banca Múltiple): la unidad es el segmento, no la institución.
  const modoSistema = rows.some(function (r) { return /^\s*5\s+Total Banca/i.test((r && r.nombre_entidad) || ""); });
  if (!rows.length) return <div style={{ color: C.muted, fontSize: 15, fontStyle: "italic" }}>Sin datos fuente disponibles.</div>;
  const porLabel = {};
  rows.forEach(function (r) { const l = r.label || "?"; (porLabel[l] = porLabel[l] || []).push(r); });
  const limpia = function (n) { return (n || "").replace(/^\d+\s+/, ""); };
  const fMDP = function (v) { return v == null ? "\u2014" : (v / 1e6).toLocaleString("es-MX", { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + " MDP"; };
  const fPct = function (v) { return v == null ? "\u2014" : Number(v).toFixed(2) + "%"; };
  const esVeces = function (l) { return /requerimiento|veces/i.test(l); };
  const MESES = ["ene", "feb", "mar", "abr", "may", "jun", "jul", "ago", "sep", "oct", "nov", "dic"];
  const pLabel = function (p) { const y = Math.floor(p / 100), mo = p % 100; return (MESES[mo - 1] || "?") + " " + String(y).slice(2); };
  const th = { padding: "4px 8px", textAlign: "left", fontSize: 11, fontFamily: "monospace", color: C.gold, borderBottom: "1px solid " + C.border };
  const thr = Object.assign({}, th, { textAlign: "right" });
  const td = { padding: "4px 8px", fontSize: 13, color: C.text, borderBottom: "1px solid " + C.border + "33" };
  const tdr = Object.assign({}, td, { textAlign: "right" });
  const tdrs = Object.assign({}, tdr, { fontSize: 12 });
  return (
    <div style={{ display: "flex", flexDirection: "column", gap: 18 }}>
      <div style={{ fontSize: 12, color: C.muted, fontStyle: "italic" }}>Datos fuente (CNBV) usados para este reporte. Cifras deterministas, no generadas por el modelo.</div>
      <div style={{ fontSize: 12, color: C.muted }}>Nota: el ICOR y la narrativa de cobertura usan el saldo de EPRC del <b>balance</b>. Las cifras de EPRC <b>A-0417</b> se presentan como fuente complementaria y no necesariamente coinciden, por diferencias de integración y clasificación. Los ratios con denominador ~0 se marcan "no representativo".</div>
      {Object.keys(porLabel).map(function (label) {
        // En modo sistema las Alertas Tempranas (clasificación por institución) no aplican a segmentos.
        if (modoSistema && /alertas tempranas/i.test(label)) return null;
        let fs = porLabel[label];
        // Alertas Tempranas es una categor\u00eda ordinal (1..5 \u2192 I..V), NO un porcentaje.
        const esCat = /alertas tempranas/i.test(label) || (fs[0].tipo === "categoria");
        // Categor\u00eda OFICIAL y POR INSTITUCI\u00d3N: excluir la fila del AGREGADO del grupo (ej. "59 G-7").
        if (esCat) fs = fs.filter(r => /^\s*4\d{4}\b/.test((r && r.nombre_entidad) || ""));
        if (!fs.length) return null;
        const m = (fs[0].tipo || "monto") === "monto";
        const veces = esVeces(label);
        const ROMANO = { 1: "I", 2: "II", 3: "III", 4: "IV", 5: "V" };
        const fCat = function (v) { return v == null ? "\u2014" : (ROMANO[Math.round(Number(v))] || "n/d"); };
        const unidad = esCat ? "categor\u00eda" : (veces ? "x" : (m ? "MDP" : "%"));
        const fVal = function (v) { return v == null ? "\u2014" : (esCat ? fCat(v) : (veces ? Number(v).toFixed(2) + "x" : (m ? fMDP(v) : fPct(v)))); };
        const periodos = Array.from(new Set([].concat.apply([], fs.map(function (f) { return (f.historico || []).map(function (h) { return h.periodo; }); })))).sort(function (a, b) { return a - b; });
        return (
          <div key={label}>
            <div style={{ fontSize: 14, fontWeight: 600, color: C.text, marginBottom: 6 }}>{label} <span style={{ color: C.muted, fontWeight: 400 }}>({unidad})</span></div>
            <table style={{ width: "100%", borderCollapse: "collapse" }}>
              <thead><tr>
                <th style={th}>{modoSistema ? "SEGMENTO" : "ENTIDAD"}</th><th style={thr}>ACTUAL</th><th style={thr}>ANTERIOR</th><th style={thr}>Δ</th><th style={thr}>Δ%</th>
              </tr></thead>
              <tbody>
                {fs.map(function (f, i) {
                  const va = f.valor_actual, vant = f.valor_anterior;
                  const actNoRep = _noRep(f.metrica, va);
                  const antNoRep = _noRep(f.metrica, vant);
                  // Actual no representativo \u2192 toda la fila n/r
                  if (actNoRep) {
                    return (
                      <tr key={i}>
                        <td style={td}>{limpia(f.nombre_entidad)}</td>
                        <td style={Object.assign({}, td, { textAlign: "right", color: C.muted, fontStyle: "italic" })} colSpan={4}>
                          No representativo (denominador ~0)
                        </td>
                      </tr>
                    );
                  }
                  const baseBaja = !!f.base_baja;
                  const nrVar = antNoRep || baseBaja;  // variaci\u00f3n no representativa si el anterior no lo es
                  // \u0394 desde el MISMO valor del backend (delta ya redondeado sobre extremos redondeados)
                  const dd = (typeof f.delta === "number") ? f.delta : ((va != null && vant != null) ? va - vant : null);
                  let dabs = "\u2014", dpct = "\u2014";
                  if (!esCat && !nrVar && va != null && vant != null && dd != null) {
                    // Ratios (x/pp): redondear-PRIMERO desde los valores visibles (consistencia con narrativa/HTML).
                    const d2 = Math.round(va * 100) / 100 - Math.round(vant * 100) / 100;
                    if (veces) { dabs = (d2 >= 0 ? "+" : "") + d2.toFixed(2) + "x"; }
                    else if (m) { const d = dd / 1e6; dabs = (d >= 0 ? "+" : "") + d.toLocaleString("es-MX", { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + " MDP"; }
                    else { dabs = (d2 >= 0 ? "+" : "") + d2.toFixed(2) + " pp"; }
                    dpct = (m && !veces && vant !== 0) ? (((va - vant) / vant * 100) >= 0 ? "+" : "") + ((va - vant) / vant * 100).toFixed(1) + "%" : "\u2014";
                  } else if (nrVar) { dabs = antNoRep ? "n/r" : "n/r (base ~0)"; dpct = "n/r"; }
                  return (
                    <tr key={i}>
                      <td style={td}>{limpia(f.nombre_entidad)}</td>
                      <td style={tdr}>{fVal(va)}</td>
                      <td style={tdr}>{antNoRep ? <span style={{ color: C.muted, fontStyle: "italic" }}>n/r</span> : fVal(vant)}</td>
                      <td style={tdr}>{dabs}</td>
                      <td style={tdr}>{dpct}</td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
            {periodos.length > 0 && (
              <div style={{ marginTop: 8, overflowX: "auto" }}>
                <div style={{ fontSize: 11, color: C.muted, marginBottom: 3 }}>Histórico mensual ({unidad})</div>
                <table style={{ borderCollapse: "collapse" }}>
                  <thead><tr>
                    <th style={th}>ENTIDAD</th>
                    {periodos.map(function (p) { return <th key={p} style={thr}>{pLabel(p)}</th>; })}
                  </tr></thead>
                  <tbody>
                    {fs.map(function (f, i) {
                      const hmap = {};
                      (f.historico || []).forEach(function (h) { hmap[h.periodo] = h.valor; });
                      return (
                        <tr key={i}>
                          <td style={td}>{limpia(f.nombre_entidad)}</td>
                          {periodos.map(function (p) {
                            const v = hmap[p];
                            // Misma representatividad que el resumen \u2192 coinciden (V8 #1)
                            if (v != null && !m && !veces && !esCat && _noRep(f.metrica, v)) {
                              return <td key={p} style={Object.assign({}, tdrs, { color: C.muted, fontStyle: "italic" })}>n/r</td>;
                            }
                            const cell = v == null ? "\u2014" : (esCat ? fCat(v) : (veces ? Number(v).toFixed(2) + "x" : (m ? (v / 1e6).toLocaleString("es-MX", { maximumFractionDigits: 0 }) : Number(v).toFixed(2) + "%")));
                            return <td key={p} style={tdrs}>{cell}</td>;
                          })}
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
}


// Anexo COMPACTO de cartera: consume resultado.anexo (backend) — una sección colapsable por
// métrica, con materialidad ya aplicada y ratios sin base marcados "No representativo".
const _MESES_ANX = ["ene", "feb", "mar", "abr", "may", "jun", "jul", "ago", "sep", "oct", "nov", "dic"];
function _pLabelAnx(p) { const y = Math.floor(p / 100), mo = p % 100; return (_MESES_ANX[mo - 1] || "?") + " " + String(y).slice(2); }
function _filaLabel(f) { return f.nivel <= 1 ? ((f.seg || "total").charAt(0).toUpperCase() + (f.seg || "total").slice(1)) : (f.desc || f.seg || "?"); }

function SeccionAnexoCartera({ anexo, C }) {
  const grupos = anexo || [];
  if (!grupos.length) return <div style={{ color: C.muted, fontSize: 15, fontStyle: "italic" }}>Sin datos fuente disponibles.</div>;
  const th = { padding: "4px 8px", textAlign: "left", fontSize: 11, fontFamily: "monospace", color: C.gold, borderBottom: "1px solid " + C.border };
  const thr = Object.assign({}, th, { textAlign: "right" });
  const td = { padding: "4px 8px", fontSize: 13, color: C.text, borderBottom: "1px solid " + C.border + "33" };
  const tdr = Object.assign({}, td, { textAlign: "right" });
  const fMDP = v => v == null ? "—" : (v / 1e6).toLocaleString("es-MX", { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + " MDP";
  const fPct = v => v == null ? "—" : Number(v).toFixed(2) + "%";
  return (
    <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>
      <div style={{ fontSize: 12, color: C.muted, fontStyle: "italic" }}>
        Datos fuente (CNBV) — cifras deterministas, no generadas por el modelo. Se omiten subsegmentos sin materialidad (&lt;100 MDP); los ratios sin base se marcan "No representativo".
      </div>
      {grupos.map(function (g, gi) {
        const m = g.es_monto;
        const fVal = v => v == null ? "—" : (m ? fMDP(v) : fPct(v));
        const periodos = Array.from(new Set([].concat.apply([], g.filas.map(f => (f.historico || []).map(h => h[0]))))).sort((a, b) => a - b);
        return (
          <details key={gi} open={!!g.principal} style={{ border: "1px solid " + C.border, borderRadius: 6, padding: "8px 12px" }}>
            <summary style={{ cursor: "pointer", fontSize: 14, fontWeight: 600, color: C.text }}>
              {g.label} <span style={{ color: C.muted, fontWeight: 400 }}>({g.unidad}) · {g.filas.length} filas</span>
            </summary>
            <div style={{ marginTop: 8 }}>
              <table style={{ width: "100%", borderCollapse: "collapse" }}>
                <thead><tr><th style={th}>UNIDAD</th><th style={thr}>ACTUAL</th><th style={thr}>ANTERIOR</th><th style={thr}>Δ</th><th style={thr}>Δ%</th></tr></thead>
                <tbody>
                  {g.filas.map(function (f, i) {
                    if (f.no_representativo) {
                      return (<tr key={i}><td style={td}>{_filaLabel(f)}</td><td style={tdr} colSpan={4}><span style={{ color: C.muted, fontStyle: "italic" }}>No representativo (cartera vencida mínima o nula)</span></td></tr>);
                    }
                    const va = f.actual, vant = f.anterior;
                    let dabs = "—", dpct = "—";
                    if (va != null && vant != null) {
                      if (m) { const d = (va - vant) / 1e6; dabs = (d >= 0 ? "+" : "") + d.toLocaleString("es-MX", { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + " MDP"; dpct = vant !== 0 ? (((va - vant) / vant * 100) >= 0 ? "+" : "") + ((va - vant) / vant * 100).toFixed(1) + "%" : "—"; }
                      else { const d = Math.round(va * 100) / 100 - Math.round(vant * 100) / 100; dabs = (d >= 0 ? "+" : "") + d.toFixed(2) + " pp"; }
                    }
                    const bold = f.nivel <= 0;
                    return (<tr key={i}><td style={Object.assign({}, td, bold ? { fontWeight: 600 } : {})}>{_filaLabel(f)}</td><td style={tdr}>{fVal(va)}</td><td style={tdr}>{fVal(vant)}</td><td style={tdr}>{dabs}</td><td style={tdr}>{dpct}</td></tr>);
                  })}
                </tbody>
              </table>
              {periodos.length > 0 && (
                <details style={{ marginTop: 8 }}>
                  <summary style={{ cursor: "pointer", fontSize: 11, color: C.muted }}>Histórico mensual ({g.unidad})</summary>
                  <div style={{ marginTop: 6, overflowX: "auto" }}>
                    <table style={{ borderCollapse: "collapse" }}>
                      <thead><tr><th style={th}>UNIDAD</th>{periodos.map(p => <th key={p} style={thr}>{_pLabelAnx(p)}</th>)}</tr></thead>
                      <tbody>
                        {g.filas.map(function (f, i) {
                          const hmap = {}; (f.historico || []).forEach(h => { hmap[h[0]] = h[1]; });
                          return (<tr key={i}><td style={td}>{_filaLabel(f)}</td>{periodos.map(p => { const v = hmap[p]; const cell = v == null ? "—" : (m ? (v / 1e6).toLocaleString("es-MX", { maximumFractionDigits: 0 }) : Number(v).toFixed(2) + "%"); return <td key={p} style={Object.assign({}, tdr, { fontSize: 12 })}>{cell}</td>; })}</tr>);
                        })}
                      </tbody>
                    </table>
                  </div>
                </details>
              )}
            </div>
          </details>
        );
      })}
    </div>
  );
}

// Transforma hechos + series de cartera al shape que espera SeccionAnexo
// ({label, nombre_entidad, valor_actual, valor_anterior, tipo, historico}).
function carteraDatosFuente(resultado) {
  const hechos = resultado.hechos || {};
  const series = resultado.series || {};
  const MET = {
    imor: "IMOR", imora: "IMORA", tda: "TDA", icor: "ICOR", eprc_sobre_cartera: "EPRC/cartera",
    eprc_balance: "EPRC balance", cartera_total: "Cartera total", cartera_vigente: "Cartera vigente",
    cartera_vencida: "Cartera vencida", quitas_12m: "Quitas y castigos 12m", quitas_mensual: "Quitas mensual",
    a0417_eprc: "EPRC A-0417", a0417_cartera: "Cartera base A-0417",
  };
  const esMonto = (m) => /^cartera_|^eprc_balance$|^quitas|^a0417_/.test(m || "");
  const rows = [];
  for (const ent in hechos) {
    for (const cve in hechos[ent]) {
      const h = hechos[ent][cve];
      if (!h) continue;
      const s = (series[ent] && series[ent][cve]) || [];
      rows.push({
        label: `${MET[h.metrica] || String(h.metrica || "").toUpperCase()} — ${h.desc || ""}`,
        nombre_entidad: ent,
        valor_actual: h.valor_fin,
        valor_anterior: h.valor_ini,
        tipo: esMonto(h.metrica) ? "monto" : "indicador",
        metrica: h.metrica,
        base_baja: !!h.base_baja,
        delta: h.delta,
        historico: (s || []).map((pt) => ({ periodo: pt[0], valor: pt[1] })),
      });
    }
  }
  return rows;
}

// ─────────────────────────────────────────────────────────────────────────────
// RESULTADO — REPORTE DE CARTERA (6 secciones + gráficas SVG del backend + Anexo)
// ─────────────────────────────────────────────────────────────────────────────
function ReporteCarteraResultado({ resultado, C }) {
  const SECS = [
    { id: "evolucion_cartera",       label: "Evolución",      g: ["evolucion", "treemap_tipo", "treemap_entidad", "composicion"] },
    { id: "calidad_por_segmento",    label: "Calidad",        g: ["calidad"] },
    { id: "cobertura_reservas",      label: "Cobertura",      g: ["cobertura"] },
    { id: "senales_por_institucion", label: "Señales",        g: ["ranking", "notables"] },
    { id: "descomposicion_vencida",  label: "Descomposición", g: ["descomposicion"] },
    { id: "conclusion",              label: "Conclusión",     g: [] },
    { id: "anexo",                   label: "Anexo",          g: [] },
  ];
  const [sec, setSec] = useState(SECS[0].id);
  const secciones = resultado.secciones || {};
  const graficas  = resultado.graficas || {};
  const meta      = resultado.meta || {};
  const notas     = (resultado.disponibilidad && resultado.disponibilidad.notas) || [];
  const cur   = SECS.find(s => s.id === sec) || SECS[0];
  const texto = secciones[cur.id] || "";
  const svgs  = (cur.g || []).map(k => graficas[k]).filter(Boolean);

  // ── Anexo serializado a HTML estático (para la descarga) — por ENTIDAD, con histórico ──
  function _anexoHTML(gold, line, mut) {
    const rows = carteraDatosFuente(resultado);
    if (!rows.length) return `<p style="color:${mut};font-style:italic">Sin datos fuente disponibles.</p>`;
    const modoSistema = rows.some(r => /^\s*5\s+Total Banca/i.test((r && r.nombre_entidad) || ""));
    const porLabel = {};
    rows.forEach(r => { const l = r.label || "?"; (porLabel[l] = porLabel[l] || []).push(r); });
    const limpia = n => (n || "").replace(/^\d+\s+/, "");
    const th = `padding:4px 8px;text-align:left;font-size:11px;font-family:monospace;color:${gold};border-bottom:1px solid ${line}`;
    const thr = th + ";text-align:right";
    const td = `padding:4px 8px;font-size:13px;border-bottom:1px solid ${line}55`;
    const tdr = td + ";text-align:right";
    const tdrs = tdr + ";font-size:12px";
    let out = `<div style="font-size:12px;color:${mut};font-style:italic;margin-bottom:10px">Datos fuente (CNBV) usados para este reporte. Cifras deterministas, no generadas por el modelo.</div>`;
    out += `<div style="font-size:12px;color:${mut};margin-bottom:12px">Nota: el ICOR y la narrativa de cobertura usan el saldo de EPRC del <b>balance</b>. Las cifras de EPRC <b>A-0417</b> se presentan como fuente complementaria y no necesariamente coinciden, por diferencias de integración y clasificación. Los ratios con denominador ~0 se marcan "no representativo".</div>`;
    for (const label of Object.keys(porLabel)) {
      let fs = porLabel[label];
      // Alertas Tempranas es categoría OFICIAL y POR INSTITUCIÓN: excluir la fila del agregado del grupo.
      if (/alertas tempranas/i.test(label)) fs = fs.filter(r => /^\s*4\d{4}\b/.test((r && r.nombre_entidad) || ""));
      if (!fs.length) continue;
      const m = (fs[0].tipo || "monto") === "monto";
      const unidad = m ? "MDP" : "%";
      const fVal = v => v == null ? "—" : (m ? (v / 1e6).toLocaleString("es-MX", { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + " MDP" : Number(v).toFixed(2) + "%");
      const periodos = Array.from(new Set([].concat.apply([], fs.map(f => (f.historico || []).map(h => h.periodo))))).sort((a, b) => a - b);
      out += `<div style="margin:18px 0"><div style="font-size:14px;font-weight:600;margin-bottom:6px">${label} <span style="color:${mut};font-weight:400">(${unidad})</span></div>`;
      out += `<table style="width:100%;border-collapse:collapse"><thead><tr><th style="${th}">${modoSistema ? "SEGMENTO" : "ENTIDAD"}</th><th style="${thr}">ACTUAL</th><th style="${thr}">ANTERIOR</th><th style="${thr}">Δ</th><th style="${thr}">Δ%</th></tr></thead><tbody>`;
      for (const f of fs) {
        const va = f.valor_actual, vant = f.valor_anterior;
        if (_noRep(f.metrica, va)) { out += `<tr><td style="${td}">${limpia(f.nombre_entidad)}</td><td style="${td};text-align:right;color:${mut};font-style:italic" colspan="4">No representativo (denominador ~0)</td></tr>`; continue; }
        const antNoRep = _noRep(f.metrica, vant);
        const nrVar = antNoRep || !!f.base_baja;
        const dd = (typeof f.delta === "number") ? f.delta : ((va != null && vant != null) ? va - vant : null);
        let dabs = "—", dpct = "—";
        if (!nrVar && va != null && vant != null && dd != null) {
          if (m) { const d = dd / 1e6; dabs = (d >= 0 ? "+" : "") + d.toLocaleString("es-MX", { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + " MDP"; }
          else { const d2 = Math.round(va * 100) / 100 - Math.round(vant * 100) / 100; dabs = (d2 >= 0 ? "+" : "") + d2.toFixed(2) + " pp"; }
          dpct = (m && vant !== 0) ? (((va - vant) / vant * 100) >= 0 ? "+" : "") + ((va - vant) / vant * 100).toFixed(1) + "%" : "—";
        } else if (nrVar) { dabs = antNoRep ? "n/r" : "n/r (base ~0)"; dpct = "n/r"; }
        const antCell = antNoRep ? `<span style="color:${mut};font-style:italic">n/r</span>` : fVal(vant);
        out += `<tr><td style="${td}">${limpia(f.nombre_entidad)}</td><td style="${tdr}">${fVal(va)}</td><td style="${tdr}">${antCell}</td><td style="${tdr}">${dabs}</td><td style="${tdr}">${dpct}</td></tr>`;
      }
      out += `</tbody></table>`;
      if (periodos.length) {
        out += `<div style="margin-top:8px;overflow-x:auto"><div style="font-size:11px;color:${mut};margin-bottom:3px">Histórico mensual (${unidad})</div>`;
        out += `<table style="border-collapse:collapse"><thead><tr><th style="${th}">${modoSistema ? "SEGMENTO" : "ENTIDAD"}</th>${periodos.map(p => `<th style="${thr}">${_pLabelAnx(p)}</th>`).join("")}</tr></thead><tbody>`;
        for (const f of fs) {
          const hmap = {}; (f.historico || []).forEach(h => { hmap[h.periodo] = h.valor; });
          out += `<tr><td style="${td}">${limpia(f.nombre_entidad)}</td>`;
          out += periodos.map(p => { const v = hmap[p]; if (v != null && !m && _noRep(f.metrica, v)) return `<td style="${tdrs};color:${mut};font-style:italic">n/r</td>`; const cell = v == null ? "—" : (m ? (v / 1e6).toLocaleString("es-MX", { maximumFractionDigits: 0 }) : Number(v).toFixed(2) + "%"); return `<td style="${tdrs}">${cell}</td>`; }).join("");
          out += `</tr>`;
        }
        out += `</tbody></table></div>`;
      }
      out += `</div>`;
    }
    return out;
  }

  // ── Descargas (HTML con gráficas SVG / Word .doc) ──
  function _docHTML(bgWhite) {
    const bg = bgWhite ? "#ffffff" : "#0e1420";
    const fg = bgWhite ? "#1a2230" : "#dbe4f0";
    const gold = bgWhite ? "#a8760a" : "#d8b67a", mut = "#6b7a90", line = "#c8d0da";
    let body = "";
    for (const s of SECS) {
      const txt = secciones[s.id] || "";
      body += `<h2 style="color:${gold};border-bottom:1px solid ${line};padding-bottom:5px;margin-top:26px">${s.label}</h2>`;
      if (s.id === "anexo") { body += _anexoHTML(gold, line, mut); continue; }
      body += txt.split("\n").filter(l => l.trim())
        .map(l => `<p style="line-height:1.55;margin:0 0 9px">${l.replace(/^\s*-\s*/, "• ")}</p>`).join("");
      for (const k of (s.g || [])) if (graficas[k]) body += `<div style="margin:10px 0">${graficas[k]}</div>`;
    }
    return `<!doctype html><html><head><meta charset="utf-8"><title>Reporte Cartera ${meta.nombre_universo || ""}</title></head>`
      + `<body style="background:${bg};color:${fg};font-family:Segoe UI,Arial,sans-serif;max-width:900px;margin:auto;padding:24px">`
      + `<h1 style="margin:0 0 4px">Reporte de Cartera de Crédito — ${meta.nombre_universo || ""}</h1>`
      + `<div style="color:${mut};font-family:monospace;font-size:13px">Ventana 12 meses &middot; corte ${meta.periodo_fin}</div>`
      + (notas.length ? `<div style="color:${gold};margin:12px 0">⚠ ${notas.join(" ")}</div>` : "")
      + body + `</body></html>`;
  }
  function _descargar(contenido, tipo, ext) {
    const blob = new Blob([contenido], { type: tipo });
    const a = document.createElement("a");
    a.href = URL.createObjectURL(blob);
    a.download = `Reporte_Cartera_${String(meta.nombre_universo || "").replace(/[^\w]+/g, "_")}_${meta.periodo_fin}.${ext}`;
    document.body.appendChild(a); a.click(); a.remove(); URL.revokeObjectURL(a.href);
  }
  const descargarHTML = () => _descargar(_docHTML(false), "text/html;charset=utf-8", "html");
  const descargarWord = () => _descargar(_docHTML(true), "application/msword;charset=utf-8", "doc");
  const btnDl = { padding: "5px 12px", borderRadius: 6, fontSize: 13, cursor: "pointer",
                  border: "1px solid " + C.border, background: "none", color: C.text };

  function Bullets({ txt }) {
    if (!txt) return <div style={{ color: C.muted, fontSize: 15, fontStyle: "italic" }}>Sin contenido para esta sección.</div>;
    return txt.split("\n").filter(l => l.trim()).map((l, i) => (
      <p key={i} style={{ margin: "0 0 10px 0", fontSize: 15, lineHeight: 1.65, color: "#cbd5e1" }}>
        {l.replace(/^\s*-\s*/, "• ")}
      </p>
    ));
  }

  return (
    <div>
      <div style={{ fontSize: 18, fontWeight: 600, color: C.text, marginBottom: 3 }}>
        Reporte de Cartera de Crédito — {meta.nombre_universo || ""}
      </div>
      <div style={{ fontSize: 13, color: C.muted, fontFamily: "monospace", marginBottom: 10 }}>
        Ventana 12 meses · corte {meta.periodo_fin} · {(meta.entidades_encontradas || []).length} unidades
        {resultado.tiempo_total ? " · " + resultado.tiempo_total + "s" : ""}
      </div>

      <div style={{ display: "flex", gap: 8, marginBottom: 14 }}>
        <button onClick={descargarHTML} style={btnDl}>↓ HTML</button>
        <button onClick={descargarWord} style={btnDl}>↓ Word</button>
      </div>

      {notas.length > 0 && (
        <div style={{
          marginBottom: 14, padding: "8px 12px", background: C.gold + "12",
          border: "1px solid " + C.gold + "33", borderRadius: 6, fontSize: 13, color: C.gold,
        }}>
          ⚠ {notas.join(" ")}
        </div>
      )}

      {/* Tabs de sección */}
      <div style={{ display: "flex", gap: 6, flexWrap: "wrap", marginBottom: 16, borderBottom: "1px solid " + C.border, paddingBottom: 8 }}>
        {SECS.map(s => (
          <button key={s.id} onClick={() => setSec(s.id)}
            style={{
              padding: "5px 13px", borderRadius: 6, fontSize: 13, cursor: "pointer",
              border: sec === s.id ? ("1px solid " + C.gold) : ("1px solid " + C.border),
              background: sec === s.id ? (C.gold + "18") : "none",
              color: sec === s.id ? C.gold : C.text,
            }}>
            {s.label}
          </button>
        ))}
      </div>

      {cur.id === "anexo" ? (
        <SeccionAnexo datos={carteraDatosFuente(resultado)} C={C} />
      ) : (
        <>
          {/* Narrativa de la sección */}
          <div style={{ marginBottom: 18 }}><Bullets txt={texto} /></div>
          {/* Gráficas deterministas (SVG del backend) */}
          {svgs.map((html, i) => (
            <div key={i} style={{ marginTop: 8 }} dangerouslySetInnerHTML={{ __html: html }} />
          ))}
        </>
      )}
    </div>
  );
}


function ReporteResultado({ resultado, C, datosB1, datosB2, datosB3 }) {
  const [sec, setSec] = useState("resumen");
  const [descargando, setDescargando] = useState(false);

  const TIPO_C = { positivo: "#22c55e", negativo: "#ef4444", neutro: "#94a3b8", alerta: "#f59e0b" };
  const NIVEL_C = { critico: "#ef4444", moderado: "#f59e0b", informativo: "#3b82f6" };

  const secs = [
    { id: "resumen",      label: "Resumen Ejecutivo" },
    { id: "balance",      label: "Balance" },
    { id: "resultados",   label: "Resultados" },
    { id: "riesgo",       label: "Riesgo" },
    { id: "solvencia",    label: resultado.tipo_reporte === "tematico_riesgo" ? "Cobertura/Reservas" : "Solvencia" },
    { id: "hallazgos",    label: "Hallazgos y Alertas (" + ((resultado.hallazgos_detectados || resultado.hallazgos || []).length) + ")" },
    { id: "conclusiones", label: "Conclusiones" },
    { id: "anexo",       label: "Anexo" },
    { id: "formulas",    label: "Fórmulas" },
  ];

  const bodyMap = {
    resumen:      resultado.resumen_ejecutivo,
    contexto:     resultado.contexto_universo,
    balance:      resultado.analisis_balance,
    resultados:   resultado.analisis_resultados,
    riesgo:       resultado.analisis_riesgo,
    solvencia:    resultado.analisis_solvencia,
    conclusiones: resultado.conclusiones,
  };

  function Parrafo({ texto }) {
    if (!texto) return <div style={{ color: C.muted, fontSize: 15, fontStyle: "italic" }}>Dato no disponible para este corte.</div>;
    return texto.split("\n").filter(Boolean).map((p, i) => (
      <p key={i} style={{ margin: "0 0 12px 0", fontSize: 16, lineHeight: 1.75, color: "#cbd5e1" }}>{p}</p>
    ));
  }

  function SeccionFormulas({ texto, C }) {
    if (!texto) return <div style={{ color: C.muted, fontSize: 15, fontStyle: "italic" }}>Fórmulas de referencia no disponibles para este reporte.</div>;
    const lineas = texto.split("\n").filter(function (l) { return l.trim(); });
    return (
      <div>
        <div style={{ fontSize: 12, color: C.muted, fontStyle: "italic", marginBottom: 12 }}>
          Los indicadores vienen ya calculados por la CNBV; EMRISK no los recalcula. Estas fórmulas son solo referencia metodológica.
        </div>
        {lineas.map(function (l, i) {
          const dash = l.trim().charAt(0) === "-";
          const eqIdx = dash ? l.indexOf("=") : -1;
          if (dash && eqIdx > 0) {
            return (
              <div key={i} style={{ display: "flex", gap: 8, padding: "6px 10px", marginBottom: 4, borderRadius: 5, background: C.border + "10", fontFamily: "monospace", fontSize: 14, lineHeight: 1.5 }}>
                <span style={{ color: "#60a5fa", fontWeight: 600, minWidth: 90 }}>{l.slice(1, eqIdx).trim()}</span>
                <span style={{ color: "#cbd5e1" }}>= {l.slice(eqIdx + 1).trim()}</span>
              </div>
            );
          }
          const esHeader = i === 0;
          return (
            <p key={i} style={{ margin: esHeader ? "0 0 10px 0" : "10px 0 0 0", fontSize: esHeader ? 14 : 13, fontWeight: esHeader ? 600 : 400, color: esHeader ? C.text : C.muted, lineHeight: 1.6 }}>{l}</p>
          );
        })}
      </div>
    );
  }

  const allDatos = [...(datosB1 || []), ...(datosB2 || []), ...(datosB3 || [])];
  const metricasRiesgo     = extraerMetricasPorEntidad(datosB2, datosB3, ["IMOR", "IMORA", "ICOR", "TDA"]);
  const metricasSolvencia  = extraerMetricasPorEntidad(datosB2, datosB3, ["ICAP T", "CCB", "CCF"]);
  const metricasBalance    = extraerMetricasPorEntidad(datosB2, datosB3, ["Activo", "Cartera", "Captacion", "Capital"]);
  const metricasResultados = extraerMetricasPorEntidad(datosB2, datosB3, ["ROA", "ROE"]);
  const metricasReservas   = extraerMetricasPorEntidad(datosB1 || [], [], ["EPRC Total", "EPRC Etapa 1", "EPRC Etapa 2", "EPRC Etapa 3", "EPRC Consumo E3", "EPRC Comercial E3", "EPRC Vivienda E3", "EPRC Adicional"]);

  function SeccionConDatos({ texto, metricas, colorBarra }) {
    const hayDatos = metricas && metricas.length > 0;
    return (
      <div>
        <Parrafo texto={texto} />
        {hayDatos && (
          <div style={{ marginTop: 16 }}>
            <div style={{ fontSize: 12, color: C.gold, fontFamily: "monospace", marginBottom: 8, letterSpacing: 1 }}>
              DATOS DEL PERIODO
            </div>
            {metricas.map(function(m) {
              const esPct = m.datos[0] && m.datos[0].tipo === "porcentaje";
              const tablaFilas = m.datos.map(function(d) {
                return { "Entidad": d.nombre, "Valor": esPct ? fmtPct(d.valor) : fmtMDP(d.valor) };
              });
              return (
                <div key={m.metrica} style={{ marginBottom: 14 }}>
                  <div style={{ fontSize: 13, color: C.muted, fontFamily: "monospace", marginBottom: 4 }}>{m.metrica}</div>
                  {m.datos.length <= 3
                    ? <TablaMetricas filas={tablaFilas} C={C} />
                    : <MiniBarChart datos={m.datos} color={colorBarra || "#c8a84b"} formatVal={esPct ? fmtPct : fmtMDP} />
                  }
                </div>
              );
            })}
          </div>
        )}
      </div>
    );
  }

  async function handleDescargar() {
    setDescargando(true);
    try {
      const { generarWordReporte } = await import("./generarWordReporte");
      await generarWordReporte(resultado, datosB2, datosB3, datosB1);
    } catch (e) {
      alert("Error al generar Word: " + e.message);
    } finally {
      setDescargando(false);
    }
  }

  async function handleDescargarHTML() {
    try {
      const { generarHTMLReporte } = await import("./generarHTMLReporte");
      generarHTMLReporte(resultado, datosB2, datosB3, datosB1);
    } catch (e) {
      alert("Error al generar HTML: " + e.message);
    }
  }

  function SeccionGraficas() {
    const PALETTE = ["#c8a84b", "#60a5fa", "#34d399", "#f87171", "#a78bfa", "#f97316"];
    const graficas = resultado.graficas || [];

    if (!graficas.length) {
      return <div style={{ color: C.muted, fontSize: 15, fontStyle: "italic", padding: 8 }}>
        El LLM no generó gráficas para este reporte. Intenta con horizonte 6M o 12M.
      </div>;
    }

    return (
      <div style={{ display: "flex", flexDirection: "column", gap: 20 }}>
        {graficas.map(function(g, gi) {
          const esLinea = g.tipo !== "barras";
          // Construir datos para Recharts: array de {x, trace0, trace1, ...}
          // Unificar todos los periodos x de todas las traces (por si el LLM los desalineó)
          const allX = [];
          g.traces.forEach(function(t) { (t.x || []).forEach(function(xv) { if (!allX.includes(xv)) allX.push(xv); }); });
          const xLabels = allX.length ? allX : (g.traces[0] ? g.traces[0].x : []);
          const chartData = xLabels.map(function(xVal, xi) {
            const punto = { x: xVal };
            g.traces.forEach(function(t) {
              const idx = (t.x || []).indexOf(xVal);
              punto[t.nombre] = idx >= 0 && t.y[idx] != null ? t.y[idx] : null;
            });
            return punto;
          });

          return (
            <div key={gi} style={{ background: C.bg, border: "1px solid " + C.border, borderRadius: 6, padding: "12px 14px" }}>
              <div style={{ fontSize: 12, color: C.gold, fontFamily: "monospace", marginBottom: 8, letterSpacing: 1 }}>
                {g.titulo.toUpperCase()} {g.unidad ? "· " + g.unidad : ""}
              </div>
              {/* Leyenda */}
              <div style={{ display: "flex", gap: 12, marginBottom: 8, flexWrap: "wrap" }}>
                {g.traces.map(function(t, ti) {
                  return (
                    <div key={ti} style={{ display: "flex", alignItems: "center", gap: 4 }}>
                      <div style={{ width: 10, height: 10, borderRadius: 2, background: PALETTE[ti % PALETTE.length] }} />
                      <span style={{ fontSize: 12, color: C.muted, fontFamily: "monospace" }}>{t.nombre}</span>
                    </div>
                  );
                })}
              </div>
              {/* SVG chart manual */}
              <GraficaReporte datos={chartData} traces={g.traces} tipo={g.tipo} palette={PALETTE} C={C} />
            </div>
          );
        })}
      </div>
    );
  }

  return (
    <div style={{ background: C.card, border: "1px solid " + C.border, borderRadius: 9, overflow: "hidden" }}>
      <div style={{ background: "#0d1b2a", borderBottom: "1px solid " + C.border, padding: "13px 17px" }}>
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start" }}>
          <div style={{ flex: 1 }}>
            <div style={{ fontSize: 12, color: C.gold, fontFamily: "monospace", marginBottom: 3 }}>
              EMRISK AI &middot; {(resultado.tipo_reporte || "").toUpperCase()} &middot; {(resultado.periodo_label || "").toUpperCase()}
            </div>
            <div style={{ fontSize: 17, fontWeight: 600, color: C.text, lineHeight: 1.3 }}>{resultado.titulo}</div>
            <div style={{ fontSize: 13, color: C.muted, marginTop: 3 }}>
              {resultado.nombre_universo} &middot; {resultado.tiempo_total}s
              {resultado._tokens_input ? " \u00b7 " + (resultado._tokens_input + resultado._tokens_output) + " tokens" : ""}
              &middot; ID {resultado.reporte_id}
            </div>
          </div>
          <div style={{ display: "flex", gap: 6, marginLeft: 12, flexShrink: 0 }}>
            <button onClick={handleDescargarHTML}
              style={{
                padding: "6px 10px", borderRadius: 5, fontSize: 13, cursor: "pointer",
                border: "1px solid " + C.blue + "80", background: C.blue + "15",
                color: C.blue, fontFamily: "monospace", whiteSpace: "nowrap",
              }}>
              ↓ HTML
            </button>
            <button onClick={handleDescargar} disabled={descargando}
              style={{
                padding: "6px 10px", borderRadius: 5, fontSize: 13, cursor: "pointer",
                border: "1px solid " + C.gold, background: descargando ? C.dim : C.gold + "20",
                color: C.gold, fontFamily: "monospace", whiteSpace: "nowrap",
              }}>
              {descargando ? "Generando..." : "↓ Word"}
            </button>
          </div>
        </div>
      </div>

      <div style={{ display: "flex", gap: 2, padding: "6px 9px", borderBottom: "1px solid " + C.border, flexWrap: "wrap" }}>
        {secs.map(function(s) {
          return (
            <button key={s.id} onClick={function() { setSec(s.id); }}
              style={{
                padding: "3px 8px", borderRadius: 3, fontSize: 12, fontFamily: "monospace",
                border: sec === s.id ? ("1px solid " + C.gold) : ("1px solid " + C.border),
                background: sec === s.id ? (C.gold + "15") : "none",
                color: sec === s.id ? C.gold : C.muted, cursor: "pointer",
              }}>
              {s.label}
            </button>
          );
        })}
      </div>

      <div style={{ padding: "16px 20px", maxHeight: 520, overflowY: "auto" }}>
        {sec === "balance"    && (resultado.html_balance
          ? <div className="emrisk-frag-host" dangerouslySetInnerHTML={{ __html: resultado.html_balance }} />
          : <SeccionConDatos texto={bodyMap.balance}    metricas={metricasBalance}    colorBarra="#3b82f6" />)}
        {sec === "resultados" && (resultado.html_resultados
          ? <div className="emrisk-frag-host" dangerouslySetInnerHTML={{ __html: resultado.html_resultados }} />
          : <SeccionConDatos texto={bodyMap.resultados} metricas={metricasResultados} colorBarra="#22c55e" />)}
        {sec === "riesgo"     && (resultado.html_riesgo
          ? <div className="emrisk-frag-host" dangerouslySetInnerHTML={{ __html: resultado.html_riesgo }} />
          : <SeccionConDatos texto={bodyMap.riesgo}     metricas={metricasRiesgo}     colorBarra="#ef4444" />)}
        {sec === "solvencia"  && (resultado.html_solvencia
          ? <div className="emrisk-frag-host" dangerouslySetInnerHTML={{ __html: resultado.html_solvencia }} />
          : <SeccionConDatos texto={bodyMap.solvencia}  metricas={metricasSolvencia}  colorBarra="#8b5cf6" />)}
        {sec === "graficas"   && <SeccionGraficas />}
        {sec === "anexo"      && <SeccionAnexo datos={allDatos} C={C} />}
        {sec === "formulas"   && <SeccionFormulas texto={resultado.formulas_referencia} C={C} />}
        {sec === "resumen" && (resultado.html_resumen
          ? <div className="emrisk-frag-host" dangerouslySetInnerHTML={{ __html: resultado.html_resumen }} />
          : <Parrafo texto={bodyMap.resumen} />)}
        {sec === "conclusiones" && <Parrafo texto={resultado.conclusiones} />}

        {sec === "hallazgos" && (resultado.html_hallazgos
          ? <div className="emrisk-frag-host" dangerouslySetInnerHTML={{ __html: resultado.html_hallazgos }} />
          : (
          <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
            {!(resultado.hallazgos && resultado.hallazgos.length) && (
              <div style={{ color: C.muted, fontSize: 15 }}>Sin hallazgos registrados.</div>
            )}
            {(resultado.hallazgos || []).map(function(h, i) {
              return (
                <div key={i} style={{
                  padding: "10px 11px", borderRadius: 5,
                  border: "1px solid " + (TIPO_C[h.tipo] || C.border) + "25",
                  borderLeft: "3px solid " + (TIPO_C[h.tipo] || C.border),
                  background: (TIPO_C[h.tipo] || C.border) + "07",
                }}>
                  <div style={{ display: "flex", gap: 7, alignItems: "center", marginBottom: 4 }}>
                    <span style={{ fontSize: 12, fontFamily: "monospace", color: TIPO_C[h.tipo] || C.muted, textTransform: "uppercase" }}>{h.tipo}</span>
                    <div style={{ fontSize: 15, fontWeight: 500, color: C.text }}>{h.titulo}</div>
                  </div>
                  <div style={{ fontSize: 14, color: "#94a3b8", lineHeight: 1.6 }}>{h.texto}</div>
                </div>
              );
            })}
          </div>
        ))}
      </div>
    </div>
  );
}

// ─────────────────────────────────────────────────────────────────────────────
// MINERÍA DE DATOS — HHI DINÁMICO DE CONCENTRACIÓN
// ─────────────────────────────────────────────────────────────────────────────
function MineriaView({ user }) {
  // C — usa la paleta global de theme.js

  // ── Modo principal del módulo ─────────────────────────────────────
  const [modo, setModo] = useState("hhi"); // "hhi" | "anomalias" | "forecast"

  const CAT_COLOR = {
    "Cuasi-monopolio":        "#f87171",
    "Concentración alta":     "#fb923c",
    "Concentración moderada": "#fbbf24",
    "Competitivo":            "#34d399",
  };
  const DIR_ICON = {
    "Concentrándose":    { icon: "↑", color: "#f87171" },
    "Desconcentrándose": { icon: "↓", color: "#34d399" },
    "Estable":           { icon: "—", color: "#64748b" },
    "Sin comparable":    { icon: "·", color: "#64748b" },
  };

  const VISTAS = [
    { id: "sistemica", label: "Sistémica",  desc: "Nivel 4 + Depósitos a Plazo (~97% del valor)" },
    { id: "inclusion", label: "Inclusión",  desc: "Niveles 1, 2, 3 + Ahorro" },
    { id: "todos",     label: "Todos",      desc: "Los 6 productos comerciales" },
  ];

  const PERSONALIDADES = [
    { id: "todos",       label: "Todos"        },
    { id: "fisica",      label: "Física"       },
    { id: "moral",       label: "Moral"        },
    { id: "empresarial", label: "Empresarial"  },
  ];

  const VISTAS_LABEL = { sistemica: "Sistémica", inclusion: "Inclusión", todos: "Todos los productos" };

  // ── Estado HHI ────────────────────────────────────────────────────
  const [vista,     setVista]     = useState("sistemica");
  const [loading,   setLoading]   = useState(false);
  const [error,     setError]     = useState(null);
  const [resultado, setResultado] = useState(null);
  const [sortCol,   setSortCol]   = useState("delta_abs");
  const [sortAsc,   setSortAsc]   = useState(false);

  // ── Estado Anomalías ──────────────────────────────────────────────
  const [vistaAnom,       setVistaAnom]       = useState("sistemica");
  const [personalidad,    setPersonalidad]    = useState("todos");
  const [loadingAnom,     setLoadingAnom]     = useState(false);
  const [errorAnom,       setErrorAnom]       = useState(null);
  const [resultadoAnom,   setResultadoAnom]   = useState(null);
  const [sortColAnom,     setSortColAnom]     = useState("z_abs");
  const [sortAscAnom,     setSortAscAnom]     = useState(false);

  // ── Estado Forecast ───────────────────────────────────────────────
  const _FC_ENTIDADES = [
    "BBVA México","Banorte","Santander","Banamex","HSBC",
    "Scotiabank","Inbursa","Banco del Bajío","Banco Azteca","Banregio","Bancoppel","Banco Base",
  ];
  const _FC_PRODUCTOS = [
    "Cuentas Transaccionales de Bajo Riesgo Nivel 4",
    "Cuentas de Depósitos a Plazo",
  ];
  const [fcEntidad,   setFcEntidad]   = useState("");   // "" = todas
  const [fcProducto,  setFcProducto]  = useState("");   // "" = ambos
  const [fcHorizonte, setFcHorizonte] = useState(6);
  const [loadingFc,   setLoadingFc]   = useState(false);
  const [errorFc,     setErrorFc]     = useState(null);
  const [resultadoFc, setResultadoFc] = useState(null);
  const [fcSerie,     setFcSerie]     = useState("");    // "entidad||producto" seleccionado en el chart

  async function handleAnalizar() {
    setLoading(true);
    setError(null);
    try {
      const resp = await fetch(`${BACKEND_URL}/mineria/concentracion`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ vista, top_n: 200, usuario: user?.email || "" }),
      });
      if (!resp.ok) {
        const err = await resp.json().catch(() => ({}));
        throw new Error(err.detail || `HTTP ${resp.status}`);
      }
      const data = await resp.json();
      setResultado(data);
    } catch (e) {
      setError(e.message);
    } finally {
      setLoading(false);
    }
  }

  // ── Fetch Anomalías ───────────────────────────────────────────────
  async function handleDetectar() {
    setLoadingAnom(true);
    setErrorAnom(null);
    try {
      const resp = await fetch(`${BACKEND_URL}/mineria/anomalias`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ vista: vistaAnom, personalidad, top_n: 200, usuario: user?.email || "" }),
      });
      if (!resp.ok) {
        const err = await resp.json().catch(() => ({}));
        throw new Error(err.detail || `HTTP ${resp.status}`);
      }
      setResultadoAnom(await resp.json());
    } catch (e) {
      setErrorAnom(e.message);
    } finally {
      setLoadingAnom(false);
    }
  }

  // ── Fetch Forecast ────────────────────────────────────────────────
  async function handleForecast() {
    setLoadingFc(true);
    setErrorFc(null);
    setResultadoFc(null);
    try {
      const body = { horizonte: fcHorizonte, confianza: 0.9, usuario: user?.email || "" };
      if (fcEntidad)  body.entidad  = fcEntidad;
      if (fcProducto) body.producto = fcProducto;
      const resp = await fetch(`${BACKEND_URL}/mineria/forecast`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(body),
      });
      if (!resp.ok) {
        const err = await resp.json().catch(() => ({}));
        throw new Error(err.detail || `HTTP ${resp.status}`);
      }
      const data = await resp.json();
      setResultadoFc(data);
      // Auto-seleccionar primera serie en el gráfico
      if (data.proyecciones && data.proyecciones.length > 0) {
        const p0 = data.proyecciones[0];
        setFcSerie(`${p0.nombre_entidad}||${p0.descripcion_producto}`);
      }
    } catch (e) {
      setErrorFc(e.message);
    } finally {
      setLoadingFc(false);
    }
  }

  // ── Sort Anomalías ────────────────────────────────────────────────
  function getSortedFilasAnom() {
    if (!resultadoAnom?.filas) return [];
    const filas = [...resultadoAnom.filas];
    filas.sort(function(a, b) {
      let va, vb;
      if      (sortColAnom === "z_abs")         { va = Math.abs(a.z_score);     vb = Math.abs(b.z_score); }
      else if (sortColAnom === "saldo_mdp")     { va = a.saldo_mdp;             vb = b.saldo_mdp; }
      else if (sortColAnom === "delta_mdp")     { va = Math.abs(a.delta_mensual_mdp); vb = Math.abs(b.delta_mensual_mdp); }
      else if (sortColAnom === "share_celda")   { va = a.share_celda_pct;       vb = b.share_celda_pct; }
      else { va = 0; vb = 0; }
      return sortAscAnom ? va - vb : vb - va;
    });
    return filas;
  }

  function handleSortColAnom(col) {
    if (sortColAnom === col) setSortAscAnom(!sortAscAnom);
    else { setSortColAnom(col); setSortAscAnom(false); }
  }

  // ── Export Anomalías Excel ────────────────────────────────────────
  function handleExportExcelAnom() {
    const headers = ["Entidad","Estado","Producto","Saldo MDP","Δ Mensual MDP","Saldo hist. MDP","Z-Score","Tipo","Nivel","Share celda %"];
    const rows = getSortedFilasAnom().map(f => [
      f.nombre_entidad, f.descripcion_estado, f.descripcion_producto,
      f.saldo_mdp, f.delta_mensual_mdp, f.saldo_hist_mdp,
      f.z_score, f.tipo_anomalia, f.nivel_alerta, f.share_celda_pct,
    ]);
    const csv = [headers, ...rows]
      .map(r => r.map(v => `"${String(v ?? "").replace(/"/g, '""')}"`).join(","))
      .join("\n");
    const blob = new Blob(["﻿" + csv], { type: "text/csv;charset=utf-8;" });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = `Anomalias_${resultadoAnom.vista}_${resultadoAnom.personalidad}_${resultadoAnom.periodo_analizado}.csv`;
    a.click();
    URL.revokeObjectURL(url);
  }

  // ── Export Anomalías HTML ─────────────────────────────────────────
  function handleExportHTMLAnom() {
    const ANOM_C = { "Crecimiento crítico": "#f87171", "Crecimiento inusual": "#fb923c", "Caída crítica": "#60a5fa", "Caída inusual": "#93c5fd" };
    const NIVEL_C = { "Crítica": "#f87171", "Moderada": "#fb923c" };
    const r = resultadoAnom;
    const tableRows = getSortedFilasAnom().map(function(f, i) {
      const ac = ANOM_C[f.tipo_anomalia] || "#94a3b8";
      const nc = NIVEL_C[f.nivel_alerta] || "#94a3b8";
      const df = (f.delta_mensual_mdp >= 0 ? "+" : "") + f.delta_mensual_mdp.toFixed(1);
      return `<tr style="background:${i%2===0?"#0f172a":"#1a2535"}">
        <td style="color:#e2e8f0">${f.nombre_entidad}</td>
        <td>${f.descripcion_estado}</td>
        <td>${f.descripcion_producto}</td>
        <td style="text-align:right">${f.saldo_mdp.toLocaleString("es-MX",{maximumFractionDigits:1})}</td>
        <td style="text-align:right;color:${ac};font-weight:600">${df}</td>
        <td style="text-align:right;color:${ac};font-weight:700">${f.z_score >= 0 ? "+" : ""}${f.z_score.toFixed(2)}</td>
        <td><span style="padding:2px 8px;border-radius:4px;background:${ac}20;color:${ac}">${f.tipo_anomalia}</span></td>
        <td><span style="padding:2px 8px;border-radius:4px;background:${nc}20;color:${nc}">${f.nivel_alerta}</span></td>
        <td style="text-align:right">${f.share_celda_pct.toFixed(1)}%</td>
      </tr>`;
    }).join("");
    const html = `<!DOCTYPE html>
<html lang="es"><head><meta charset="UTF-8">
<title>Anomalías ${VISTAS_LABEL[r.vista]} · ${r.periodo_analizado}</title>
<style>
  body{font-family:monospace;background:#0b1117;color:#e2e8f0;margin:0;padding:28px}
  h1{color:#c8a84b;font-size:17px;margin:0 0 4px}
  .meta{color:#8fafc7;font-size:12px;margin-bottom:14px}
  .insight{background:#c8a84b12;border:1px solid #c8a84b35;border-left:3px solid #c8a84b;padding:12px 16px;border-radius:6px;margin-bottom:16px;font-size:12px;line-height:1.75}
  .badges{display:flex;gap:8px;flex-wrap:wrap;margin-bottom:16px}
  .badge{padding:4px 12px;border-radius:20px;font-size:11px}
  table{width:100%;border-collapse:collapse;font-size:11px}
  th{padding:7px 10px;text-align:left;color:#4a6278;font-size:9px;text-transform:uppercase;letter-spacing:.8px;background:#0f1923;border-bottom:1px solid #1e2d3d}
  td{padding:6px 10px;border-bottom:1px solid #1e2d3d;color:#94a3b8}
  .footer{margin-top:18px;color:#4a6278;font-size:10px}
</style></head><body>
<h1>◉ Radar de Riesgos — Detección de Anomalías</h1>
<div class="meta">Vista: ${VISTAS_LABEL[r.vista]} · Periodo: ${r.periodo_analizado} · ${getSortedFilasAnom().length} anomalías · Generado: ${new Date().toLocaleString("es-MX")}</div>
${r.insight ? `<div class="insight"><div style="font-size:9px;color:#c8a84b;letter-spacing:1px;margin-bottom:6px">INSIGHT · CLAUDE SONNET</div>${r.insight}</div>` : ""}
<div class="badges">
  <span class="badge" style="background:#f8717120;color:#f87171;border:1px solid #f8717145">Críticas: ${r.resumen.criticas}</span>
  <span class="badge" style="background:#fb923c20;color:#fb923c;border:1px solid #fb923c45">Moderadas: ${r.resumen.moderadas}</span>
  <span class="badge" style="background:#fb923c20;color:#fb923c;border:1px solid #fb923c45">Crecimiento: ${r.resumen.crecimiento}</span>
  <span class="badge" style="background:#60a5fa20;color:#60a5fa;border:1px solid #60a5fa45">Caída: ${r.resumen.caida}</span>
</div>
<table><thead><tr>
  <th>Entidad</th><th>Estado</th><th>Producto</th><th>Saldo MDP</th>
  <th>Δ Mensual MDP</th><th>Z-Score</th><th>Tipo</th><th>Nivel</th><th>Share %</th>
</tr></thead><tbody>${tableRows}</tbody></table>
<div class="footer">Fuente: CNBV R2421 · EMRISK AI · Anomalía: |z| ≥ 2.0 vs. distribución histórica de deltas mensuales · Materialidad mínima: 10 MDP</div>
</body></html>`;
    const blob = new Blob([html], { type: "text/html;charset=utf-8;" });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = `Anomalias_${r.vista}_${r.periodo_analizado}.html`;
    a.click();
    URL.revokeObjectURL(url);
  }

  // ── Exportar CSV (abre en Excel con UTF-8 BOM) ─────────────────────
  function handleExportExcel() {
    const headers = ["Estado","Producto","Saldo MDP","Bancos","HHI","Δ HHI","HHI año anterior","Categoría","Dirección","Banco dominante","Share %"];
    const rows = filasSorted.map(f => [
      f.descripcion_estado,
      f.descripcion_producto,
      f.saldo_total_mdp,
      f.num_bancos,
      f.hhi_actual.toFixed(0),
      f.delta_hhi != null ? f.delta_hhi.toFixed(0) : "",
      f.hhi_anio_anterior != null ? f.hhi_anio_anterior.toFixed(0) : "",
      f.categoria_hhi,
      f.direccion,
      f.banco_dominante,
      f.share_dominante_pct.toFixed(1),
    ]);
    const csv = [headers, ...rows]
      .map(r => r.map(v => `"${String(v ?? "").replace(/"/g, '""')}"`).join(","))
      .join("\n");
    const blob = new Blob(["﻿" + csv], { type: "text/csv;charset=utf-8;" });
    const url  = URL.createObjectURL(blob);
    const a    = document.createElement("a");
    a.href     = url;
    a.download = `HHI_${resultado.vista}_${resultado.periodo_analizado}.csv`;
    a.click();
    URL.revokeObjectURL(url);
  }

  // ── Exportar HTML ──────────────────────────────────────────────────
  function handleExportHTML() {
    const CAT_BG = {
      "Cuasi-monopolio":        "#4c1515",
      "Concentración alta":     "#4c2510",
      "Concentración moderada": "#4c3a0a",
      "Competitivo":            "#0a3326",
    };
    const tableRows = filasSorted.map(function(f, i) {
      const cc  = CAT_COLOR[f.categoria_hhi] || "#94a3b8";
      const dir = DIR_ICON[f.direccion] || { icon: "·", color: "#64748b" };
      const df  = f.delta_hhi != null ? (f.delta_hhi >= 0 ? "+" : "") + f.delta_hhi.toFixed(0) : "—";
      return `<tr style="background:${i%2===0?"#0f172a":"#1a2535"}">
        <td>${f.descripcion_estado}</td>
        <td>${f.descripcion_producto}</td>
        <td style="text-align:right">${f.saldo_total_mdp.toLocaleString("es-MX",{maximumFractionDigits:0})}</td>
        <td style="text-align:center">${f.num_bancos}</td>
        <td style="text-align:right;color:${cc};font-weight:600">${f.hhi_actual.toFixed(0)}</td>
        <td style="text-align:right;color:${dir.color};font-weight:600">${df}</td>
        <td><span style="padding:2px 8px;border-radius:4px;background:${CAT_BG[f.categoria_hhi]||"#1e293b"};color:${cc}">${f.categoria_hhi}</span></td>
        <td style="color:${dir.color}">${dir.icon} ${f.direccion}</td>
        <td>${f.banco_dominante}</td>
        <td style="text-align:right">${f.share_dominante_pct.toFixed(1)}%</td>
      </tr>`;
    }).join("");
    const r   = resultado;
    const res = r.resumen;
    const html = `<!DOCTYPE html>
<html lang="es"><head><meta charset="UTF-8">
<title>HHI ${VISTAS_LABEL[r.vista]} · ${r.periodo_analizado}</title>
<style>
  body{font-family:monospace;background:#0b1117;color:#e2e8f0;margin:0;padding:28px}
  h1{color:#c8a84b;font-size:17px;margin:0 0 4px}
  .meta{color:#8fafc7;font-size:12px;margin-bottom:14px}
  .insight{background:#c8a84b12;border:1px solid #c8a84b35;border-left:3px solid #c8a84b;padding:12px 16px;border-radius:6px;margin-bottom:16px;font-size:12px;line-height:1.75}
  .insight .label{font-size:9px;color:#c8a84b;letter-spacing:1px;margin-bottom:6px}
  .badges{display:flex;gap:8px;flex-wrap:wrap;margin-bottom:16px}
  .badge{padding:4px 12px;border-radius:20px;font-size:11px}
  table{width:100%;border-collapse:collapse;font-size:11px}
  th{padding:7px 10px;text-align:left;color:#4a6278;font-size:9px;text-transform:uppercase;letter-spacing:.8px;background:#0f1923;border-bottom:1px solid #1e2d3d}
  td{padding:6px 10px;border-bottom:1px solid #1e2d3d;color:#94a3b8}
  td:first-child{color:#e2e8f0}
  .footer{margin-top:18px;color:#4a6278;font-size:10px}
</style></head><body>
<h1>◉ Radar de Riesgos — HHI Dinámico de Concentración</h1>
<div class="meta">Vista: ${VISTAS_LABEL[r.vista]} · Periodo: ${r.periodo_analizado} · ${filasSorted.length} celdas · Generado: ${new Date().toLocaleString("es-MX")}</div>
${r.insight ? `<div class="insight"><div class="label">INSIGHT · CLAUDE SONNET</div>${r.insight}</div>` : ""}
<div class="badges">
  <span class="badge" style="background:#f8717120;color:#f87171;border:1px solid #f8717145">Cuasi-monopolio: ${res.cuasi_monopolio}</span>
  <span class="badge" style="background:#fb923c20;color:#fb923c;border:1px solid #fb923c45">Concentración alta: ${res.alta}</span>
  <span class="badge" style="background:#fbbf2420;color:#fbbf24;border:1px solid #fbbf2445">Moderada: ${res.moderada}</span>
  <span class="badge" style="background:#34d39920;color:#34d399;border:1px solid #34d39945">Competitivo: ${res.competitiva}</span>
</div>
<table><thead><tr>
  <th>Estado</th><th>Producto</th><th>Saldo MDP</th><th>Bancos</th>
  <th>HHI</th><th>Δ HHI</th><th>Categoría</th><th>Dirección</th>
  <th>Dominante</th><th>Share %</th>
</tr></thead><tbody>${tableRows}</tbody></table>
<div class="footer">Fuente: CNBV Forma R2421 · EMRISK AI · Umbrales COFECE/DOJ: &lt;1 500 competitivo · 1 500–2 500 moderado · 2 500–5 000 alto · &gt;5 000 cuasi-monopolio</div>
</body></html>`;
    const blob = new Blob([html], { type: "text/html;charset=utf-8;" });
    const url  = URL.createObjectURL(blob);
    const a    = document.createElement("a");
    a.href     = url;
    a.download = `HHI_${r.vista}_${r.periodo_analizado}.html`;
    a.click();
    URL.revokeObjectURL(url);
  }

  // ── Ordenamiento ───────────────────────────────────────────────────
  function getSortedFilas() {
    if (!resultado?.filas) return [];
    const filas = [...resultado.filas];
    filas.sort(function(a, b) {
      let va, vb;
      if      (sortCol === "delta_abs")          { va = Math.abs(a.delta_hhi ?? 0); vb = Math.abs(b.delta_hhi ?? 0); }
      else if (sortCol === "hhi_actual")         { va = a.hhi_actual;           vb = b.hhi_actual; }
      else if (sortCol === "saldo_total_mdp")    { va = a.saldo_total_mdp;      vb = b.saldo_total_mdp; }
      else if (sortCol === "share_dominante_pct"){ va = a.share_dominante_pct;  vb = b.share_dominante_pct; }
      else { va = 0; vb = 0; }
      return sortAsc ? va - vb : vb - va;
    });
    return filas;
  }

  function handleSortCol(col) {
    if (sortCol === col) setSortAsc(!sortAsc);
    else { setSortCol(col); setSortAsc(false); }
  }

  function SortArrow({ col }) {
    if (sortCol !== col) return <span style={{ color: C.dim, marginLeft: 3 }}>⇅</span>;
    return <span style={{ color: C.gold, marginLeft: 3 }}>{sortAsc ? "↑" : "↓"}</span>;
  }

  const filasSorted = getSortedFilas();
  const res = resultado?.resumen;

  // Estilo compartido para botones de exportar
  const btnExport = {
    padding: "5px 12px", borderRadius: 6, cursor: "pointer",
    fontSize: 14, fontFamily: "monospace",
    border: `1px solid ${C.border}`,
    background: C.card, color: C.sub,
    transition: "all 0.15s",
  };

  return (
    <div style={{ flex: 1, display: "flex", flexDirection: "column", background: C.bg, overflow: "hidden" }}>

      {/* ── Header ── */}
      <div style={{ padding: "18px 24px 14px", borderBottom: `1px solid ${C.border}`, flexShrink: 0 }}>
        <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: 5 }}>
          <div style={{ display: "flex", alignItems: "baseline", gap: 10 }}>
            <span style={{ fontSize: 16, fontWeight: 600, color: C.text, fontFamily: "monospace" }}>◉ Radar de Riesgos</span>
            <span style={{ fontSize: 15, color: C.sub, fontFamily: "monospace" }}>Captación R2421</span>
          </div>
          {/* Toggle de modo */}
          <div style={{ display: "flex", gap: 0, borderRadius: 7, overflow: "hidden", border: `1px solid ${C.border}` }}>
            {[
              { id: "hhi",       label: "⊞ Concentración HHI" },
              { id: "anomalias", label: "⚡ Anomalías"          },
              { id: "forecast",  label: "◈ Pronóstico ARIMA"   },
            ].map(m => (
              <button key={m.id} onClick={() => setModo(m.id)} style={{
                padding: "5px 14px", border: "none", cursor: "pointer",
                fontSize: 14, fontFamily: "monospace", fontWeight: modo === m.id ? 700 : 400,
                background: modo === m.id ? C.gold : C.card,
                color:      modo === m.id ? "#0b1117" : C.sub,
                transition: "all 0.15s",
              }}>{m.label}</button>
            ))}
          </div>
        </div>
        <div style={{ fontSize: 15, color: C.sub, lineHeight: 1.55 }}>
          {modo === "hhi"
            ? <>Concentración de mercado (HHI) por estado × producto, con delta interanual. Umbrales COFECE/DOJ: &lt;1 500 competitivo · 1 500–2 500 moderado · 2 500–5 000 alto · &gt;5 000 cuasi-monopolio.</>
            : modo === "anomalias"
              ? <>Detección de anomalías estadísticas (z-score mensual) por entidad × estado × producto. Señala comportamientos inusuales vs. la distribución histórica de los últimos 48 meses. Umbral: |z| ≥ 2.0 · Materialidad ≥ 10 MDP.</>
              : <>Pronóstico BQML ARIMA_PLUS de captación sistémica. 22 series: 11 entidades (87.6% del sistema) × 2 productos sistémicos (~97% del valor). Horizonte configurable 1–12 meses · Bandas de confianza al 90%.</>
          }
        </div>
      </div>

      {/* ══════════════════════════════════════════════════════════════
          SECCIÓN HHI
      ══════════════════════════════════════════════════════════════ */}
      {modo === "hhi" && <>

      {/* ── Controles HHI ── */}
      <div style={{ padding: "12px 24px", borderBottom: `1px solid ${C.border}`, display: "flex", alignItems: "center", gap: 10, flexShrink: 0, flexWrap: "wrap" }}>
        {/* Selector de vista */}
        <div style={{ display: "flex", gap: 6 }}>
          {VISTAS.map(v => (
            <button key={v.id} title={v.desc} onClick={() => setVista(v.id)} style={{
              padding: "5px 13px", borderRadius: 6, cursor: "pointer", fontSize: 15,
              fontFamily: "monospace",
              border: vista === v.id ? `1px solid ${C.gold}66` : `1px solid ${C.border}`,
              background: vista === v.id ? C.gold + "18" : C.card,
              color: vista === v.id ? C.gold : C.sub,
              fontWeight: vista === v.id ? 600 : 400,
              transition: "all 0.15s",
            }}>
              {v.label}
            </button>
          ))}
        </div>

        {/* Botón analizar */}
        <button onClick={handleAnalizar} disabled={loading} style={{
          padding: "6px 18px", borderRadius: 6, cursor: loading ? "not-allowed" : "pointer",
          background: loading ? C.dim : C.gold, color: loading ? C.muted : "#0b1117",
          fontWeight: 700, fontSize: 15, fontFamily: "monospace",
          border: "none", letterSpacing: 0.5,
          opacity: loading ? 0.7 : 1, transition: "all 0.15s",
        }}>
          {loading ? "Analizando…" : "▶ Analizar"}
        </button>

        {/* Periodo analizado */}
        {resultado && (
          <span style={{ fontSize: 14, color: C.sub, marginLeft: 4 }}>
            Periodo: <strong style={{ color: C.text }}>{resultado.periodo_analizado}</strong>
            {" · "}{resultado.tiempo_total}s
          </span>
        )}

        {/* Botones exportar — solo cuando hay datos */}
        {resultado && filasSorted.length > 0 && (
          <div style={{ display: "flex", gap: 6, marginLeft: "auto" }}>
            <button onClick={handleExportExcel} style={btnExport} title="Descargar CSV compatible con Excel">
              ↓ Excel
            </button>
            <button onClick={handleExportHTML} style={btnExport} title="Descargar reporte HTML">
              ↓ HTML
            </button>
          </div>
        )}
      </div>

      {/* ── Error ── */}
      {error && (
        <div style={{ margin: "14px 24px", padding: "10px 14px", background: "#f8717118", border: "1px solid #f8717133", borderRadius: 6, color: "#f87171", fontSize: 15 }}>
          Error: {error}
        </div>
      )}

      {/* ── Resultados ── */}
      {resultado && (
        <div style={{ flex: 1, overflow: "auto", padding: "0 24px 24px" }}>

          {/* Insight de Sonnet — con scroll si el texto es largo */}
          {resultado.insight && (
            <div style={{
              margin: "16px 0 14px", padding: "12px 16px",
              background: C.gold + "0d", border: `1px solid ${C.gold}35`,
              borderLeft: `3px solid ${C.gold}`, borderRadius: 6,
            }}>
              <div style={{ fontSize: 12, fontFamily: "monospace", color: C.gold, letterSpacing: 1, marginBottom: 7 }}>
                INSIGHT · CLAUDE SONNET
              </div>
              <div style={{ fontSize: 15, color: C.text, lineHeight: 1.75, maxHeight: 130, overflowY: "auto", paddingRight: 4 }}>
                {resultado.insight}
              </div>
            </div>
          )}

          {/* Badges resumen */}
          {res && (
            <div style={{ display: "flex", gap: 8, marginBottom: 14, flexWrap: "wrap" }}>
              {[
                { label: "Cuasi-monopolio",    val: res.cuasi_monopolio, color: "#f87171" },
                { label: "Concentración alta", val: res.alta,            color: "#fb923c" },
                { label: "Moderada",           val: res.moderada,        color: "#fbbf24" },
                { label: "Competitivo",        val: res.competitiva,     color: "#34d399" },
              ].map(b => (
                <div key={b.label} style={{
                  padding: "5px 12px", borderRadius: 20,
                  background: b.color + "18", border: `1px solid ${b.color}45`,
                  display: "flex", alignItems: "center", gap: 7,
                }}>
                  <div style={{ width: 7, height: 7, borderRadius: "50%", background: b.color, flexShrink: 0 }} />
                  <span style={{ fontSize: 14, color: b.color, fontFamily: "monospace" }}>{b.label}</span>
                  <span style={{ fontSize: 16, fontWeight: 700, color: b.color, fontFamily: "monospace" }}>{b.val}</span>
                </div>
              ))}
              <div style={{
                padding: "5px 12px", borderRadius: 20,
                background: C.dim + "50", border: `1px solid ${C.border}`,
                display: "flex", alignItems: "center", gap: 7,
              }}>
                <span style={{ fontSize: 14, color: C.sub, fontFamily: "monospace" }}>Total celdas</span>
                <span style={{ fontSize: 16, fontWeight: 700, color: C.text, fontFamily: "monospace" }}>{res.total_celdas}</span>
              </div>
            </div>
          )}

          {/* Tabla */}
          {filasSorted.length === 0 && (
            <div style={{ color: C.sub, fontSize: 15, padding: 12 }}>Sin resultados para esta vista y filtros.</div>
          )}
          {filasSorted.length > 0 && (
            <div style={{ overflowX: "auto" }}>
              <table style={{ width: "100%", borderCollapse: "collapse", fontSize: 14, fontFamily: "monospace" }}>
                <thead>
                  <tr style={{ background: C.surface, borderBottom: `1px solid ${C.border}` }}>
                    {[
                      { col: null,                  label: "Estado"    },
                      { col: null,                  label: "Producto"  },
                      { col: "saldo_total_mdp",     label: "Saldo MDP" },
                      { col: null,                  label: "Bancos"    },
                      { col: "hhi_actual",          label: "HHI"       },
                      { col: "delta_abs",           label: "Δ HHI"     },
                      { col: null,                  label: "Categoría" },
                      { col: null,                  label: "Dirección" },
                      { col: "share_dominante_pct", label: "Dominante" },
                      { col: "share_dominante_pct", label: "Share %"   },
                    ].map(function(h, i) {
                      return (
                        <th key={i} onClick={h.col ? () => handleSortCol(h.col) : undefined}
                          style={{
                            padding: "7px 10px", textAlign: "left",
                            color: C.sub, fontWeight: 600, fontSize: 12,
                            letterSpacing: 0.8, textTransform: "uppercase",
                            cursor: h.col ? "pointer" : "default",
                            whiteSpace: "nowrap", userSelect: "none",
                          }}>
                          {h.label}{h.col && <SortArrow col={h.col} />}
                        </th>
                      );
                    })}
                  </tr>
                </thead>
                <tbody>
                  {filasSorted.map(function(f, i) {
                    const catColor = CAT_COLOR[f.categoria_hhi] || C.body;
                    const dir      = DIR_ICON[f.direccion]      || { icon: "·", color: "#64748b" };
                    const deltaFmt = f.delta_hhi != null
                      ? (f.delta_hhi >= 0 ? "+" : "") + f.delta_hhi.toFixed(0)
                      : "—";
                    return (
                      <tr key={i} style={{
                        borderBottom: `1px solid ${C.border}`,
                        background: i % 2 === 0 ? "transparent" : C.card + "66",
                      }}>
                        <td style={{ padding: "6px 10px", color: C.text, whiteSpace: "nowrap" }}>{f.descripcion_estado}</td>
                        <td style={{ padding: "6px 10px", color: C.body, minWidth: 320, whiteSpace: "nowrap" }} title={f.descripcion_producto}>{f.descripcion_producto}</td>
                        <td style={{ padding: "6px 10px", color: C.text, textAlign: "right" }}>{f.saldo_total_mdp.toLocaleString("es-MX", { maximumFractionDigits: 0 })}</td>
                        <td style={{ padding: "6px 10px", color: C.body, textAlign: "center" }}>{f.num_bancos}</td>
                        <td style={{ padding: "6px 10px", color: catColor, fontWeight: 600, textAlign: "right" }}>{f.hhi_actual.toFixed(0)}</td>
                        <td style={{ padding: "6px 10px", color: dir.color, textAlign: "right", fontWeight: 600 }}>{deltaFmt}</td>
                        <td style={{ padding: "6px 10px", whiteSpace: "nowrap" }}>
                          <span style={{
                            padding: "2px 7px", borderRadius: 4, fontSize: 13,
                            background: catColor + "20", color: catColor,
                            border: `1px solid ${catColor}45`,
                          }}>{f.categoria_hhi}</span>
                        </td>
                        <td style={{ padding: "6px 10px", whiteSpace: "nowrap" }}>
                          <span style={{ color: dir.color, fontWeight: 700, marginRight: 4 }}>{dir.icon}</span>
                          <span style={{ color: dir.color, fontSize: 13 }}>{f.direccion}</span>
                        </td>
                        <td style={{ padding: "6px 10px", color: C.text, whiteSpace: "nowrap" }}>{f.banco_dominante}</td>
                        <td style={{ padding: "6px 10px", color: C.body, textAlign: "right" }}>{f.share_dominante_pct.toFixed(1)}%</td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
          )}
        </div>
      )}

      {/* Estado vacío inicial */}
      {!resultado && !loading && !error && (
        <div style={{ flex: 1, display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", color: C.sub, gap: 10 }}>
          <div style={{ fontSize: 32, opacity: 0.25 }}>◉</div>
          <div style={{ fontSize: 16, fontFamily: "monospace", color: C.text }}>Selecciona una vista y presiona Analizar</div>
          <div style={{ fontSize: 15, color: C.sub, maxWidth: 320, textAlign: "center", lineHeight: 1.6 }}>
            Analiza la concentración de captación bancaria en ~28M registros históricos desde 2017.
          </div>
        </div>
      )}

      </>}
      {/* ══════════════════════════════════════════════════════════════
          SECCIÓN ANOMALÍAS
      ══════════════════════════════════════════════════════════════ */}
      {modo === "anomalias" && <>

      {/* ── Controles Anomalías ── */}
      <div style={{ padding: "12px 24px", borderBottom: `1px solid ${C.border}`, display: "flex", alignItems: "center", gap: 10, flexShrink: 0, flexWrap: "wrap" }}>

        {/* Selector de vista */}
        <div style={{ display: "flex", gap: 6 }}>
          {VISTAS.map(v => (
            <button key={v.id} title={v.desc} onClick={() => setVistaAnom(v.id)} style={{
              padding: "5px 13px", borderRadius: 6, cursor: "pointer", fontSize: 15,
              fontFamily: "monospace",
              border: vistaAnom === v.id ? `1px solid ${C.gold}66` : `1px solid ${C.border}`,
              background: vistaAnom === v.id ? C.gold + "18" : C.card,
              color: vistaAnom === v.id ? C.gold : C.sub,
              fontWeight: vistaAnom === v.id ? 600 : 400,
              transition: "all 0.15s",
            }}>
              {v.label}
            </button>
          ))}
        </div>

        {/* Selector personalidad jurídica */}
        <div style={{ display: "flex", gap: 5, alignItems: "center" }}>
          <span style={{ fontSize: 13, color: C.sub, fontFamily: "monospace", letterSpacing: 0.5 }}>PERS.</span>
          {PERSONALIDADES.map(p => (
            <button key={p.id} onClick={() => setPersonalidad(p.id)} style={{
              padding: "5px 11px", borderRadius: 6, cursor: "pointer", fontSize: 14,
              fontFamily: "monospace",
              border: personalidad === p.id ? `1px solid #7dd3fc66` : `1px solid ${C.border}`,
              background: personalidad === p.id ? "#7dd3fc18" : C.card,
              color: personalidad === p.id ? "#7dd3fc" : C.sub,
              fontWeight: personalidad === p.id ? 600 : 400,
              transition: "all 0.15s",
            }}>
              {p.label}
            </button>
          ))}
        </div>

        {/* Botón detectar */}
        <button onClick={handleDetectar} disabled={loadingAnom} style={{
          padding: "6px 18px", borderRadius: 6, cursor: loadingAnom ? "not-allowed" : "pointer",
          background: loadingAnom ? C.dim : "#f87171",
          color: loadingAnom ? C.muted : "#0b1117",
          fontWeight: 700, fontSize: 15, fontFamily: "monospace",
          border: "none", letterSpacing: 0.5,
          opacity: loadingAnom ? 0.7 : 1, transition: "all 0.15s",
        }}>
          {loadingAnom ? "Detectando…" : "⚡ Detectar"}
        </button>

        {/* Periodo analizado */}
        {resultadoAnom && (
          <span style={{ fontSize: 14, color: C.sub, marginLeft: 4 }}>
            Periodo: <strong style={{ color: C.text }}>{resultadoAnom.periodo_analizado}</strong>
            {" · "}{resultadoAnom.tiempo_total}s
          </span>
        )}

        {/* Botones exportar */}
        {resultadoAnom && getSortedFilasAnom().length > 0 && (
          <div style={{ display: "flex", gap: 6, marginLeft: "auto" }}>
            <button onClick={handleExportExcelAnom} style={btnExport} title="Descargar CSV compatible con Excel">
              ↓ Excel
            </button>
            <button onClick={handleExportHTMLAnom} style={btnExport} title="Descargar reporte HTML">
              ↓ HTML
            </button>
          </div>
        )}
      </div>

      {/* ── Error ── */}
      {errorAnom && (
        <div style={{ margin: "14px 24px", padding: "10px 14px", background: "#f8717118", border: "1px solid #f8717133", borderRadius: 6, color: "#f87171", fontSize: 15 }}>
          Error: {errorAnom}
        </div>
      )}

      {/* ── Resultados ── */}
      {resultadoAnom && (
        <div style={{ flex: 1, overflow: "auto", padding: "0 24px 24px" }}>

          {/* Insight de Sonnet */}
          {resultadoAnom.insight && (
            <div style={{
              margin: "16px 0 14px", padding: "12px 16px",
              background: "#f87171" + "0d", border: `1px solid #f8717135`,
              borderLeft: `3px solid #f87171`, borderRadius: 6,
            }}>
              <div style={{ fontSize: 12, fontFamily: "monospace", color: "#f87171", letterSpacing: 1, marginBottom: 7 }}>
                INSIGHT · CLAUDE SONNET
              </div>
              <div style={{ fontSize: 15, color: C.text, lineHeight: 1.75, maxHeight: 130, overflowY: "auto", paddingRight: 4 }}>
                {resultadoAnom.insight}
              </div>
            </div>
          )}

          {/* Badges resumen */}
          {resultadoAnom.resumen && (
            <div style={{ display: "flex", gap: 8, marginBottom: 14, flexWrap: "wrap" }}>
              {[
                { label: "Críticas",     val: resultadoAnom.resumen.criticas,    color: "#f87171" },
                { label: "Moderadas",    val: resultadoAnom.resumen.moderadas,   color: "#fb923c" },
                { label: "Crecimiento",  val: resultadoAnom.resumen.crecimiento, color: "#fb923c" },
                { label: "Caída",        val: resultadoAnom.resumen.caida,       color: "#60a5fa" },
              ].map(b => (
                <div key={b.label} style={{
                  padding: "5px 12px", borderRadius: 20,
                  background: b.color + "18", border: `1px solid ${b.color}45`,
                  display: "flex", alignItems: "center", gap: 7,
                }}>
                  <div style={{ width: 7, height: 7, borderRadius: "50%", background: b.color, flexShrink: 0 }} />
                  <span style={{ fontSize: 14, color: b.color, fontFamily: "monospace" }}>{b.label}</span>
                  <span style={{ fontSize: 16, fontWeight: 700, color: b.color, fontFamily: "monospace" }}>{b.val}</span>
                </div>
              ))}
              <div style={{
                padding: "5px 12px", borderRadius: 20,
                background: C.dim + "50", border: `1px solid ${C.border}`,
                display: "flex", alignItems: "center", gap: 7,
              }}>
                <span style={{ fontSize: 14, color: C.sub, fontFamily: "monospace" }}>Total anomalías</span>
                <span style={{ fontSize: 16, fontWeight: 700, color: C.text, fontFamily: "monospace" }}>{resultadoAnom.resumen.total}</span>
              </div>
            </div>
          )}

          {/* Tabla anomalías */}
          {getSortedFilasAnom().length === 0 && (
            <div style={{ color: C.sub, fontSize: 15, padding: 12 }}>Sin anomalías detectadas para esta vista y filtros.</div>
          )}
          {getSortedFilasAnom().length > 0 && (
            <div style={{ overflowX: "auto" }}>
              <table style={{ width: "100%", borderCollapse: "collapse", fontSize: 14, fontFamily: "monospace" }}>
                <thead>
                  <tr style={{ background: C.surface, borderBottom: `1px solid ${C.border}` }}>
                    {[
                      { col: null,           label: "Entidad"       },
                      { col: null,           label: "Estado"        },
                      { col: null,           label: "Producto"      },
                      { col: "saldo_mdp",    label: "Saldo MDP"     },
                      { col: "delta_mdp",    label: "Δ Mensual MDP" },
                      { col: "z_abs",        label: "Z-Score"       },
                      { col: null,           label: "Tipo"          },
                      { col: null,           label: "Nivel"         },
                      { col: "share_celda",  label: "Share %"       },
                    ].map(function(h, i) {
                      return (
                        <th key={i} onClick={h.col ? () => handleSortColAnom(h.col) : undefined}
                          style={{
                            padding: "7px 10px", textAlign: "left",
                            color: C.sub, fontWeight: 600, fontSize: 12,
                            letterSpacing: 0.8, textTransform: "uppercase",
                            cursor: h.col ? "pointer" : "default",
                            whiteSpace: "nowrap", userSelect: "none",
                          }}>
                          {h.label}{h.col && (
                            <span style={{ marginLeft: 3, opacity: 0.6 }}>
                              {sortColAnom === h.col ? (sortAscAnom ? "↑" : "↓") : "↕"}
                            </span>
                          )}
                        </th>
                      );
                    })}
                  </tr>
                </thead>
                <tbody>
                  {getSortedFilasAnom().map(function(f, i) {
                    const ANOM_C = {
                      "Crecimiento crítico": "#f87171",
                      "Crecimiento inusual": "#fb923c",
                      "Caída crítica":       "#60a5fa",
                      "Caída inusual":       "#93c5fd",
                    };
                    const NIVEL_C = { "Crítica": "#f87171", "Moderada": "#fb923c" };
                    const ac  = ANOM_C[f.tipo_anomalia]  || C.body;
                    const nc  = NIVEL_C[f.nivel_alerta]  || C.body;
                    const df  = (f.delta_mensual_mdp >= 0 ? "+" : "") + f.delta_mensual_mdp.toFixed(1);
                    const zf  = (f.z_score >= 0 ? "+" : "") + f.z_score.toFixed(2);
                    return (
                      <tr key={i} style={{
                        borderBottom: `1px solid ${C.border}`,
                        background: i % 2 === 0 ? "transparent" : C.card + "66",
                      }}>
                        <td style={{ padding: "6px 10px", color: C.text, whiteSpace: "nowrap" }}>{f.nombre_entidad}</td>
                        <td style={{ padding: "6px 10px", color: C.body, whiteSpace: "nowrap" }}>{f.descripcion_estado}</td>
                        <td style={{ padding: "6px 10px", color: C.body, minWidth: 320, whiteSpace: "nowrap" }} title={f.descripcion_producto}>{f.descripcion_producto}</td>
                        <td style={{ padding: "6px 10px", color: C.text, textAlign: "right" }}>{f.saldo_mdp.toLocaleString("es-MX", { maximumFractionDigits: 1 })}</td>
                        <td style={{ padding: "6px 10px", color: ac, fontWeight: 600, textAlign: "right" }}>{df}</td>
                        <td style={{ padding: "6px 10px", color: ac, fontWeight: 700, textAlign: "right" }}>{zf}</td>
                        <td style={{ padding: "6px 10px", whiteSpace: "nowrap" }}>
                          <span style={{
                            padding: "2px 7px", borderRadius: 4, fontSize: 13,
                            background: ac + "20", color: ac,
                            border: `1px solid ${ac}45`,
                          }}>{f.tipo_anomalia}</span>
                        </td>
                        <td style={{ padding: "6px 10px", whiteSpace: "nowrap" }}>
                          <span style={{
                            padding: "2px 7px", borderRadius: 4, fontSize: 13,
                            background: nc + "20", color: nc,
                            border: `1px solid ${nc}45`,
                          }}>{f.nivel_alerta}</span>
                        </td>
                        <td style={{ padding: "6px 10px", color: C.body, textAlign: "right" }}>{f.share_celda_pct.toFixed(1)}%</td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
          )}
        </div>
      )}

      {/* Estado vacío inicial anomalías */}
      {!resultadoAnom && !loadingAnom && !errorAnom && (
        <div style={{ flex: 1, display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", color: C.sub, gap: 10 }}>
          <div style={{ fontSize: 32, opacity: 0.25 }}>⚡</div>
          <div style={{ fontSize: 16, fontFamily: "monospace", color: C.text }}>Selecciona una vista y presiona Detectar</div>
          <div style={{ fontSize: 15, color: C.sub, maxWidth: 360, textAlign: "center", lineHeight: 1.6 }}>
            Detecta movimientos inusuales comparando el delta mensual de cada entidad contra su distribución histórica (z-score). Umbral: |z| ≥ 2.0 · Materialidad ≥ 10 MDP.
          </div>
        </div>
      )}

      </>}

      {/* ══════════════════════════════════════════════════════════════
          SECCIÓN FORECAST ARIMA
      ══════════════════════════════════════════════════════════════ */}
      {modo === "forecast" && <>

      {/* ── Controles Forecast ── */}
      <div style={{ padding: "12px 24px", borderBottom: `1px solid ${C.border}`, display: "flex", alignItems: "center", gap: 12, flexShrink: 0, flexWrap: "wrap" }}>

        {/* Selector de entidad */}
        <div style={{ display: "flex", alignItems: "center", gap: 6 }}>
          <span style={{ fontSize: 13, color: C.sub, fontFamily: "monospace", letterSpacing: 0.5 }}>ENTIDAD</span>
          <select
            value={fcEntidad}
            onChange={e => setFcEntidad(e.target.value)}
            style={{
              background: C.card, border: `1px solid ${C.border}`, borderRadius: 6,
              color: fcEntidad ? C.text : C.sub, fontSize: 14, fontFamily: "monospace",
              padding: "5px 10px", cursor: "pointer",
            }}
          >
            <option value="">Todas (11)</option>
            {_FC_ENTIDADES.map(e => <option key={e} value={e}>{e}</option>)}
          </select>
        </div>

        {/* Selector de producto */}
        <div style={{ display: "flex", alignItems: "center", gap: 6 }}>
          <span style={{ fontSize: 13, color: C.sub, fontFamily: "monospace", letterSpacing: 0.5 }}>PRODUCTO</span>
          <div style={{ display: "flex", gap: 4 }}>
            {[{ id: "", label: "Ambos" }, ...(_FC_PRODUCTOS.map(p => ({ id: p, label: p.includes("Nivel 4") ? "Nivel 4" : "Plazo" })))].map(op => (
              <button key={op.id} onClick={() => setFcProducto(op.id)} title={op.id || "Ambos productos sistémicos"} style={{
                padding: "5px 10px", borderRadius: 6, cursor: "pointer", fontSize: 14,
                fontFamily: "monospace",
                border: fcProducto === op.id ? `1px solid ${C.gold}66` : `1px solid ${C.border}`,
                background: fcProducto === op.id ? C.gold + "18" : C.card,
                color: fcProducto === op.id ? C.gold : C.sub,
                fontWeight: fcProducto === op.id ? 600 : 400,
                transition: "all 0.15s",
              }}>{op.label}</button>
            ))}
          </div>
        </div>

        {/* Horizonte */}
        <div style={{ display: "flex", alignItems: "center", gap: 7 }}>
          <span style={{ fontSize: 13, color: C.sub, fontFamily: "monospace", letterSpacing: 0.5 }}>HORIZONTE</span>
          <input type="range" min={1} max={12} value={fcHorizonte}
            onChange={e => setFcHorizonte(Number(e.target.value))}
            style={{ width: 80, accentColor: C.gold, cursor: "pointer" }}
          />
          <span style={{ fontSize: 14, fontFamily: "monospace", color: C.text, minWidth: 24 }}>{fcHorizonte}m</span>
        </div>

        {/* Botón proyectar */}
        <button onClick={handleForecast} disabled={loadingFc} style={{
          padding: "6px 18px", borderRadius: 6,
          cursor: loadingFc ? "not-allowed" : "pointer",
          background: loadingFc ? C.dim : "#60a5fa",
          color: loadingFc ? C.muted : "#0b1117",
          fontWeight: 700, fontSize: 15, fontFamily: "monospace",
          border: "none", letterSpacing: 0.5,
          opacity: loadingFc ? 0.7 : 1, transition: "all 0.15s",
        }}>
          {loadingFc ? "Calculando…" : "◈ Proyectar"}
        </button>

        {resultadoFc && (
          <span style={{ fontSize: 14, color: C.sub, marginLeft: 4 }}>
            {resultadoFc.n_series} series · {resultadoFc.tiempo_total}s
          </span>
        )}

        {/* Botón exportar CSV */}
        {resultadoFc && resultadoFc.proyecciones && resultadoFc.proyecciones.length > 0 && (
          <button
            onClick={function() {
              const headers = ["Entidad","Producto","Periodo","Saldo proy. MDP","Banda inf. MDP","Banda sup. MDP"];
              const rows = resultadoFc.proyecciones.map(function(p) {
                return [
                  p.nombre_entidad,
                  p.descripcion_producto,
                  String(p.periodo).slice(0,4) + "/" + String(p.periodo).slice(4,6),
                  p.saldo_proyectado_mdp,
                  p.banda_inferior_mdp,
                  p.banda_superior_mdp,
                ];
              });
              const csv = [headers].concat(rows)
                .map(function(r) { return r.map(function(v) { return '"' + String(v ?? "").replace(/"/g, '""') + '"'; }).join(","); })
                .join("\n");
              const blob = new Blob(["﻿" + csv], { type: "text/csv;charset=utf-8;" });
              const url  = URL.createObjectURL(blob);
              const a    = document.createElement("a");
              a.href     = url;
              a.download = "Forecast_ARIMA_" + (fcEntidad || "TodosEnt") + "_" + fcHorizonte + "m.csv";
              a.click();
              URL.revokeObjectURL(url);
            }}
            style={{
              marginLeft: "auto", padding: "5px 12px", borderRadius: 6, cursor: "pointer",
              fontSize: 14, fontFamily: "monospace",
              border: "1px solid " + C.border,
              background: C.card, color: C.sub,
              transition: "all 0.15s",
            }}
          >
            ↓ CSV
          </button>
        )}
      </div>

      {/* ── Error ── */}
      {errorFc && (
        <div style={{ margin: "14px 24px", padding: "10px 14px", background: "#f8717118", border: "1px solid #f8717133", borderRadius: 6, color: "#f87171", fontSize: 15 }}>
          Error: {errorFc}
        </div>
      )}

      {/* ── Resultados ── */}
      {resultadoFc && (
        <div style={{ flex: 1, overflow: "auto", padding: "0 24px 24px" }}>

          {/* Insight Sonnet */}
          {resultadoFc.insight && (
            <div style={{
              margin: "16px 0 14px", padding: "12px 16px",
              background: "#60a5fa0d", border: `1px solid #60a5fa35`,
              borderLeft: `3px solid #60a5fa`, borderRadius: 6,
            }}>
              <div style={{ fontSize: 12, fontFamily: "monospace", color: "#60a5fa", letterSpacing: 1, marginBottom: 7 }}>
                INSIGHT · CLAUDE SONNET
              </div>
              <div style={{ fontSize: 15, color: C.text, lineHeight: 1.75, paddingRight: 4 }}>
                {resultadoFc.insight}
              </div>
            </div>
          )}

          {/* Selector de serie + chart SVG */}
          {resultadoFc.proyecciones && resultadoFc.proyecciones.length > 0 && (function() {
            // ── Construir catálogo de series ──────────────────────────────
            const seriesMap = {};
            resultadoFc.proyecciones.forEach(function(p) {
              const key = p.nombre_entidad + "||" + p.descripcion_producto;
              if (!seriesMap[key]) seriesMap[key] = { entidad: p.nombre_entidad, producto: p.descripcion_producto };
            });
            const seriesKeys = Object.keys(seriesMap);
            const activeSerie = (fcSerie && seriesMap[fcSerie]) ? fcSerie : seriesKeys[0];
            const serEntidad  = activeSerie.split("||")[0];
            const serProducto = activeSerie.split("||")[1];

            // ── Filtrar la serie activa ───────────────────────────────────
            const histSerie = (resultadoFc.historico || []).filter(function(h) {
              return h.nombre_entidad === serEntidad && h.descripcion_producto === serProducto;
            });
            const proySerie = resultadoFc.proyecciones.filter(function(p) {
              return p.nombre_entidad === serEntidad && p.descripcion_producto === serProducto;
            });

            // ── Coordenadas del canvas SVG ────────────────────────────────
            const W = 820, H = 220, PL = 75, PR = 20, PT = 24, PB = 40;
            const plotW = W - PL - PR;
            const plotH = H - PT - PB;

            // Combinar todos los puntos para escala — conversión explícita a Number
            const toNum = function(v) { return Number(v); };
            const histVals = histSerie.map(function(h) { return toNum(h.saldo_historico_mdp); });
            const proyVals = proySerie.map(function(p) { return toNum(p.saldo_proyectado_mdp); });
            const bandHi   = proySerie.map(function(p) { return toNum(p.banda_superior_mdp); });
            const bandLo   = proySerie.map(function(p) { return toNum(p.banda_inferior_mdp); });
            const allVals  = histVals.concat(proyVals, bandHi, bandLo).filter(function(v) {
              return typeof v === "number" && isFinite(v) && !isNaN(v);
            });

            // Guard: sin datos válidos
            if (allVals.length === 0) {
              return (
                <div style={{ padding: "16px 0", color: C.sub, fontSize: 14, fontFamily: "monospace" }}>
                  Hist: {histSerie.length} pts · Proy: {proySerie.length} pts · Sin valores numéricos para graficar.
                </div>
              );
            }

            const dataMin = Math.min.apply(null, allVals);
            const dataMax = Math.max.apply(null, allVals);
            const spread  = dataMax - dataMin;
            const padding = spread > 0 ? spread * 0.08 : (dataMax !== 0 ? Math.abs(dataMax) * 0.05 : 1);
            const minV    = dataMin - padding;
            const maxV    = dataMax + padding;
            const rangeV  = (maxV - minV) || 1;   // guard: nunca 0

            const totalN = histSerie.length + proySerie.length;
            const xS = function(i) { return PL + (totalN > 1 ? (i / (totalN - 1)) * plotW : plotW / 2); };
            const yS = function(v) {
              var n = Number(v);
              if (!isFinite(n) || isNaN(n)) return PT + plotH / 2;   // fallback al centro
              return PT + plotH - ((n - minV) / rangeV) * plotH;
            };

            const hN = histSerie.length;

            // ── Puntos para polyline (formato "x,y x,y ...") ──────────────
            const histPoints = histSerie.map(function(h, i) {
              return xS(i).toFixed(1) + "," + yS(h.saldo_historico_mdp).toFixed(1);
            }).join(" ");

            const proyPoints = proySerie.map(function(p, i) {
              return xS(hN + i).toFixed(1) + "," + yS(p.saldo_proyectado_mdp).toFixed(1);
            }).join(" ");

            // Línea de conexión (último hist → primer proy)
            const connPoints = hN > 0 && proySerie.length > 0
              ? xS(hN - 1).toFixed(1) + "," + yS(histSerie[hN - 1].saldo_historico_mdp).toFixed(1) +
                " " + xS(hN).toFixed(1) + "," + yS(proySerie[0].saldo_proyectado_mdp).toFixed(1)
              : "";

            // Banda de confianza como polygon
            const bandTopPts = proySerie.map(function(p, i) {
              return xS(hN + i).toFixed(1) + "," + yS(p.banda_superior_mdp).toFixed(1);
            }).join(" ");
            const bandBotPts = proySerie.slice().reverse().map(function(p, i) {
              const origIdx = proySerie.length - 1 - i;
              return xS(hN + origIdx).toFixed(1) + "," + yS(p.banda_inferior_mdp).toFixed(1);
            }).join(" ");
            const bandPolygon = bandTopPts + " " + bandBotPts;

            // Etiquetas eje X
            const step = Math.max(1, Math.floor(totalN / 9));
            const allPeriods = histSerie.map(function(h) { return h.periodo; })
              .concat(proySerie.map(function(p) { return p.periodo; }));
            const xLabelIdxs = [];
            for (var li = 0; li < totalN; li++) {
              if (li % step === 0 || li === totalN - 1) xLabelIdxs.push(li);
            }

            // Etiquetas eje Y
            const midV = (minV + maxV) / 2;
            const fmtV = function(v) {
              if (Math.abs(v) >= 1000000) return (v / 1000000).toFixed(1) + "M";
              if (Math.abs(v) >= 1000) return (v / 1000).toFixed(0) + "K";
              return v.toFixed(0);
            };

            // Línea separadora histórico/proyección
            const sepX = hN > 0 && proySerie.length > 0 ? xS(hN - 0.5) : null;

            return (
              <div style={{ marginBottom: 20 }}>
                {/* Selector de serie */}
                {seriesKeys.length > 1 && (
                  <div style={{ display: "flex", gap: 5, flexWrap: "wrap", marginBottom: 10, marginTop: 4 }}>
                    <span style={{ fontSize: 13, color: C.sub, fontFamily: "monospace", alignSelf: "center" }}>SERIE</span>
                    {seriesKeys.map(function(k) {
                      const s = seriesMap[k];
                      const prodShort = s.producto.includes("Nivel 4") ? "Nivel 4" : "Plazo";
                      return (
                        <button key={k} onClick={function() { setFcSerie(k); }} style={{
                          padding: "3px 10px", borderRadius: 5, cursor: "pointer", fontSize: 13,
                          fontFamily: "monospace",
                          border: activeSerie === k ? "1px solid #60a5fa88" : "1px solid " + C.border,
                          background: activeSerie === k ? "#60a5fa22" : C.card,
                          color: activeSerie === k ? "#60a5fa" : C.muted,
                          fontWeight: activeSerie === k ? 700 : 400,
                        }}>{s.entidad} / {prodShort}</button>
                      );
                    })}
                  </div>
                )}

                {/* Título de la serie */}
                <div style={{ fontSize: 14, color: C.sub, fontFamily: "monospace", marginBottom: 6 }}>
                  <span style={{ color: C.text, fontWeight: 600 }}>{serEntidad}</span>
                  {" · "}
                  <span>{serProducto.includes("Nivel 4") ? "Cuentas Nivel 4" : "Depósitos a Plazo"}</span>
                  {" · "}
                  <span style={{ color: C.muted }}>{histSerie.length}m histórico + {proySerie.length}m proyectados</span>
                </div>

                {/* SVG Chart — usa polyline en lugar de path para máxima compatibilidad */}
                <div style={{ background: C.surface, borderRadius: 8, border: "1px solid " + C.border, padding: "10px 4px 4px", overflow: "hidden" }}>
                  <svg viewBox={"0 0 " + W + " " + H} style={{ width: "100%", display: "block" }} xmlns="http://www.w3.org/2000/svg">

                    {/* Guías horizontales + etiquetas Y */}
                    {[minV, midV, maxV].map(function(v, gi) {
                      const gy = yS(v);
                      return (
                        <g key={gi}>
                          <line x1={PL} y1={gy} x2={W - PR} y2={gy} stroke="#1e2d3d" strokeWidth="1" />
                          <text x={PL - 5} y={gy + 4} textAnchor="end" fontSize="10" fill="#4a6278" fontFamily="monospace">{fmtV(v)}</text>
                        </g>
                      );
                    })}

                    {/* Banda de confianza (polygon) */}
                    {bandPolygon && (
                      <polygon points={bandPolygon} fill="#60a5fa" fillOpacity="0.12" stroke="none" />
                    )}

                    {/* Separador histórico / proyección */}
                    {sepX !== null && (
                      <line x1={sepX} y1={PT} x2={sepX} y2={PT + plotH} stroke="#60a5fa" strokeOpacity="0.35" strokeWidth="1" strokeDasharray="3,3" />
                    )}

                    {/* Línea histórica (polyline) */}
                    {histPoints && (
                      <polyline points={histPoints} fill="none" stroke="#7a9ab5" strokeWidth="1.8" strokeLinejoin="round" strokeLinecap="round" />
                    )}

                    {/* Línea de conexión (polyline dashed) */}
                    {connPoints && (
                      <polyline points={connPoints} fill="none" stroke="#60a5fa" strokeWidth="1.5" strokeDasharray="4,3" />
                    )}

                    {/* Línea de proyección (polyline) */}
                    {proyPoints && (
                      <polyline points={proyPoints} fill="none" stroke="#60a5fa" strokeWidth="2.5" strokeLinejoin="round" strokeLinecap="round" />
                    )}

                    {/* Etiquetas eje X */}
                    {xLabelIdxs.map(function(li) {
                      const per = String(allPeriods[li] || "");
                      return (
                        <text key={li} x={xS(li)} y={PT + plotH + 16} textAnchor="middle" fontSize="10.5" fill="#4a6278" fontFamily="monospace">
                          {per.slice(0, 4)}/{per.slice(4, 6)}
                        </text>
                      );
                    })}

                    {/* Leyenda */}
                    <g transform={"translate(" + (W - 175) + "," + (PT + 2) + ")"}>
                      <line x1="0" y1="6" x2="16" y2="6" stroke="#7a9ab5" strokeWidth="1.8" />
                      <text x="20" y="10" fontSize="11" fill="#7a9ab5" fontFamily="monospace">Histórico</text>
                      <rect x="0" y="17" width="16" height="8" fill="#60a5fa" fillOpacity="0.15" />
                      <line x1="0" y1="21" x2="16" y2="21" stroke="#60a5fa" strokeWidth="2.5" />
                      <text x="20" y="25" fontSize="11" fill="#60a5fa" fontFamily="monospace">Proyección (90%)</text>
                    </g>

                    {/* Etiqueta unidad */}
                    <text x={PL} y={PT - 8} fontSize="10" fill="#4a6278" fontFamily="monospace">MDP</text>
                  </svg>
                </div>
              </div>
            );
          }())}

          {/* Tabla de proyecciones */}
          {resultadoFc.proyecciones && resultadoFc.proyecciones.length > 0 && (
            <div style={{ overflowX: "auto", marginTop: 16 }}>
              <div style={{ fontSize: 13, color: C.sub, fontFamily: "monospace", letterSpacing: 0.7, marginBottom: 8, textTransform: "uppercase" }}>
                Detalle · {resultadoFc.n_series} series × {fcHorizonte} meses
              </div>
              <table style={{ width: "100%", borderCollapse: "collapse", fontSize: 14, fontFamily: "monospace" }}>
                <thead>
                  <tr style={{ background: C.surface, borderBottom: "1px solid " + C.border }}>
                    {["Entidad", "Producto", "Periodo", "Saldo proy. MDP", "Banda inf. MDP", "Banda sup. MDP"].map(function(h, i) {
                      return (
                        <th key={i} style={{
                          padding: "7px 10px", textAlign: i >= 3 ? "right" : "left",
                          color: C.sub, fontWeight: 600, fontSize: 12,
                          letterSpacing: 0.8, textTransform: "uppercase", whiteSpace: "nowrap",
                        }}>{h}</th>
                      );
                    })}
                  </tr>
                </thead>
                <tbody>
                  {resultadoFc.proyecciones.map(function(p, i) {
                    return (
                      <tr key={i} style={{ borderBottom: "1px solid " + C.border, background: i % 2 === 0 ? "transparent" : C.card + "66" }}>
                        <td style={{ padding: "6px 10px", color: C.text, whiteSpace: "nowrap" }}>{p.nombre_entidad}</td>
                        <td style={{ padding: "6px 10px", color: C.body, whiteSpace: "nowrap" }}>
                          {p.descripcion_producto && p.descripcion_producto.includes("Nivel 4") ? "Nivel 4" : "Depésitos a Plazo"}
                        </td>
                        <td style={{ padding: "6px 10px", color: "#60a5fa", fontWeight: 600 }}>
                          {String(p.periodo).slice(0, 4)}/{String(p.periodo).slice(4, 6)}
                        </td>
                        <td style={{ padding: "6px 10px", color: C.text, textAlign: "right", fontWeight: 600 }}>
                          {p.saldo_proyectado_mdp.toLocaleString("es-MX", { maximumFractionDigits: 1 })}
                        </td>
                        <td style={{ padding: "6px 10px", color: C.muted, textAlign: "right" }}>
                          {p.banda_inferior_mdp.toLocaleString("es-MX", { maximumFractionDigits: 1 })}
                        </td>
                        <td style={{ padding: "6px 10px", color: C.muted, textAlign: "right" }}>
                          {p.banda_superior_mdp.toLocaleString("es-MX", { maximumFractionDigits: 1 })}
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
          )}

          {/* Nota metodológica */}
          {resultadoFc.metodologia && (
            <div style={{
              marginTop: 20, padding: "10px 14px",
              background: C.surface, border: "1px solid " + C.border,
              borderRadius: 6, fontSize: 13, color: C.muted, lineHeight: 1.7,
            }}>
              <span style={{ color: C.sub, letterSpacing: 0.5 }}>METODOLOGÍA · </span>
              {resultadoFc.metodologia}
            </div>
          )}
        </div>
      )}

      {/* Estado vacío inicial forecast */}
      {!resultadoFc && !loadingFc && !errorFc && (
        <div style={{ flex: 1, display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", color: C.sub, gap: 10 }}>
          <div style={{ fontSize: 32, opacity: 0.25 }}>◈</div>
          <div style={{ fontSize: 16, fontFamily: "monospace", color: C.text }}>Configura los parámetros y presiona Proyectar</div>
          <div style={{ fontSize: 15, color: C.sub, maxWidth: 440, textAlign: "center", lineHeight: 1.6 }}>
            Modelo BQML ARIMA_PLUS entrenado con datos históricos mensuales de la R2421.
            Cubre las 11 principales entidades (87.6% del sistema) en vista sistémica.
            Horizonte de 1 a 12 meses con bandas de confianza al 90%.
          </div>
          <div style={{ fontSize: 14, color: C.muted, maxWidth: 440, textAlign: "center", lineHeight: 1.6, marginTop: 4, padding: "8px 14px", background: C.card, borderRadius: 6, border: "1px solid " + C.border }}>
            <span style={{ color: C.sub }}>Criterios de cobertura: </span>
            Top 12 entidades por saldo sistémico; se excluye Citi México por historia &lt;24 meses en R2421.
            Productos: Nivel 4 + Depósitos a Plazo. Otros productos excluidos por inestabilidad de series.
          </div>
        </div>
      )}

      </>}

    </div>
  );
}
